// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public//images/option_home_img/markert_summarybg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public//images/option_home_img/option_highlightbg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public//images//option_home_img//option_highlightbg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
    max-width: 100%;
}

ul {
    padding: 0px;
    margin: 0px;
    list-style: none;
}

a {
    text-decoration: none;
}

.container,
.container-lg,
.container-md,
.container-sm,
.container-xl,
.container-xxl {
    max-width: 1380px;
    padding: 0px 20px;
}

body {
    background-color: #181A20;
}

.usd_future_dashboard {
    width: 100%;
    display: block;
    background-color: #111114;
    height: 100%;
    color: #fff;
}

.option_datatable_bl #buy_orders .table_info_data {
    padding: 0px 10px;
}

.option_datatable_bl #sell_orders .table_info_data {
    padding: 0px 10px;
}

.option_datatable_bl #trades .table_info_data {
    padding: 0px 10px;
}

.top_bar_usd_future {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 10px;
    margin-top: 0px;
    /* border-bottom: 4px solid #222222; */
    /* border-top: 1px solid #222222; */
    align-items: center;
    background-color: #181A20;
}

.usd_left_pr {
    display: flex;
    align-items: center;
    gap: 24px;
}

.price_top_right {
    font-size: 16px;
    color: #01BC8D;
    font-weight: 500;
    line-height: 19px;
    display: flex;
    flex-direction: column;
    white-space: nowrap;
}

.price_top_right span {
    font-size: 14px;
    font-weight: 400;
}

.space_gap_0.dashboard_mid_s .dashboard_summary_lft {
    width: 65%;
}

.order_trade_s .trade_movers_tb .table-responsive {
    max-height: 500px;
}

.space_gap_0.dashboard_mid_s .relative_select_right {
    max-height: 640px;
}

.btcusd__currency span {
    min-width: 18px;
    height: 18px;
    border: 1px solid #434343;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50px;
}

.btcusd__currency {
    min-width: 130px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
}

.top_future_left_s {
    display: flex;
    align-items: center;
    gap: 18px;
}

.top_future_left_s ul {
    display: flex;
    align-items: center;
    gap: 18px;
    padding: 0px;
    margin: 0px;
    list-style: none;
}

.top_future_left_s ul li span {
    color: #6C6C6C;
}

.top_future_left_s ul li {
    font-size: 13px;
}

.top_future_left_s ul li span.yellow {
    color: hsl(33, 97%, 58%);
}

.top_future_right_s {
    text-align: right;
}


.market_highlight_section .table-responsive {
    min-height: 100px;
    max-height: 220px;
}

.top_future_right_s ul {
    padding: 0px;
    margin: 0px;
    list-style: none;
    display: flex;
    align-items: center;
    gap: 16px;
}

.top_future_right_s ul li {
    color: #f3f3f39c;
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    padding-right: 12px;
    border-right: 1px solid #222222;
    line-height: 10px;
    border-radius: 2px;
    padding: 5px 8px;
    background-color: #22242c;
    min-width: 90px;
    border: 1px solid #22242c;
    font-size: 12px;
}

.top_future_right_s ul li button {
    background: none;
    border: none;
    padding: 0px;
}

.top_future_right_s ul li:last-child {
    border: none;
}

.dashboard_mid_s {
    width: 100%;
    display: flex;
}

.dashboard_mid_s .dashboard_summary_lft {
    max-width: 1270px;
}

.classic_favorites_bl .col-sm-2 .order_trade_s {
    width: 100%;
    height: 100%;
}

.top_hd_s {
    width: 16%;
    padding: 0px;
    background: #181A20;
    border: none;
    border-radius: 0px;
    overflow: hidden;
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
    position: relative;
    color: #fffffff2;
}

.order_book_info {
    width: 100%;
}

.toggle_dotted {
    width: 10px;
    cursor: pointer;
}

.orderbook_lightbox .form-check {
    font-size: 14px;
}

.orderbook_lightbox {
    color: #fff;
}

.orderbook_lightbox {
    width: 250px;
    display: none;
    position: absolute;
    top: 30px;
    right: 0px;
    z-index: 666;
    background-color: #3c3c3c;
    padding: 24px;
    border-radius: 10px;
    border: 1px solid #494949;
}

.orderbook_lightbox.active {
    display: block;
}

.orderbook_lightbox h6 {
    font-size: 13px;
    font-weight: 400;
    padding-bottom: 10px;
}

.orderbook_lightbox .d-flex.gap-3 {
    flex-direction: column;
}

.top_hd_s h2 {
    font-size: 15px;
    margin: 0px;
    background-color: #1B1B1B;
    padding: 6px 15px;
    font-weight: 400;
}

.order_top_table_grid {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    padding: 10px 10px 0px;
}

.order_top_table_grid ul.togglebtn {
    display: flex;
    gap: 12px;
}

.order_top_table_grid ul.togglebtn li {
    border: 1px solid #3B3B3B;
    border-radius: 3px;
    display: flex;
    padding: 1px 3px;
    align-items: center;
    justify-content: center;
}

.order_right_toggle ul {
    display: flex;
    gap: 15px;
}

.order_right_toggle ul li {
    font-size: 12px;
    color: #787878;
}

.table_info_data table {
    font-size: 12px;
    width: 100%;
    /* height: 0% !important; */
}

.table_info_data table tr th {
    padding: 3px 10px;
    color: #636363;
    font-weight: 400;
}

.table_info_data table tr td {
    padding: 3px 10px;
    color: #e9e9e9;
}

.table_info_data table tr td.danger {
    color: #F65454;
}

.table_info_data table tr.totaltb td.danger {
    font-size: 18px;
}

.table_info_data table tr .subtotal {
    text-align: center;
    color: #999;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.table_info_data table tr td.sucess {
    color: #01BC8D;
}

.table_info_data table tr .subtotal span {
    border: 2px solid #3B3B3B;
    border-radius: 3px;
    margin-right: 5px;
    font-weight: 700;
    color: #666666;
    font-size: 10px;
    padding: 1px 2px;
    /* align-items: center; */
    justify-content: center;
}

.trade_movers_tb ul.nav-tabs {
    background-color: #181A20;
    border-radius: 0px;
    border-color: #ffffff12;
    padding-top: 4px;
}

.trade_movers_tb button.nav-link.active {
    background-color: transparent;
    border: none;
    border-bottom: 2px solid #fff !important;
    color: #fff;
}

.trade_movers_tb button.nav-link {
    font-size: 14px;
    margin: 0px;
    color: #949AA4;
    border: none;
    border-bottom: 2px solid #ffffff00;
    padding: 6px 15px;
    font-weight: 400;
}

.trade_movers_tb button.nav-link:hover {
    border: none;
    outline: none;
}

.relative_select_right {
    background-color: #22222200;
}

.flex_right_option {
    display: flex;
    gap: 5px;
    height: 85%;
}

.flex_right_option .order_trade_s {
    width: 40%;
}

.flex_right_option .relative_select_right {
    width: 60%;
}

.data_option_calls {
    border: 1px solid #ffffff12;
    border-radius: 10px;
}

.selected_product_info {
    width: 100%;
    display: flex;
    border-bottom: 1px solid #ffffff12;
    margin-bottom: 20px;
    padding-bottom: 10px;
    flex-direction: column;
    gap: 15px;
}



.product_data_info table tr td {
    font-size: 11px;
    color: #8e9298;
    text-align: right;
    padding: 0px;
}

.product_data_info table tr td span {
    display: block;
    font-size: 12px;
    color: #fff;
}

.product_data_info table tr {
    display: flex;
    justify-content: space-between;
}

.product_flex {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.product_name {
    display: flex;
    align-items: center;
    gap: 5px;
    line-height: 15px;
    font-size: 14px;
    color: #d5d5d5;
}

.product_name svg {
    width: 18px;
    height: 16px;
}

.product_name svg path {
    fill: #f3bb2b;
}

.product_header button {
    background-color: transparent;
    border: none;
    padding: 0px;
    display: flex;
    color: #f0f0f0;
    font-size: 12px;
    font-weight: 200;
    gap: 7px;
    align-items: center;
}

.product_header button span {
    color: #acacac;
}

.product_header button path {
    fill: #eeeeee;
}

.product_header.ms-auto {
    display: flex;
    gap: 24px;
    align-items: center;
}



.top_cross_dashboard {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 0px;
}

.top_cross_dashboard ul {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    justify-content: space-between;
}

.top_cross_dashboard ul li {
    width: 100%;
    display: block;
}

.top_cross_dashboard ul li a {
    background-color: #2B313C;
    padding: 5px 12px 6px;
    color: #d3d3d3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    list-style: none;
    text-decoration: none;
    font-size: 13px;
    border: none;
    border-radius: 5px;

}

.copy_icon {
    max-width: 15px;
}

.spot_future_ {
    width: 100%;
    background-color: #121212;
    padding: 0px 15px;
    margin-top: 7px;
}

.spot_future_ ul {
    display: flex;
    gap: 10px;
}

.spot_future_ ul li a {
    color: #999;
    font-size: 13px;
    text-decoration: none;
    border-bottom: 1px solid #121212;
    display: block;
    padding: 10px 4px;
    font-weight: 500;
}

.spot_future_ ul li span {
    color: #01BC8D;
    background-color: #102621;
    padding: 4px;
    border-radius: 5px;
}

.spot_future_ ul li.active a {
    color: #fff;
    border-bottom: 1px solid #01BC8D;
}

.leverage_bl {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 0px 0px;
    gap: 12px;
    /* background-color: #121212;
    border-top: 10px solid #222222;
    border-bottom: 5px solid #222222; */
}

.leverage_bl>div {
    background-color: #2B313C;
    border-radius: 4px;
    width: 100%;
    gap: 14px;
    font-size: 12px;
    font-weight: 500;
    padding: 8px 20px;
    align-items: center;
    display: flex;
    justify-content: center;
}

.leverage_bl .rage_txt {
    color: #5F5F5F;
}

.leverage_bl div.plustext {
    width: auto;
    padding: 8px 6px;
}

.market_spot_form {
    width: 100%;
}

.market_spot_form .nav-tabs {
    background-color: #121212;
    border: none;
}

.market_spot_form .nav-tabs li button {
    border: none;
    background-color: transparent !important;
    color: #6C6C6C !important;
    font-size: 12px;
    font-weight: 500;
}

.market_spot_form .nav-tabs li button.active {
    color: #01bc8d !important;
}

.market_spot_form .nav-tabs li a {
    border: none;
    background-color: transparent !important;
    color: #6C6C6C !important;
    font-size: 13px;
    font-weight: 500;
}

.market_spot_form .nav-tabs li a.active {
    color: #fff !important;
}

.market_spot_form .nav-tabs li .dropdown-menu li a {
    color: #000 !important;
}

form.price_info {
    min-height: 100px;
    max-height: 410px;
    width: 100%;
    padding: 0px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.price_inputbl {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.price_inputbl label {
    font-size: 12px;
    color: #F2F4F6;
    font-weight: 400;
}

.relative_select_right .price_select_option {
    background-color: #2B313C;
    border-color: #2d303a00;
    border-radius: 4px;
    padding: 8px;
    display: flex;
    justify-content: space-between;
}

.price_inputbl .inputtype {
    border: none;
    background-color: transparent;
    padding-left: 2px;
    color: #fff;
    font-weight: 400;
}

.price_inputbl select {
    border: none;
    background-color: transparent;
    color: #999;
    font-size: 12px;
}

.price_inputbl label span {
    color: #ababab;
}

.price_inputbl ul {
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: space-between;
}

.price_inputbl ul li button {
    font-size: 12px;
    border-radius: 0px;
    border: 1px solid #2d303a00 !important;
    font-weight: 200;
    width: 100%;
    position: relative;
    text-align: center;
    background-color: transparent;
    color: #ababab;
    padding: 0px !important;
}

.price_inputbl ul li button:before {
    width: 7px;
    background-color: #393F4F;
    height: 7px;
    position: absolute;
    content: "";
    border-radius: 50px;
    border: 1px solid #393F4F;
    left: 0px;
    top: -15px;
}

.price_inputbl ul li.active button:before {
    width: 14px;
    background-color: #393f4f;
    height: 14px;
    border: 2px solid #F2F4F6;
    top: -19px;
}

.price_inputbl ul li:last-child button:before {
    left: inherit;
    right: 0px;
}

.avail_total_usd {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
}

.tpsl_reduce {
    font-size: 13px;
    color: #6C6C6C;
}

.price_inputbl.mt-2 {
    padding-bottom: 20px !important;
}

ul.btnlimit {
    display: flex;
    margin: 15px 0px;
    gap: 12px;
}

ul.btnlimit li button {
    width: 100%;
    padding: 4px 0px;
    border: none;
    font-size: 13px;
    background: none;
    color: #fff;
    font-weight: 200;
}

ul.btnlimit li button.active {
    color: #f3bb2b;
}

.buysell_btn button {
    width: 100%;
    padding: 6px 32px;
    background-color: #5EBA89;
    border: none;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    border-radius: 50px;
}

.buysell_btn button.sellbtn {
    background-color: #ed5765;
}

.costbtc_total h5 {
    font-size: 12px;
    color: #949AA4;
    margin: 0px;
}

.classic_grid_dashboard_bl.d-flex.option_datatable_bl .d-flex.topnav_selected {
    padding: 16px 0px 0px;
}

.costbtc_total h5 span {
    color: #fff;
}

.price_inputbl .inputtype:focus-visible {
    outline: none;
}

.trade_account_summary_assets {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.trade_account_summary_assets {
    width: 100%;
    display: flex;
    justify-content: space-between;
    background-color: #121212;
    margin-top: 4px;
}

.position_order .position_list {
    border-bottom: 1px solid #454C59;
    gap: 15px;
    display: flex;
}

.position_order .position_list li button {
    border-radius: 0px;
    border: none;
    background-color: transparent;
    font-size: 13px;
    white-space: nowrap;
    font-weight: 400;
    padding: 5px 10px;
    color: #9f9f9f;
}

.trade_summary_table_lft .nav-tabs {
    border-bottom: 1px solid #282828;
    gap: 15px;
}

.position_order .cnt_table {
    display: none;
}

.position_order .cnt_table.active {
    display: flex;
}

.trade_summary_table_lft .nav-tabs li button {
    border-radius: 0px;
    border: none;
    background-color: transparent;
    font-size: 13px;
    font-weight: 400;
    padding: 5px 10px;
    color: #9f9f9f;
}


.trade_summary_table_lft .nav-item.active button {
    color: #fff;
}

.trade_summary_table_lft .nav-tabs li button.active {
    color: #fff;
}

.trade_summary_table_lft .tab-content {
    min-height: 260px;
    display: flex;
    align-items: start;
    justify-content: center;
}

.trade_summary_table_lft .tab-content h4 {
    font-size: 14px;
    margin: 0px;
}

.notfound_vector p {
    color: #fff !important;
}


.assets_right {
    width: 23.46%;
    background-color: #181A20;
    /* padding: 7px; */
}


.assets_right h2 {
    font-size: 14px;
    margin-left: 0px;
    padding: 5px 0px;
}

.no-data p {
    font-size: 14px;
    padding-top: 10px;
}

.trade_summary_table_lft tr th .num-div .num-select {
    padding: 0px 10px !important;
}

.asset_total_value {
    padding: 5px 0px;
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.asset_total_value h5 {
    color: #fff;
    font-weight: 500;
}

.asset_total_value div {
    font-size: 12px;
}

.asset_total_value div h6 {
    font-size: 12px;
    margin: 0px;
    color: #767676;
}

.danger {
    color: #F65454 !important;
}

span.green {
    display: flex;
    align-items: center;
    gap: 5px;
    color: #00B47D;
}

.buy_transferbtn {
    gap: 8px;
    margin: 10px 0px 30px;
}

.buy_transferbtn button {
    font-size: 12px;
    background-color: #2A2A2A;
    color: #fff;
    border: none;
    padding: 7px 18px;
    width: 100%;
    border-radius: 50px;
}

.top_future_right_s ul li img {
    min-width: 20px;
}

.search_form {
    width: 100%;
    border: 1px solid #c7c7c7;
    padding: 5px;
    border-radius: 5px;
    gap: 10px;
}

.search_form input {
    border: none;
    width: 100%;
}

.search_form input:focus-visible {
    outline: none;
}

.bn-tabs_favorites_bl button.nav-link {
    border: none;
    padding: 0px;
    font-size: 14px;
    font-weight: 500;
    color: #626262;
    line-height: 22px;
}

.bn-tabs_favorites_bl li a {
    border: none;
    padding: 0px;
    font-size: 14px;
    font-weight: 500;
    color: #626262;
    line-height: 22px;
}

.bn-tabs_favorites_bl li a:focus {
    border: none;
}

.bn-tabs_favorites_bl li a:hover {
    border: none;
}

.bn-tabs_favorites_bl li a.active {
    border: none;
}

.bn-tabs_favorites_bl ul {
    border: none;
    margin: 10px 0px;
}

.modal.currency_popup_s .modal-dialog {
    max-width: 620px;
}

.currency_data_list {
    color: #181818;
}

.currency_data_list table {
    width: 100%;
}

.currency_data_list table tr td {
    font-size: 14px;
    padding: 8px 0px;
}

.currency_data_list table tr th {
    font-size: 14px;
    padding: 5px 0px;
    font-weight: 400;
}

.currency_data_list table h6 {
    margin: 0px;
    font-size: 14px;
}

.currency_data_list table p {
    margin: 0px;
}

.cnt_first_t {
    display: flex;
    gap: 8px;
    align-items: center;
}

.cnt_first_t .icon_currency {
    display: flex;
    gap: 5px;
    align-items: center;
}

.cnt_first_t .icon_currency img {
    width: 22px;
}

.cnt_first_t .icon_currency svg {
    width: 20px;
    height: auto;
}

.no_data_found {
    width: 100%;
    display: block;
    text-align: center;
    padding: 70px 0px;
    color: #000;
}

.no_data_found svg {
    width: 100px;
}

.no_data_found svg path {
    fill: #000;
}

.top_future_left_s ul li.dropdown ul.dropdown-menu {
    display: none;
}

.top_future_left_s ul li.dropdown ul.dropdown-menu.dropdown-menu.show {
    display: flex;
    flex-direction: column;
    gap: 9px;
    align-items: normal;
    padding: 10px;
}


.top_tabs_center {
    display: flex;
    justify-content: space-between;
    position: relative;
    color: #222;
    font-size: 13px;
    font-weight: 500;
    align-items: center;
}

.classic_option_top {
    width: 100%;
    display: flex;
    gap: 12px;
    align-items: center;
    padding: 0px;
}

.leftbar_classic {
    width: auto;
}

.leftbar_classic ul {
    display: flex;
    align-items: center;
    gap: 7px;
}

.leftbar_classic ul li a {
    width: 40px;
    height: 46px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #121212;
}

.leftbar_classic ul li a:hover {
    background-color: #2A2310;
}

.leftbar_classic ul li rect {
    fill: #fff;
}

.leftbar_classic ul li.active a {
    background-color: #2A2310;
}

.leftbar_classic ul li.active rect {
    fill: #FEBA00;
}

.classic_usd_right {
    width: 100%;
}

.classic_usd_right ul {
    display: flex;
    gap: 18px;
}

.classic_option_top .classic_usd_right ul li {
    padding: 0px;
}

.classic_option_top .classic_usd_right ul li.active button {
    border: 1px solid #f3bb2b;
}

.classic_usd_right ul li button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #22242c;
    border: 1px solid #22242c;
    font-size: 13px;
    color: #a2a2a2;
    min-width: 105px;
    gap: 5px;
    padding: 4px 10px;
    border-radius: 2px;
}

.succes {
    color: #01BC8D !important;
}

.classic_usd_right .cnt_top_cl {
    text-align: left;
}

.classic_usd_right ul li:first-child {
    background-color: #444444;
    color: #fff;
}

.classic_usd_right ul li .cnt_top_cl h6 {
    margin: 0px;
    font-size: 12px;
}

.classic_usd_right ul li .cnt_top_cl p span {
    padding-left: 20px;
}

.classic_usd_right ul li .cnt_top_cl p {
    margin: 0px;
}

.classic_usd_right ul li img {
    max-width: 24px;
}

.classic_grid_dashboard_left {
    width: 100%;
}

.classic_favorites_bl {
    width: 100%;
    border-top: 1px solid #f3f3f329;
    margin: 0px;
    padding-top: 15px;
}

.classic_favorites_bl .trade_movers_tb .table_info_data {
    height: auto;
}

.classic_favorites_bl .order_trade_s .table-trade {
    padding: 0px 10px;
}

.classic_favorites_bl .order_trade_s .table_info_data table tr th {
    font-size: 11px;
}

.classic_favorites_bl .table_info_data table tr.totaltb td.danger {
    font-size: 12px;
}


.classic_favorites_bl .order_trade_s .table_info_data table tr td {
    font-size: 12px;
    padding: 3px 0px !important;
}

.topnav_selected .date_tbl {
    border: none;
    display: flex;
    gap: 15px;
    overflow: auto;
    padding-bottom: 5px;
}

.topnav_selected .date_tbl .nav-link {
    border: none;
    color: #f3f3f39c;
    border-radius: 2px;
    padding: 5px 10px;
    background-color: #22242c;
    min-width: 80px;
    border: 1px solid #22242c;
    font-size: 12px;
    white-space: nowrap;
}

.topnav_selected .date_tbl .nav-link:hover {
    /* border: none; */
    /* border: 1px solid #f3bb2b; */
    background-color: #2d303a;
}

.topnav_selected .date_tbl .nav-link.active {
    background-color: #22242c;
    color: #fff;
    border: 1px solid #f3bb2b;
}

.d-flex.topnav_selected {
    padding: 15px 0px 0px;
    justify-content: space-between;
    align-items: center;
}

.right_top_r {
    display: flex;
    gap: 20px;
    padding-right: 32px;
    position: relative;
}

.right_top_r .form-check {
    font-size: 13px;
    color: #f3f3f39c;
    margin: 0px;
}

.right_top_r .orderbook_lightbox form .d-flex {
    flex-direction: column;
}

.displayed_reset {
    padding: 13px 0px;
}

.displayed_reset h6 {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.displayed_reset h6 span {
    color: #f0b90b;
}

.decimal_text {
    font-size: 12px;
    color: #b3b3b3;
    justify-content: space-between;
    align-items: center;
}

.decimal_text p {
    margin: 0px;
    font-size: 15px;
}

.classic_favorites_bl .col-sm-9 .tab-content {
    border-top: 1px solid #f3f3f329;
    padding: 0px !important;
}

.top_barcalls_put_cnt {
    border-bottom: 1px solid #f3f3f329;
}

.top_barcalls_put_cnt ul {
    display: flex;
    align-items: center;
    gap: 40px;
    padding: 15px 0px;
    justify-content: space-evenly;
}

.top_barcalls_put_cnt ul li {
    font-size: 13px;
    color: #c5c5c5;
}

.top_barcalls_put_cnt ul li strong {
    color: #fff;
}


.option_datatable_bl .data_option_calls table tr th {
    font-size: 12px;
    font-weight: 400;
    color: #999;
    padding: 8px 10px !important;
    border-bottom: 1px solid #f3f3f329;
    background-color: #111114 !important;
}

.data_option_calls table tr {
    background-color: #030303;
}

.data_option_calls table tr:hover {
    background: rgb(58 62 73 / 6%);
    cursor: pointer;
}



.data_option_calls table tr td {

    font-size: 12px;
    font-weight: 400;
    height: 50px;
    color: #ffffff;
    padding: 8px 10px;
    border-bottom: 1px solid #f3f3f329;
}

.data_option_calls table tr td.text-succes {
    color: #01BC8D;
}

.data_option_calls table tr td.danger {
    color: #F65454;
}

.top_table_data .mid_data tr td {
    height: 50px;
    color: #fff;
    font-weight: 500;
    background-color: #111114;
}

.classic_favorites_bl .order_trade_s .table_info_data table tr td.right_alien {
    text-align: right;
    padding-right: 5px !important;
}

.classic_favorites_bl .order_trade_s .table_info_data table tr th.right_alien {
    text-align: right;
}

.data_option_calls table {
    width: 100%;
}

.recent_tables_outer {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.tables_calls {
    width: 100%;
}

.tables_puts {
    width: 100%;
}

.recent_trades_options table {
    width: 100%;
    font-size: 13px;
}

.recent_trades_options table tr th {
    font-size: 12px;
    font-weight: 400;
    color: #999;
    padding: 15px;
    border-bottom: 1px solid #494949;
}

.recent_trades_options table tr td {
    font-weight: 400;
    padding: 15px;
    border-bottom: 1px solid #494949;
}

.recent_trades_options {
    width: 100%;
    padding-top: 20px;
}

.recent_trades_options h6 {
    font-size: 12px;
    color: #999;
    padding: 0px 15px;
}

.classic_favorites_bl .trade_summary_table_lft .nav-tabs li button {
    padding: 10px;
}

.classic_favorites_bl .trade_summary_table_lft {
    width: 100%;
    overflow: hidden;
}

.hide_underlying_s {
    display: flex;
    justify-content: end;
    padding-right: 30px;
    gap: 5px;
    align-items: center;
    font-size: 13px;
    color: #999;
}

.trade_summary_table_lft .row {
    align-items: center;
}

.option_account_right {
    width: 100%;
    border-left: 1px solid #f3f3f32b;
    height: 100%;
}

.trade_option_bl {
    width: 100%;
    margin: 0px;
    padding: 32px;
    background-color: #222222;
    text-align: center;
}

.classic_favorites_bl>.col-sm-9 {
    padding: 0px;
}

.classic_favorites_bl>.col-sm-3 {
    padding: 0px;
}

.option_account_right h2 {
    font-size: 15px;
}

.trade_option_bl p {
    font-size: 12px;
    margin: 0px;
    max-width: 220px;
    margin: 5px auto;
}

.data_option_calls.mobile_data_table {
    display: none;
}

.option_block {
    width: 100%;
    border-radius: 4px;
    cursor: pointer;
    padding: 16px;
    background-color: #454545;
}

.option_block span {
    font-size: 12px;
}

.youtube_icon {
    max-width: 50px;
    margin: 0 auto;
    margin-top: 13px;
}

.trade_option_bl .row {
    padding-top: 20px;
}

.account_block_s {
    width: 100%;
    padding: 24px 32px;
}

.account_tabs_info {
    width: 100%;
    display: block;
    border-bottom: 1px solid #f3f3f32b;
    padding-bottom: 20px;
    margin-top: 20px;
}

.account_tabs_info h5 {
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.account_tabs_info ul {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 12px;
    font-size: 12px;
}

.account_tabs_info .cnt_ac.hide {
    display: none;
}

.account_tabs_info ul a {
    color: #a3a3a3;
    font-size: 13px;
}


.video_popup .modal-dialog {
    max-width: 750px;
}

.video_popup .modal-content {
    background-color: #242526;
    border-radius: 24px;
    padding: 5px 12px;
}

.video_popup .btn-close {
    border-radius: 50px !important;
    background-color: #fff;
    opacity: 1;
}

.video_popup .modal-header {
    border: none;
}

.easy_option_dashboard {
    background-color: #121212;
}

.easy_mode_back {
    width: 100%;
    padding-top: 18px;
}

.easy_mode_back a {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #d9d9d99c;
}

.easy_mode_back svg {
    width: 20px;
}

.prediction_top_s {
    width: 100%;
    padding: 55px 0px;
    text-align: center;
    color: #D9D9D9;
}

.prediction_bl {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.prediction_up {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 32px;
}

.prediction_bl p a {
    color: #FEBA00;
}

.prediction_bl p {
    margin: 0px;
}

.bn_steps_step {
    width: 100%;
    position: relative;
    margin: 20px 0px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.bn_steps_step::before {
    width: 100%;
    height: 5px;
    position: absolute;
    content: "";
    background-color: #222222;
}

.bn_steps_step .number {
    width: 28px;
    height: 28px;
    background-color: #222;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50px;
    font-size: 14px;
    font-weight: 500;
    position: relative;
}

.prediction_detail {
    width: 100%;
    padding: 24px;
    min-height: 250px;
    border-radius: 10px;
    background-color: #222222;
    color: #fff;
}

.prediction_detail ul {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 48px;
    margin-top: 70px;
}

.prediction_detail ul.nav-tabs {
    margin-top: 28px;
    border: none;
    justify-content: start;
    gap: 20px;
}

.prediction_detail ul li {
    cursor: pointer;
}

.prediction_detail ul.nav-tabs li button {
    padding: 0px;
    background-color: transparent;
    border: none;
    font-size: 14px;
    color: #D9D9D9;
    font-weight: 500;
}

.prediction_detail ul.nav-tabs li button.active {
    background-color: transparent;
    color: #FEBA00;
}

.prediction_detail ul.nav-tabs li button:focus-visible {
    box-shadow: none;
}

.prediction_detail .tab-content .tab-pane {
    margin-top: 22px;
}

.trade_summary_table_lft tr th {
    font-size: 14px;
    font-weight: 500;
    color: #999;
    border-color: #ffffff00;
    padding: 8px 15px;
}

.trade_summary_table_lft tr td {
    font-size: 13px;
    font-weight: 500;
    color: #999;
    padding: 8px 15px;
}

.trade_summary_table_lft table {
    width: 100%;
}

.trade_summary_table_lft .tab-content>.tab-pane {
    width: 100%;
}

.trade-wrapper .trade_account_summary_assets .trade_summary_table_lft table tr td {
    padding: 10px !important;
    font-weight: 400 !important;
}


body .trade_account_summary_assets .bg-dark {
    background-color: #2b313c !important;
}


.fill_cnt {
    width: 100%;
    display: block;
    padding: 40px 0px;
    color: #d9d9d99c;
    text-align: center;
}

.esay_option_table {
    width: 100%;
    overflow: hidden;
    padding: 0px 20px;
}

.trade_summary_table_lft.esay_option_table h2 {
    color: #fff;
    margin: 32px 0px;
}

.trade_summary_table_lft.esay_option_table .nav-tabs {
    border: none;
    padding-bottom: 10px;
}

.top_th_easyop {
    border-bottom: 1px solid #282828;
}

.esay_option_table thead {
    border-bottom: 1px solid #282828;
}

.notfound_vector {
    max-width: 190px;
    margin: 0 auto;
    margin: 60px auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.buy_sell_option {
    width: 100%;
    display: block;
    padding: 40px 0px 70px;
    color: #fff;
}

.buy_sell_option h5 {
    font-size: 20px;
    font-weight: 400;
    color: #D9D9D9;
}

.buy_sell_option .nav-tabs {
    border-bottom: none;
    margin-top: 32px;
}

.buy_sell_option .nav-tabs li button.nav-link {
    font-size: 16px;
    color: #848e9c;
    border-radius: 0px;
    border: none;
}

.buy_sell_option .nav-tabs li button.nav-link.active {
    background-color: #5f38074d;
    color: #e4a456;
}


.probability_option .title-container {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
}

.probability_option .extra-button {
    border-radius: 16px;
    background-color: rgb(252, 213, 53);
    color: rgb(24, 26, 32);
    font-size: 13px;
    line-height: 16px;
    padding: 4px 8px;
    font-weight: 600;
    display: flex;
    align-items: center;
}

.relative_select_right .limit_tabs button {
    padding: 6px 0;
    /* background-color: transparent; */
    border: none !important;
    background-color: #ffffff00 !important;
    border-radius: 2px;
    font-size: 12px;
    color: #949AA4;
    transition: unset !important;
    width: 100%;
    display: block;
}

.relative_select_right .limit_tabs {
    gap: 15px;
    display: flex;
    flex-wrap: nowrap;
    border: none;
    margin: 8px 0px 10px;
    border-bottom: 1px solid #454C59 !important;
}

.relative_select_right .limit_tabs li.active button {
    color: #fff;
    border-bottom: 2px solid #fff !important;
}

.relative_select_right .nav-tabs .nav-link.active#buy-tab {
    color: #fff !important;
    background: #5EBA89 !important;
}

.relative_select_right .limit_tabs .selltab.active button {
    color: #fff !important;
    background: #ed5765 !important;
}

.buysell_heder .limit_tabs li.selltab.active button::before {
    background: #ed5765 !important;
}

.probability_option .extra-button svg {
    margin-left: 4px;
    width: 15px;
}

.probability_option .title {
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    color: rgb(234, 236, 239);
}

.probability_option {
    margin: 0px;
    min-width: 0px;
    background-color: rgb(43, 49, 57);
    padding: 16px;
    border-radius: 8px;
    cursor: pointer;
    flex-basis: 100%;
    border: 1px solid transparent;
}

.probability_option ul {
    display: flex;
    justify-content: space-between;
    gap: 5px;
    flex-direction: column;
    margin-top: 12px;
}

.probability_option ul li {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    gap: 12px;
    color: #969696;
    align-items: start;
}

.probability_option ul li .value {
    font-size: 14px;
    width: 50%;
    font-weight: 500;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: end;
}

.probability_option ul li .value:first-child {
    align-items: start;
}

.buy_sell_option .tab-content {
    margin-top: 24px;
}

.probability_option:hover {
    border: 1px solid #fcd535;
}

.prediction_up img.prediction_vector {
    min-height: 170px;
}

.algo_orders_outers .nav-tabs {
    border-bottom: none;
}

.algo_orders_outers .nav-tabs li .nav-link {
    font-size: 16px;
    color: #d9d9d9c9;
    border: none;
    border-radius: 0px;
}

.algo_orders_outers .nav-tabs li .nav-link.active {
    background-color: transparent;
    color: #fff;
}

.topbar_order {
    justify-content: space-between;
    gap: 32px;
    align-items: center;
    padding: 7px 20px 7px 0px;
}

.portal_chat_top {
    width: 50%;
}

.portal_chat_top ul {
    display: flex;
    justify-content: end;
    gap: 30px;
    color: #fff;
}

.portal_chat_top ul li a {
    display: flex;
    gap: 10px;
    color: #fff;
    font-size: 16px;
    align-items: center;
}

.algo_detail_summary {
    width: 100%;
    padding: 24px 15px 15px;
    color: #fff;
}

.algo_detail_summary p {
    color: #d9d9d9c9;
}

.orders_leftside {
    width: 100%;
}

.orders_leftside h2 {
    font-size: 32px;
}

.orders_leftside .nav-tabs {
    width: 100%;
    overflow: hidden;
    background-color: #222222;
    border-radius: 10px;
    margin: 20px 0px;
}

.orders_leftside .nav-tabs li {
    width: 50%;
    text-align: center;
}

.algo_detail_summary .row {
    margin-top: 24px;
}

.algo_orders_outers .orders_leftside .nav-tabs li .nav-link {
    width: 100%;
    padding: 22px 15px;
    border-radius: 10px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
}

.algo_orders_outers .orders_leftside .nav-tabs li .nav-link.active {
    background-color: #25B070;
}

.algo_orders_outers .orders_leftside .nav-tabs li.buytab .nav-link img {
    transform: rotate(-90deg);
}


.amount_info_del {
    width: 100%;
    background-color: #222222;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
}

.algo_detail_summary_left {
    display: flex;
    flex-direction: column;
    gap: 30px;
}

.algo_detail_summary_left h5 {
    color: #C1C9D5;
    font-weight: 400;
    margin: 0px;
}

.pricebtn button {
    font-size: 12px;
    background-color: #FEBA00;
    border: none;
    padding: 4px 16px;
    border-radius: 4px;
    font-weight: 700;
}

.pricebtn button.blackbtn {
    background-color: #000;
    color: #fff;
}

.amount_info_del.coloum_reverse {
    flex-direction: row-reverse;
}

.price_step {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
}

.price_step::before {
    width: 100%;
    position: absolute;
    left: 0px;
    content: "";
    background-color: #5A5B5C;
    height: 5px;
    top: 38%;
}

.price_step div {
    margin-top: 40px;
    position: relative;
    font-size: 14px;
    color: #C1C9D5;
}

.price_step div button:before {
    width: 16px;
    height: 16px;
    background-color: #5A5B5C;
    position: absolute;
    right: 0px;
    top: -22px;
    content: "";
}

.placebtn button {
    width: 100%;
    background-color: #FEBA00;
    border: none;
    border-radius: 8px;
    padding: 22px 20px;
    font-size: 24px;
    font-weight: 500;
}

.price_step div button {
    padding: 0px;
    background-color: transparent;
    border: none;
    color: #fff;
}

.algo_order_right {
    width: 100%;
}

.top_right_cnt {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.left_price_summary h2 {
    font-weight: 400;
}

.left_price_summary p {
    color: #47A663;
    line-height: 15px;
    margin: 15px 0px 0px;
    display: block;
    font-weight: 500;
}

.left_price_summary p span {
    margin-left: 8px;
    background-color: #1E1E1E;
    border: 1px solid #ffffff1f;
    padding: 3px 8px;
    border-radius: 5px;
    color: #fff;
}

.morebtn_right button {
    background-color: #1E1E1E;
    border: 1px solid #ffffff1f;
    padding: 9px 16px;
    border-radius: 5px;
    color: #fff;
}

.order_summary_graphchat {
    width: 100%;
    margin-top: 40px;
}

.option_symbol_s {
    display: flex;
    flex-direction: column;
    gap: 40px;
    margin-top: 30px;
}

.options_section {
    width: 100%;
}

.options_section h6 {
    font-size: 20px;
    color: #D9D9D9;
    font-weight: 400;
}

.options_section ul {
    display: flex;
    gap: 24px;
    margin-top: 15px;
}

.options_section ul li button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-size: 20px;
    color: #494949;
    border: 1px solid #494949;
    border-radius: 13px;
    padding: 12px 16px;
    font-weight: 600;
    background-color: transparent;
}

.options_section ul li button.active {
    color: #fff;
}

.strategies_cate ul {
    justify-content: space-between;
}

.strategies_cate ul li {
    width: 100%;
}

.strategies_cate ul li button {
    width: 100%;
}

.spot_trading_block {
    width: 822px;
    margin: 0 auto;
    max-width: 100%;
}

.d-flex.top_bar_hd {
    justify-content: space-between;
    align-items: center;
}

.d-flex.top_bar_hd h4 {
    font-size: 24px;
    font-weight: 400;
}

.setting_icon button {
    background-color: transparent;
    border: none;
}





.option_block a {
    color: #fff;
}

tr.green_light {
    background-color: #1b2a2a !important;
}

tr.danger_light {
    background-color: #2f1e26 !important;
}



.section_trading .dropdown {
    position: relative;
    display: inline-block;
    width: 200px;
}

.section_trading .dropdown-toggle {
    background-color: #2F2F2F;
    color: #ffffff;
    padding: 10px 14px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    border: 1px solid #444;
}

.section_trading .dropdown-toggle .left {
    display: flex;
    align-items: center;
    gap: 8px;
}

.section_trading .dropdown-toggle img.token-icon {
    width: 24px;
    height: 24px;
}

.section_trading .dropdown-menu {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    background-color: #1c1c1c;
    border-radius: 10px;
    margin-top: 8px;
    width: 100%;
    border: 1px solid #444;
    z-index: 999;
}

.section_trading .dropdown-menu .item {
    padding: 10px 14px;
    display: flex;
    align-items: center;
    gap: 10px;
    color: #fff;
    cursor: pointer;
}

.section_trading .dropdown-menu .item:hover {
    background-color: #333;
}

.section_trading .dropdown-menu img {
    width: 22px;
    height: 22px;
}

.section_trading .dropdown-menu.show {
    display: block;
}

.d-flex.justify_currency {
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    font-size: 18px;
}

.d-flex.justify_currency p {
    color: #717A8C;
    margin: 0px;
}

.section_trading {
    background-color: #222222;
    padding: 26px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.section_trading .price {
    font-size: 26px;
    color: #717A8C;
}

.trading_info_bl {
    display: flex;
    flex-direction: column;
    position: relative;
    gap: 12px;
    margin-top: 20px;
}

.refresh_cntr {
    width: 98px;
    position: absolute;
    margin: 0 auto;
    left: 0;
    right: 0px;
    top: 33%;
    transform: translateY(-40%);
}

.total_balance {
    font-size: 18px;
    color: #717A8C;
    text-align: right;
}

.request_quote_btn button {
    font-size: 22px;
    background-color: #feba008f;
    width: 100%;
    border: none;
    border-radius: 12px;
    padding: 18px 0px 20px;
}

.request_quote_btn {
    margin-top: 10px;
}

.option_block_outer {
    width: 100%;
    color: #fff;
    padding: 20px 40px;
}

.option_block_outer h1 {
    font-size: 32px;
}

.option_block_process {
    width: 100%;
    display: block;
    padding: 20px 0px;
    border: 1px solid #575757;
    border-radius: 35px;
    padding: 40px;
    margin-top: 40px;
}

.option_block_process ul {
    display: flex;
    gap: 50px;
    justify-content: space-between;
}

.option_block_process ul li span {
    font-size: 20px;
    margin-bottom: 10px;
    display: block;
}

.option_block_process ul li h2 {
    font-size: 22px;
    font-weight: 400;
}

.option_block_process ul li p {
    color: #999999;
    margin: 0px;
}

.createblock_form {
    width: 100%;
    display: block;
    padding: 115px 0px 40px;
}

.createblock_form .nav-tabs {
    border: none;
}

.createblock_form .nav-tabs li .nav-link {
    font-size: 18px;
    color: #C1C9D5;
    font-weight: 600;
    border: none;
    border-radius: 12px;
}

.createblock_form .nav-tabs li .nav-link.active {
    background-color: #222222;
    color: #fff;
}

.createblock_form>.tab-content {
    margin-top: 50px;
}

.creatblock_left_inquery {
    width: 100%;
    overflow: hidden;
    border-radius: 32px;
    background-color: #474747;
}

h5.mobile {
    padding: 10px 15px 0px;
    font-size: 18px;
    display: none;
}

.createblock_form .creatblock_left_inquery .nav-tabs {
    border: none;
    justify-content: space-between;
    flex-direction: row;
    display: flex;
    flex-wrap: nowrap;
}

.createblock_form .creatblock_left_inquery .nav-tabs li {
    width: 100%;
}

.createblock_form .creatblock_left_inquery .nav-tabs li .nav-link {
    width: 100%;
    font-size: 22px;
    border-radius: 0px;
    padding: 20px 15px;
}

.creatblock_left_inquery .tab-content {
    padding: 40px;
}

.creatblock_left_inquery .form_input {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 15px;
    padding-right: 15px;
    align-items: center;
    border: 1px solid #5E5E5E;
    border-radius: 15px;
}

.creatblock_left_inquery .form_input input {
    font-size: 20px;
    width: 100%;
    color: #C1C9D5;
    background-color: transparent;
    border: none;
    padding: 15px;
}

.creatblock_left_inquery .form_input input:focus-visible {
    outline: none;
    border: none;
}

.creatblock_left_inquery .form_input select {
    background-color: transparent;
    border: none;
    font-size: 18px;
    color: #fff;
}

.creatblock_left_inquery .form_input select option {
    color: #000;
}

.creatblock_left_inquery .form_input select:focus-visible {
    outline: none;
    border: none;
}

.creatblock_left_inquery .form_input.fullsize select {
    padding: 15px;
    width: 100%;
    color: #7b7b7b;
}

.buyform form .row {
    row-gap: 32px;
}

.submitbtn button {
    font-size: 22px;
    background-color: #caab2e;
    border-radius: 15px;
    color: #000;
    padding: 18px 10px;
    border: none;
    width: 100%;
    font-weight: 600;
}

.createblock_form .submitbtn {
    background-color: transparent;
    padding: 0px;
    border-radius: 0px;
}

.markert_overview_right {
    width: 100%;
    border: 1px solid #575757;
    padding: 32px;
    border-radius: 32px;
    height: 100%;
}

.markert_overview_right ul {
    padding-top: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px
}

.markert_overview_right ul li {
    color: #C1C9D5;
    font-size: 18px;
    display: flex;
    justify-content: space-between;
}

.markert_overview_right ul li:last-child {
    padding-top: 36px;
}

.strategies_form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px;
    font-size: 20px;
    color: #494949;
    border: 1px solid #494949;
    border-radius: 13px;
    padding: 36px;
    font-weight: 600;
    background-color: transparent;
    width: 600px;
    margin: 0 auto;
}

.strategies_form form {
    width: 100%;
    margin-top: 12px;
}

.strategies_form h4 {
    display: flex;
    gap: 12px;
    align-items: center;
    font-size: 18px;
}

.strategies_form form .op_traders_step {
    display: flex;
    flex-direction: column;
    gap: 18px;
}

.search_currency .modal-content {
    background-color: #222222;
}

.search_currency .modal-header {
    border-bottom: none;
}

.search_currency .search_form {
    border: 1px solid #474747;
}

.search_currency .search_form input {
    background-color: transparent;
    border: none;
}

.rightdata_s.mobileview {
    display: none;
}

.Currency_list_select {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-top: 24px;
    max-height: 260px;
    overflow: auto;
}

.currency_item {
    display: flex;
    align-items: center;
    cursor: pointer;
    gap: 15px;
}

.text-succes {
    color: #01BC8D;
}

.currency_item h5 {
    font-size: 15px;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    gap: 3px;
    margin: 0px;
}

.search_currency button.btn-close {
    background-color: #fff;
    opacity: 1;
    border-radius: 50px;
    font-size: 12px;
    top: -13px;
    position: relative;
    right: -4px;
}

.currency_item h5 span {
    font-size: 13px;
}

.currency_item img.token-icon {
    width: 30px;
    border-radius: 50px;
}

.op_traders_step .input_block {
    display: flex;
    gap: 10px;
    align-items: center;
}

.op_traders_step .input_block label {
    font-size: 14px;
    color: #fff;
    min-width: 100px;
    color: #c4c4c4;
}

.op_traders_step .input_block .select_option {
    width: 100%;
    background-color: transparent;
    border: 1px solid #494949;
    border-radius: 6px;
    padding: 8px;
    font-size: 14px;
}

.mobile_view {
    display: none;
}

.input_inserst {
    width: 100%;
    background-color: transparent;
    border: 1px solid #494949;
    border-radius: 6px;
    padding: 8px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.input_inserst input {
    background-color: transparent;
    border: none;
    width: 80%;
    color: #999;
}

input:focus-visible {
    outline: none;
}

.submitbtn {
    background-color: #fcd535;
    border: none;
    font-weight: 600;
    font-size: 18px;
    padding: 10px 15px;
    border-radius: 8px;
}


.toggle_righsidebar {
    width: 300px;
    color: #c9c9c9;
    position: absolute;
    right: 0px;
    background-color: #1e2329;
    border: 1px solid #2b3139;
    top: 0px;
    padding: 16px;
    display: none;
}

.toggle_righsidebar::before {
    width: 299px;
    background-color: #1e2329;
    position: fixed;
    content: "";
    height: 100%;
    bottom: 0px;
    right: 0;
}

.toggle_righsidebar.active {
    display: block;
}

.top_hd svg {
    width: 18px;
}

.closebtn {
    cursor: pointer;
}

.top_sidebar_main {
    position: relative;
}

.top_hd {
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;
    justify-content: space-between;
}

.top_hd .leftcnt {
    display: flex;
    align-items: center;
    gap: 10px;
}

.top_hd h4 {
    font-size: 16px;
    margin: 0px;
    display: flex;
    gap: 5px;
}

.sidebartabs .nav-tabs {
    flex-wrap: nowrap;
    border: none;
}

.sidebartabs .nav-tabs li {
    width: 100%;
}

.sidebartabs .nav-tabs .nav-link {
    color: #848e9c;
    border: none;
    font-size: 15px;
    width: 100%;
    border-radius: 50px;
    padding: 4px 15px;
}

.sidebartabs .nav-tabs .nav-link.active {
    background-color: #feba00;
    color: #000;
    font-weight: 500;
}

.bn_bubble_content {
    font-size: 13px;
    background-color: #feba001a;
    display: inline-block;
    padding: 2px 5px;
    border-radius: 4px;
    color: #feba00;
    margin: 5px 0px;
}

.sidebartabs {
    margin-top: 12px;
    font-size: 14px;
}

.avbl_usdt .d-flex {
    gap: 5px;
}

.evenodd_icon svg {
    width: 20px;
}

.evenodd_icon svg path {
    color: #feba00;
}

.price_stbs .price {
    display: flex;
    gap: 5px;
}

.price_stbs .price svg {
    width: 18px;
}

.bn_textField_inp {
    display: flex;
    justify-content: space-between;
    gap: 15px;
    background-color: #2b3139;
    border-radius: 7px;
    margin-top: 10px;
}

.bn_textField_inp input {
    width: 90%;
    background-color: transparent;
    border: none;
    padding: 10px;
    color: #999;
}

.bn_textField_inp .text_primarytext {
    padding: 10px;
}

.tif_ios_cnt {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 15px;
    border-top: 1px solid #2b3139;
    padding: 20px 0px;
    border-bottom: 1px solid #2b3139;
    margin-top: 20px;
}

.tif_ios_cnt ul {
    display: flex;
    gap: 10px;
    align-items: center;
}

.tif_ios_cnt ul li a {
    gap: 0px;
    display: flex;
    color: #c9c9c9;
}

.tif_ios_cnt ul li select {
    background-color: transparent;
    border: none;
    color: #fff;
}

.tif_ios_cnt ul li select option {
    color: #000;
}

button.bn-button.button__buy {
    background-color: #feba00;
    border: none;
    font-size: 16px;
    font-weight: 500;
    padding: 10px;
    border-radius: 10px;
}

.toggle_righsidebar .account_block_s {
    padding: 0px;
}

.toggle_righsidebar .account_tabs_info h5 {
    font-size: 16px;
}

.toggle_righsidebar .account_tabs_info ul {
    font-size: 13px;
}

.account_tabs_info ul li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    color: #c9c9c9;
}

.account_hd_div {
    margin-top: 20px;
    display: flex;
    align-items: center;
    gap: 20px;
    justify-content: space-between;
}

.account_currency_cate {
    margin: 10px 0px;
    overflow: auto;
}

.account_currency_cate ul {
    display: flex;
    gap: 15px;
    flex-direction: row;
    flex-wrap: nowrap;
}

.account_currency_cate ul li a {
    font-size: 14px;
    font-weight: 400;
}

.account_hd_div svg {
    width: 20px;
}

.account_hd_div svg path {
    fill: #feba00;
}

.account_hd_div h2 {
    font-size: 18px;
}

.dotted_toggle {
    width: 18px;
    cursor: pointer;
}

.togglehide_cnt {
    position: absolute;
    width: 200px;
    padding: 15px;
    background-color: #1e2329;
    right: 0px;
    top: 24px;
    border: 1px solid #9999993d;
    border-radius: 10px;
    display: none;
}

.togglehide_cnt.active {
    display: flex;
}

.togglehide_cnt ul {
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.togglehide_cnt ul li {
    align-items: center;
    gap: 7px;
    display: flex;
    font-size: 14px;
}

.modal.currency_popup_s.crosstabs .modal-dialog {
    max-width: 410px;
    min-width: 410px;
    width: 100%;
}

.modal.currency_popup_s.crosstabs .modal-content {
    background: #373E4B;
    border-radius: 15px;
}

.modal.currency_popup_s.crosstabs .modal-header {
    border: none;
    padding-bottom: 0px;
}

.modal.currency_popup_s .btn-close {
    background-color: #f3bb2b00;
    font-size: 11px;
    opacity: 1;
    border-radius: 50px;
}

.modal.currency_popup_s.crosstabs .modal-body {
    display: flex;
    justify-content: center;
    gap: 5px;
    color: #fff;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 10px 24px 20px;
}

.user_identyid {
    max-width: 120px;
    margin: 0;
    margin-bottom: 20px;
    opacity: 0.7;
}

.modal.currency_popup_s.crosstabs p {
    font-size: 12px;
    line-height: 22px;
    margin-bottom: 5px;
    color: #ffffffbf;
}

.modal.currency_popup_s h3 {
    font-size: 22px;
}

.btnsupport {
    flex-direction: column;
    width: 100%;
    gap: 5px;
}

.btnsupport button {
    font-size: 16px;
    padding: 10px 24px;
    border-radius: 50px;
    border: none;
    font-weight: 500;
    background-color: #f3bb2b;
}

.btnsupport button.customerbtn {
    background-color: transparent;
    border-radius: 0px;
    color: #f3bb2b;
}

.modal.currency_popup_s.crosstabs .modal-body.free_rate {
    align-items: start;
    text-align: left;
    padding: 15px 32px 32px;
}

.modal.currency_popup_s.crosstabs .modal-body.free_rate ul {
    align-items: start;
    width: 100%;
    margin: 10px 0px 24px;
    flex-direction: column;
}

.modal.currency_popup_s.crosstabs .modal-body.free_rate ul li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    width: 100%;
}

.price_stbs .price a {
    color: #fff;
}

button.bn-button.button__buy.sellbtn {
    background-color: #f65454;
    color: #fff;
}

.top_table_data {
    display: flex;
    justify-content: space-between;
    align-items: start;
    border-bottom: 1px solid #f3f3f329;
    min-height: 500px;
    max-height: 500px;
    overflow: auto;
}

.recent_tables_outer .tables_calls .table-responsive,
.recent_tables_outer .tables_puts .table-responsive {
    min-height: 150px;
    max-height: 150px;
    overflow: auto;
}

::-webkit-scrollbar {
    width: 6px;
}

::-webkit-scrollbar-track {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.15);
    border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.25);
}

/* * {
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.25) transparent;
} */

.top_table_data .lefside_data {
    width: 100%;
}

.top_table_data .table-responsive {
    min-height: 100%;
    max-height: 100%;
}

.top_table_data .right_data {
    width: 100%;
}

.top_table_data .mid_data {
    min-width: 100px;
    text-align: center;
    box-shadow: 0 10px 8px #000000de;
    position: relative;
}

.topnav_selected .form-check-label:before {
    display: none;
}

.classic_favorites_bl .col-sm-2 .relative_select_right {
    width: 100%;
}

.usd_future_dashboard {
    position: relative;
    /* z-index: 999; */
}

.data_option_calls table tr td span {
    display: block;
    color: #999;
    font-size: 10px;
}

.option_block_outer .esay_option_table {
    padding: 0px;
}



.hero_section_option {
    background-position: right center;
    /* background-image: url(/public/images/option_home_img/hero_img.svg); */
    background-repeat: no-repeat;
    background-size: 1075px;
    min-height: 840px;
    display: flex;
    align-items: center;
    color: #fff;
    background-color: #000000;
}

.hero_section_option h1 {
    font-size: 90px;
    font-weight: 700;
}

.hero_section_option p {
    font-size: 22px;
    margin: 24px 0px 15px;
    max-width: 85%;
}

.options_btn {
    display: flex;
    gap: 48px;
    align-items: center;
}

.options_btn button {
    background-color: #b1adad20;
    padding: 19px 48px;
    border-radius: 50px;
    font-size: 24px;
    color: #fff;
    border: none;
}

.options_btn button span {
    color: #FEBA00;
}

.options_btn button.optionsbg {
    background: linear-gradient(90deg, rgba(243, 187, 43, 1) 0%, #ff9400 100%);
    color: #000;
}

.options_btn button.optionsbg:hover {
    background: linear-gradient(90deg, rgb(185, 139, 22) 0%, #f0900b 100%);
}

.hero_section_option ul {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    margin-top: 30px;
}

.tradenow_btn button:hover {
    background: linear-gradient(90deg, rgb(201, 150, 22) 0%, rgb(241, 148, 17) 100%);
}

.learn_btn button:hover {
    background: linear-gradient(90deg, rgb(201, 150, 22) 0%, rgb(241, 148, 17) 100%);
}

.hero_section_option ul li h4 {
    font-size: 22px;
    color: #ffffff6e;
    font-weight: 400;
    margin: 0px;
    line-height: 180%;
}

.hero_section_option ul li h4 span {
    display: block;
    color: #fff;
    font-weight: 500;
}

.market_highlight_section {
    width: 100%;
    background-color: #000;
    padding: 0px 0px 80px;
    color: #fff;
}

.heading2 {
    font-size: 46px;
    line-height: 130%;
}

.market_highlight_section .nav li button.nav-link {
    font-size: 13px;
    color: #fff;
    display: flex;
    border-radius: 50px;
    padding: 10px 18px;
    align-items: center;
    justify-content: center;
}

.market_highlight_section .nav li button.nav-link.active {
    background-color: #d9d9d921;
    box-shadow: 0px 1px 0px #A77B01;
}

.tradenow_btn button {
    padding: 13px 20px;
    border: none;
    border-radius: 50px;
    font-size: 20px;
    font-weight: 400;
    background: linear-gradient(90deg, rgba(243, 187, 43, 1) 0%, rgba(255, 148, 0, 1) 100%);
    color: #000;
}

.market_summary {
    width: 100% !important;
    text-align: left;
    background-size: cover;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    border-radius: 10px;
    padding: 24px 20px;
}

.slick-track {
    display: flex !important;
    gap: 10px;
}

.market_summary table {
    width: 100%;
    margin-top: 20px;
}

.market_summary table tr th {
    font-size: 14px;
    color: #ffffff9f;
    font-weight: 300;
    padding: 6px 10px !important;
}

.market_summary table tr td {
    font-size: 14px;
    color: #fff;
    font-weight: 300;
    padding: 6px 10px;
}

.market_summary table tr td.green {
    color: #01BC8D;
}

.market_summary h4 {
    font-weight: 400;
    font-size: 20px;
}

.market_highlight_section .tab-content {
    margin-top: 15px;
}

.option_highlight_section {
    padding: 30px 0px 120px;
    position: relative;
    background-color: #000;
    color: #fff;
}

.option_highlight_section::before {
    position: absolute;
    content: "";
    width: 221px;
    height: 1180px;
    top: -310px;
    left: 0px;
    background-size: contain;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
}

.trade_strengths_bl::before {
    position: absolute;
    content: "";
    width: 220px;
    height: 1500px;
    top: -80%;
    right: 0px;
    background-size: contain;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-repeat: no-repeat;
    transform: rotate(180deg);
}

.option_highlight_section p {
    font-size: 22px;
    font-weight: 300;
    margin: 20px 0px;
    color: #ffffffec;
}

.option_highlight_section .software_trading_cnt p {
    font-size: 14px;
    font-weight: 400;
    margin: 10px 0px 0px;
    color: #6D7792;
    line-height: 120%;
}

.option_highlight_section .row {
    padding-top: 20px;
}

.option_highlight_section .container {
    position: relative;
    z-index: 999;
}

.why_trade_option {
    width: 100%;
    display: block;
    position: relative;
    background-color: #010101;
    color: #fff;
    padding: 0px 0px 70px;
}

.why_trade_option .row {
    align-items: center;
    justify-content: center;
}

.why_trade_option p {
    font-size: 20px;
    padding: 15px 0px 5px;
    font-weight: 300;
    color: #e9e9e9;
}

.learn_btn button {
    padding: 20px 70px;
    border: none;
    border-radius: 50px;
    font-size: 20px;
    font-weight: 500;
    background: linear-gradient(90deg, rgba(243, 187, 43, 1) 0%, rgba(255, 148, 0, 1) 100%);
    color: #000;
}

.why_trade_options {
    max-width: 680px;
    float: right;
}

.trade_strengths_bl .nav {
    margin: 30px 0px;
    gap: 30px;
}

.trade_strengths_bl .nav li button.nav-link {
    font-size: 22px;
    background-color: #b1adad21;
    padding: 18px 32px;
    color: #fff;
    border-radius: 50px;
}

.tradenow_btn {
    display: flex;
    align-items: center;
    justify-content: center;
}

.trade_strengths_bl .nav li button.nav-link.active {
    background-color: #FBA00D;
    color: #000;
}

.coin_options_bl {
    background: linear-gradient(180deg, rgba(31, 31, 31, 1) 0%, rgba(6, 6, 6, 1) 100%);
    text-align: center;
    position: relative;
    padding: 50px;
    border-width: 1px;
    border-style: solid;
    border-image: linear-gradient(to bottom, #3e3e3e, #000000) 1;
}

.coin_options_bl::before {
    width: 160px;
    height: 160px;
    background-color: #FEBA00;
    border-radius: 100%;
    position: absolute;
    content: "";
    top: 0px;
}

.coin_icon {
    width: 106px;
    height: 106px;
    background-color: #FED300;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100px;
    border: 4px solid #FBB226;
    margin: 0 auto;
    position: relative;
    top: -40px;
    margin-top: -60px;
}

.coin_options_bl h3 {
    font-size: 30px;
    font-weight: 700;
}

.coin_options_bl p {
    color: #898CA9;
    font-size: 18px;
    margin: 0px;
}

.trade_strengths_bl .tab-content {
    margin-top: 50px;
}

.why_trade_option .tab-content .row {
    padding-top: 50px;
}

.coin_options_bl::before {
    width: 160px;
    height: 160px;
    background-color: #FEBA00;
    border-radius: 100%;
    position: absolute;
    content: "";
    top: -50px;
    right: 0px;
    filter: blur(60px);
    left: 0px;
    margin: 0 auto;
    opacity: 0.6;
}

.social_button {
    width: 100%;
    display: flex;
    gap: 24px;
    flex-wrap: wrap;
    margin-top: 30px;
}

.qr_code {
    padding-left: 15px;
}

.social_btn a {
    background-color: #24272C;
    border-radius: 8px;
    padding: 10px 12px;
    color: #fff;
    display: flex;
    align-items: center;
    gap: 18px;
}

.social_btn a .btn_cnt {
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
}

.social_btn a .btn_cnt span {
    font-size: 12px;
    display: block;
    font-weight: 400;
}

.why_trade_option.trade_anywhere_s {
    padding: 70px 0px;
}

.start_trading_options {
    margin: 120px 0px;
    text-align: center;
}

.start_trading_options .tradenow_btn button {
    padding: 18px 36px;
    font-size: 20px;
    font-weight: 500;
    margin-top: 18px;
}

.futures_options_s table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
}

.futures_options_s table thead th {
    background-color: #161616;
    color: #fff;
    font-size: 16px;
    text-transform: uppercase;
    padding: 12px;
    letter-spacing: 1px;
    text-align: left;
    border: 1px solid #222222;
}

.futures_options_s table thead th h4 {
    font-size: 28px;
    font-weight: 500;
    color: #f8f8f8;
}

.futures_options_s table tbody td {
    padding: 12px;
    border: 1px solid #222222;
    color: #ddd;
    vertical-align: top;
}

.futures_options_s table tbody td.first_tbl {
    white-space: nowrap;
}

.futures_options_s table tbody tr:nth-child(even) {
    background-color: #161616;
}

.market_highlight_section .nav li button.nav-link img {
    width: 24px;
    height: 24px;
    border-radius: 100px;
    margin-right: 5px;
}

.hero_img_mobile {
    display: none;
}

button.mobilebtn {
    display: none;
}

.market_spot_form .tab-content>.tab-pane.show {
    padding-right: 0px;
}

.market_spot_form .buysell_btn button {
    padding: 6px 24px;
    font-size: 14px;
}

.market_spot_form .price_inputbl.mt-2 {
    padding-bottom: 20px;
}

.order_trade_s .price_card_head {
    opacity: 0.6;
}

.top_barcalls_put_cnt ul li.nthchild2 {
    padding-left: 94px;
}

ul.future_mobileview_tabs {
    display: none;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
}

.future_mobile_tab_content.table_info_data .buy_sell_row {
    padding-top: 0px;
}

ul.future_mobileview_tabs li {
    font-size: 12px;
    color: #999;
    cursor: pointer;
    border-bottom: 1px solid transparent;
    padding-bottom: 3px;
}

ul.future_mobileview_tabs li.active {
    color: #fff;
    border-bottom: 1px solid #fff;
}

.future_mobile_tab_content {
    overflow-y: auto;
    max-height: 100%;
}

@media screen and (max-width:1550px) {

    .hero_section_option h1 {
        font-size: 60px;
    }

    .hero_section_option p {
        font-size: 18px;
        max-width: 70%;
    }

    .options_btn button {
        padding: 11px 32px;
        font-size: 18px;
    }

    .options_btn {
        gap: 20px;
    }

    .hero_section_option ul li h4 {
        font-size: 18px;
    }

    .hero_section_option ul {
        gap: 20px;
        margin-top: 20px;
        width: 70%;
        flex-wrap: wrap;
    }

    .heading2 {
        font-size: 38px;
    }

    .option_highlight_section p {
        font-size: 18px;
    }

    .why_trade_option p {
        font-size: 18px;
    }

    .learn_btn button {
        padding: 11px 50px;
        font-size: 16px;
    }

    .trade_strengths_bl .nav li button.nav-link {
        font-size: 18px;
        padding: 10px 32px;
    }

    .start_trading_options .tradenow_btn button {
        padding: 10px 20px;
        font-size: 16px;
    }

    .tradenow_btn button {
        font-size: 18px;
    }

    .trade_movers_tb button.nav-link {
        font-size: 12px;
        padding: 4px 12px;
    }

    .trade_movers_tb ul.nav-tabs {
        gap: 8px;
    }

    .top_future_right_s ul li {
        min-width: 140px;
    }

}

@media screen and (max-width:1440px) {

    .market_spot_form .buysell_btn button {
        padding: 4px 14px;
        font-size: 13px;
    }

    .price_inputbl ul {
        overflow: auto;
        padding-bottom: 7px;
    }

    .top_barcalls_put_cnt ul li.nthchild2 {
        padding-left: 0px;
    }

    .mrkt_trde_tab {
        justify-content: space-between !important;
        font-size: 12px;
    }

    .classic_favorites_bl .col-sm-2 .relative_select_right {
        padding: 10px 15px;
    }

    .data_option_calls table tr th {
        white-space: nowrap;
    }

    .coin_options_bl h3 {
        font-size: 24px;
    }


    .recent_trades_options table tr th {
        white-space: nowrap;
    }

    .container,
    .container-lg,
    .container-md,
    .container-sm,
    .container-xl,
    .container-xxl {
        max-width: 95%;
    }

    .algo_orders_outers .nav-tabs {
        white-space: nowrap;
        flex-wrap: nowrap;
        overflow: auto;
    }

    .placebtn button {
        padding: 16px 20px;
        font-size: 20px;
    }

    .algo_orders_outers .orders_leftside .nav-tabs li .nav-link {
        padding: 18px 15px;
    }

    .request_quote_btn button {
        font-size: 18px;
        padding: 16px 0px 20px;
    }

}

@media screen and (max-width:1366px) {

    .hero_section_option h1 {
        font-size: 40px;
    }

    .trade_movers_tb ul.nav-tabs {
        gap: 5px;
    }

    .space_gap_0 form.price_info {
        padding: 0px 0px;
    }


    .assets_right h2 {
        margin-left: 0px;
    }

    .asset_total_value {
        padding: 5px 0px;
    }

    .hero_section_option p {
        font-size: 15px;
    }

    .options_btn button {
        padding: 9px 24px;
        font-size: 15px;
    }

    .hero_section_option ul li h4 {
        font-size: 15px;
    }

    .hero_section_option {
        background-size: 750px;
        min-height: 560px;
    }

    .trade_movers_tb button.nav-link {
        font-size: 12px;
        padding: 6px 10px;
    }

    .order_trade_s .price_card_head {
        gap: 12px;
        overflow: auto;
    }

    .top_future_left_s {
        width: 70%;
        overflow: auto;
        white-space: nowrap;
    }

}

@media screen and (max-width:1200px) {

    .order_trade_s .price_card_head div {
        width: auto !important;
    }

    .mrkt_trde_tab {
        overflow: auto;
    }


    .top_table_data {
        min-height: 520px;
    }

    .buysell_btn button {
        padding: 5px 24px;
        font-size: 13px;
    }

    .market_summary table tr th {
        white-space: nowrap;
    }

    .option_highlight_section p {
        font-size: 15px;
    }

    .dashboard_mid_s.space_gap_0.pa_2 .price_info .price_inputbl {
        padding-bottom: 0px;
    }

    .why_trade_option p {
        font-size: 15px;
    }

    .learn_btn button {
        padding: 9px 36px;
        font-size: 15px;
    }

    .trade_strengths_bl .nav li button.nav-link {
        font-size: 15px;
        padding: 8px 32px;
    }

    .coin_options_bl {
        padding: 0px 20px 30px;
    }

    .coin_options_bl h3 {
        font-size: 20px;
    }

    .coin_icon {
        width: 80px;
        padding: 10px;
        height: 80px;
        top: -20px;
        margin-top: -20px;
    }

    .social_btn img {
        width: 30px;
    }

    .option_highlight_section {
        padding: 30px 0px 70px;
    }

    .social_btn img {
        width: 20px;
    }

    .social_btn a {
        padding: 7px 12px;
        gap: 10px;
    }

    .social_btn a .btn_cnt {
        font-size: 15px;
        line-height: 20px;
    }

    .social_btn a .btn_cnt span {
        font-size: 10px;
    }

    .why_trade_option.trade_anywhere_s {
        padding: 40px 0px;
    }

    .market_highlight_section .nav li button.nav-link {
        font-size: 12px;
        padding: 6px 15px;
    }

    .tradenow_btn button {
        font-size: 15px;
    }

    .market_summary table tr td {
        font-size: 12px;
    }

    .submitbtn button {
        font-size: 18px;
        padding: 15px 10px;
    }

    .createblock_form .creatblock_left_inquery .nav-tabs li .nav-link {
        font-size: 18px;
        padding: 15px 15px;
    }

    .markert_overview_right h3 {
        font-size: 20px;
    }

    .markert_overview_right {
        padding: 24px;
    }

    .creatblock_left_inquery .form_input select {
        font-size: 15px;
    }

    .creatblock_left_inquery .form_input input {
        font-size: 15px;
    }

    .createblock_form {
        padding: 70px 0px 40px;
    }

    .trade_summary_table_lft .nav-tabs {
        gap: 5px;
        overflow: scroll;
        white-space: nowrap;
        flex-wrap: nowrap;
    }

    .algo_orders_outers .orders_leftside .nav-tabs li .nav-link {
        padding: 16px 15px;
    }

    .trade_summary_table_lft {
        width: 100%;
    }

    .price_info {
        padding-bottom: 20px;
    }

    .assets_right {
        width: 100%;
    }

    footer .menu li a {
        font-size: 14px;
    }

    .h1,
    h1 {
        font-size: 30px;
    }

    .orders_leftside h2 {
        font-size: 24px;
    }

    .options_section ul li button {
        font-size: 15px;
        border-radius: 10px;
    }

    .strategies_cate ul {
        white-space: nowrap;
        overflow: auto;
    }

    .request_quote_btn button {
        font-size: 18px;
        padding: 15px 0px 20px;
    }

    .placebtn button {
        padding: 18px 20px;
        font-size: 18px;
    }

    .algo_detail_summary_left h5 {
        font-size: 16px;
    }

    .portal_chat_top ul {
        white-space: nowrap;
        flex-wrap: nowrap;
        overflow: scroll;
    }


    .top_future_right_s {
        overflow: auto;
        width: 35%;
        white-space: nowrap;
    }

    .top_bar_usd_future {
        align-items: end;
    }

    .trade_summary_table_lft.esay_option_table .nav-tabs {
        flex-wrap: nowrap;
        overflow: auto;
        white-space: nowrap;
    }

    .classic_usd_right ul {
        overflow: scroll;
        gap: 20px;
    }

    .classic_option_top {
        overflow: hidden;
    }

    .hero_section_option {
        background-size: 600px;
        min-height: 480px;
    }

    .heading2 {
        font-size: 30px;
    }

    .price_info .price_inputbl {
        padding-bottom: 15px;
    }

    .trade_movers_tb ul.nav-tabs {
        white-space: nowrap;
        flex-wrap: nowrap;
        overflow: auto;
    }

}


.mobile_data_table .desktop_view {
    display: none;
}

span.arrowmobile {
    display: none;
}

.mobileview .rightdata_s {
    display: none;
}

@media screen and (max-width:991px) {


    .rightdata_s.mobileview.active {
        display: block;
        margin-bottom: 20px;
    }

    .rightdata_s {
        display: none;
    }

    .desktop_view {
        padding-top: 10px;
    }

    .selected_product_info {
        padding: 10px 0px;
    }

    span.arrowmobile {
        display: block;
    }

    .flex_right_option .order_trade_s {
        width: 40%;
    }

    .classic_usd_right ul {
        gap: 10px;
    }

    .product_name span.arrowmobile svg {
        width: 12px;
        height: 13px;
    }


    .mobile_data_table .desktop_view {
        display: block;
    }

    button.mobilebtn {
        display: block;
        border: none;
        border-radius: 50px;
        padding: 5px 12px;
    }

    .dashboard_mid_s.space_gap_0 .order_trade_s {
        padding-top: 0px;
    }

    .market_spot_form .price_inputbl.mt-2 {
        padding-bottom: 20px !important;
    }

    .data_option_calls.mobile_data_table.active {
        display: block;
    }

    .data_option_calls.mobile_data_table {
        display: block;
    }

    .data_option_calls {
        display: none;
    }



    .option_datatable_bl .row .col-sm-5 {
        width: 100%;
        padding: 0px 5px;
    }

    .option_datatable_bl .row.classic_favorites_bl {
        flex-direction: row;
        padding-top: 0px;
    }

    .option_datatable_bl .order_trade_s {
        padding-top: 0px;
    }

    .option_datatable_bl .price_info .price_inputbl {
        padding-bottom: 0px;
    }

    .option_datatable_bl .row .col-sm-7 {
        margin-bottom: 10px;
        width: 100%;
    }

    .datatable {
        display: flex;
        flex-direction: column;
        /* gap: 40px; */
        align-items: center;
        justify-content: space-around;
        min-height: 120px;
    }

    .datatable div {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .data_put {
        display: flex;
        flex-direction: column;
        gap: 40px;
    }

    .mobile_data_table .top_table_data {
        display: flex;
        flex-direction: row-reverse;
    }

    .hero_section_option {
        background-size: 480px;
        min-height: 400px;
    }

    .space_gap_0.dashboard_mid_s .dashboard_summary_lft {
        width: 100%;
    }

    .market_highlight_section .nav li button.nav-link {
        padding: 6px 25px;
    }

    .market_highlight_section .mt-5 {
        margin-top: 24px !important;
    }

    .hero_section_option h1 {
        font-size: 30px;
    }

    .hero_section_option p {
        font-size: 14px;
    }

    .market_highlight_section {
        padding: 0px 0px 40px;
    }

    .options_btn button {
        padding: 8px 20px;
        font-size: 13px;
    }

    .options_btn {
        gap: 10px;
    }

    .hero_section_option ul {
        gap: 10px;
        margin-top: 10px;
        width: 80%;
    }

    .heading2 {
        font-size: 24px;
    }

    .trade_strengths_bl .nav {
        gap: 15px;
    }

    .coin_options_bl::before {
        width: 100px;
        height: 100px;
        top: -20px;
    }

    .coin_options_bl h3 {
        font-size: 20px;
    }

    .coin_icon {
        width: 70px;
        height: 70px;
        padding: 10px;
        top: -20px;
        margin-top: -10px;
    }

    .option_highlight_section .row {
        row-gap: 24px;
    }

    .option_highlight_section .row .col-sm-3 {
        width: 50%;
    }

    .hero_section_option ul li {
        width: 48%;
    }

    .futures_options_s table thead th h4 {
        font-size: 18px;
    }

    .futures_options_s table thead th {
        font-size: 13px;
    }

    .futures_options_s table tbody td {
        font-size: 13px;
    }

    .trade_strengths_bl::before {
        width: 130px;
        height: 1000px;
        top: -60%;
    }

    .why_trade_option {
        padding: 0px 0px 30px;
    }

    .why_trade_option .tab-content .row {
        padding-top: 20px;
    }

    .option_block_process {
        border-radius: 24px;
        padding: 24px;
        margin-top: 24px;
    }

    .markert_overview_right ul li {
        font-size: 15px;
    }

    .row.classic_favorites_bl {
        flex-direction: column;
    }

    .row.classic_favorites_bl .col-sm-9 {
        width: 100%;
    }

    .row.classic_favorites_bl .col-sm-3 {
        width: 100%;
    }

    .recent_tables_outer {
        flex-direction: column;
    }

    .dashboard_mid_s {
        flex-direction: column;
    }

    .algo_detail_summary .row {
        flex-direction: column;
    }

    .algo_detail_summary .row .col-sm-4 {
        width: 100%;
    }

    .algo_detail_summary .row .col-sm-8 {
        width: 100%;
    }

    .topbar_order {
        align-items: start;
        flex-direction: column;
        gap: 15px;
    }

    .portal_chat_top ul {
        justify-content: center;
    }

    .algo_order_right {
        margin-top: 30px;
    }

    .algo_orders_outers .nav-tabs {
        width: 100%;
    }

    .portal_chat_top {
        width: 100%;
    }

    .order_trade_s {
        width: 100%;
        padding-top: 20px;
    }

    .relative_select_right {
        width: 100%;
        padding-top: 15px;
    }

    .table_info_data table tr .subtotal {
        text-align: left;
    }

    .trade_account_summary_assets {
        flex-direction: column;
        margin-top: 0px;
    }

    .trade_summary_table_lft {
        width: 100%;
    }

    .assets_right {
        width: 100%;
    }

    .market_spot_form {
        padding-bottom: 24px;
    }

    .bs_dropbox small {
        margin-bottom: 8px;
        display: block;
    }

    .dashboard_mid_s.space_gap_0.pa_2 .market_spot_form {
        padding-bottom: 0px;
    }

    .trade_summary_table_lft .tab-content {
        min-height: 100px;
    }

    .prediction_detail ul.nav-tabs {
        margin-top: 18px;
        gap: 12px;
    }

    .no_wrap_s {
        width: 100%;
        overflow: auto;
    }

    .no_wrap_s ul {
        white-space: nowrap;
        flex-wrap: nowrap;
        width: 100%;
        margin: 0px !important;
    }

    .tradenow_btn button {
        font-size: 14px;
        white-space: nowrap;
    }

    .top_table_data .mid_data {
        display: none;
    }

    .mobile_data_table .scroll_y {
        overflow-x: auto;
        height: 100% !important;
        width: 100%;
    }

    .top_table_data .mid_data.mobile_view {
        display: flex;
    }

    .top_table_data .lefside_data {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
    }

    .mobile_data_table .top_table_data .table-responsive {
        min-height: 100%;
        max-height: 580px;
    }

    .datatable div span {
        font-size: 10px;
    }

    .data_option_calls table tr td {
        font-size: 12px;
        color: #d3d3d3;
    }

    .data_option_calls table tr td div span {
        color: #aaaaaa;
    }

    .flex_right_option {
        gap: 5px;
    }

    .market_spot_form .buysell_btn button {
        padding: 7px 14px;
    }

    /* button.btn.btn-danger.btn-block.w-100 {
            font-size: 12px;
        } */

    .order_datalist .listdata {
        padding-bottom: 18px;
    }

    .usd_left_pr {
        gap: 15px;
        flex-direction: column;
    }

    body .top_future_right_s {
        display: none;
    }

    body .top_future_left_s {
        width: 100%;
    }

    body .price_top_right {
        width: 100%;
        font-size: 20px;
    }

    .top_future_left_s ul {
        padding: 0px;
        margin: 0px;
        list-style: none;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 5px;
        align-items: flex-start !important;
    }

    body .top_future_left_s ul li:nth-child(3) {
        min-width: auto;
    }

    body .top_future_left_s ul li:nth-child(4) {
        min-width: auto;
    }

    body .top_future_left_s ul li:nth-child(5) {
        min-width: auto;
    }


}


@media screen and (max-width:767px) {

    .modal.currency_popup_s.crosstabs .modal-content {
        border-radius: 0px;
    }

    ul.future_mobileview_tabs {
        display: flex;
        border-bottom: 1px solid #585858;
    }

    .position_order .position_list {
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        /* Hide scrollbar by default on mobile */
        scrollbar-width: none;
        -ms-overflow-style: none;
    }

    .position_order .position_list li button {
        font-size: 14px;
    }

    .trade_account_summary_assets {
        margin-top: 0px;
    }

    .position_order .position_list::-webkit-scrollbar {
        height: 6px;
        display: none;
    }

    /* Show scrollbar only when user scrolls or hovers */
    .position_order .position_list.show-scrollbar::-webkit-scrollbar {
        display: block;
    }

    .position_order .position_list.show-scrollbar {
        scrollbar-width: thin;
        scrollbar-color: rgba(255, 255, 255, 0.4) transparent;
    }

    .position_order .position_list.show-scrollbar::-webkit-scrollbar-track {
        background: transparent;
        border-radius: 10px;
    }

    .position_order .position_list.show-scrollbar::-webkit-scrollbar-thumb {
        background-color: rgb(255 255 255 / 20%);
        border-radius: 10px;
    }

    .position_order .position_list.show-scrollbar::-webkit-scrollbar-thumb:hover {
        background-color: rgb(255 255 255 / 20%);
    }

    body .top_future_left_s ul li span {
        font-size: 9px;
    }

    .hero_img_mobile {
        display: block;
        max-width: 300px;
        margin: 0 auto;
    }

    .classic_grid_dashboard_bl.d-flex.option_datatable_bl .d-flex.topnav_selected {
        padding: 10px 0px 2px;
        margin-bottom: 12px;
    }

    .rightdata_s.mobileview.active {
        margin-bottom: 5px;
        padding: 0px;
    }

    .classic_usd_right ul {
        padding-bottom: 6px;
    }

    .modal.currency_popup_s.crosstabs .modal-body {
        padding: 0px 18px 18px;
    }

    button.mobilebtn {
        margin: 8px 0px 10px;
    }

    .datatable {
        min-height: 100px;
    }

    .top_table_data .mid_data tr td {
        height: 117px;
        display: flex;
        align-items: center;
    }

    .top_table_data .mid_data tr {
        display: block;
    }

    .option_datatable_bl .top_table_data .mid_data.mobile_view {
        padding: 0px;
    }

    .option_datatable_bl .classic_favorites_bl .col-sm-2 .relative_select_right {
        padding: 10px;
    }

    .option_datatable_bl .classic_favorites_bl .tab-content>.tab-pane {
        padding-right: 0px;
    }

    .d-flex.topnav_selected {
        overflow: auto;
        padding: 0px;
        align-items: start;
    }

    .d-flex.align-items-center.justify-content-between.buy_transferbtn {
        margin-bottom: 10px;
    }

    .tradenow_btn button {
        padding: 7px 20px;
    }

    .options_btn {
        justify-content: center;
    }

    .learn_btn {
        display: flex;
        justify-content: center;
    }

    .hero_section_option h1 br {
        display: none;
    }

    .option_highlight_section::before {
        display: none;
    }

    .buysell_btn button {
        padding: 7px 24px;
        font-size: 13px;
    }

    .why_trade_option .row {
        gap: 30px;
        flex-direction: column;
    }

    .why_trade_option .row .col-sm-6 {
        width: 100%;
    }

    .why_trade_option .row .col-sm-4 {
        width: 100%;
    }

    .hero_section_option .col-sm-8 {
        width: 100%;
    }

    .hero_section_option ul {
        width: 100%;
    }

    .hero_section_option {
        background-image: none;
    }

    .option_block_process ul {
        gap: 24px;
        flex-direction: column;
    }

    .createblock_form {
        padding: 40px 0px 20px;
    }

    .createblock_form .nav-tabs li .nav-link {
        font-size: 14px;
    }

    .option_block_process ul li h2 {
        font-size: 18px;
    }

    .algo_detail_summary p {
        margin-bottom: 0px;
    }

    .option_block_outer h1 {
        font-size: 24px;
    }

    .top_table_data .right_data {
        display: flex;
    }

    h5.mobile {
        display: block;
    }

    .top_table_data {
        max-height: 100%;
    }

    .top_table_data .mid_data {
        min-width: 60px;
        padding: 15px 0px;
    }

    .recent_tables_outer {
        flex-direction: column;
        gap: 24px;
    }

    .recent_tables_outer .tables_calls .table-responsive,
    .recent_tables_outer .tables_puts .table-responsive {
        min-height: 250px;
        max-height: 250px;
    }

    .recent_trades_options table tr th {
        white-space: nowrap;
    }

    .top_table_data {
        flex-direction: column;
    }

    .top_barcalls_put_cnt ul {
        gap: 20px;
        padding: 10px 20px;
    }

    .container,
    .container-sm {
        max-width: 100%;
    }

    .hero_section_option {
        background-image: none;
        padding: 30px 0px;
        text-align: center;
    }

    .hero_section_option ul li h4 {
        font-size: 13px;
    }

    .options_btn button {
        padding: 6px 20px;
        font-size: 12px;
        line-height: 110%;
    }

    .hero_section_option h1 {
        font-size: 24px;
    }

    .heading2 {
        font-size: 22px;
    }

    .market_highlight_section .mt-5 {
        margin-top: 20px !important;
    }

    .market_highlight_section .d-flex.justify-content-between.align-items-center.mt-5 {
        flex-direction: column;
        gap: 20px;
    }

    .option_highlight_section p {
        margin: 10px 0px 0px;
    }

    .market_highlight_section .table-responsive {
        max-height: 290px;
    }

    .market_highlight_section {
        padding-bottom: 0px;
    }

    .market_summary table {
        margin-top: 0px;
    }

    .market_highlight_section .nav {
        gap: 12px;
    }

    .market_summary h4 {
        font-size: 16px;
    }

    .market_summary {
        padding: 20px 15px;
    }

    .slick-track {
        gap: 0px;
    }

    .market_summary table tr th {
        white-space: nowrap;
        font-size: 12px;
    }

    .hero_section_option p {
        font-size: 13px;
        max-width: 100%;
    }

    .option_highlight_section p {
        font-size: 13px;
    }

    .why_trade_option p {
        font-size: 13px;
        padding-top: 4px;
    }

    .trade_strengths_bl::before {
        display: none;
    }

    .why_trade_option {
        text-align: center;
    }

    .learn_btn button {
        padding: 6px 28px;
        font-size: 13px;
    }

    .learn_btn button img {
        width: 11px;
    }

    .futures_options_s {
        overflow: scroll;
    }

    .futures_options_s table {
        margin-top: 0px;
    }

    .why_trade_options {
        max-width: 280px;
        float: none;
        margin: 0 auto;
        padding: 5px 0px 20px;
    }

    .trade_strengths_bl .nav li button.nav-link {
        font-size: 13px;
        padding: 6px 24px;
    }

    .trade_strengths_bl .nav {
        gap: 10px;
        justify-content: center;
        margin: 15px 0px;
    }

    .trade_strengths_bl .tab-content {
        margin-top: 35px;
    }

    .coin_options_bl {
        padding: 0px 20px 10px;
        margin-bottom: 24px;
    }

    .why_trade_option.trade_anywhere_s {
        padding: 0px 0px 20px;
    }

    .social_button {
        gap: 10px;
        margin-top: 10px;
        justify-content: center;
    }

    .social_btn a {
        padding: 4px 12px;
        gap: 7px;
        text-align: left;
    }

    .social_btn a .btn_cnt {
        font-size: 13px;
        line-height: 16px;
    }

    .social_btn a .btn_cnt span {
        font-size: 9px;
    }

    .social_btn img {
        width: 16px;
    }

    .start_trading_options {
        margin: 10px 0px;
    }

    .start_trading_options .tradenow_btn button {
        padding: 7px 20px;
        font-size: 13px;
    }

    .option_highlight_section .row {
        flex-direction: column;
    }

    .option_highlight_section {
        padding: 30px 0px 30px;
        text-align: center;
    }

    .option_highlight_section .row .col-sm-3 {
        width: 100%;
    }

    .d-flex.topnav_selected {
        flex-direction: column;
    }

    .topnav_selected .nav-tabs {
        width: 100%;
    }

    .right_top_r {
        padding: 0px 13px;
        width: 100%;
    }

    .orderbook_lightbox {
        right: inherit;
        padding: 18px;
    }

    .data_option_calls table tr th {
        white-space: nowrap;
        padding: 10px 15px;
    }

    .recent_trades_options table tr td {
        padding: 10px 15px;
        font-size: 12px;
    }

    .portal_chat_top {
        padding: 0px 20px;
    }

    .top_barcalls_put_cnt ul {
        white-space: nowrap;
        overflow: scroll;
        justify-content: space-around;
    }

    .h1,
    h1 {
        font-size: 24px;
    }

    h2 {
        font-size: 20px;
    }

    .orders_leftside h2 {
        font-size: 20px;
    }

    .algo_orders_outers .orders_leftside .nav-tabs li .nav-link {
        padding: 11px 12px;
        font-size: 14px;
    }

    .morebtn_right button {
        padding: 6px 16px;
    }

    .algo_detail_summary_left h5 {
        font-size: 14px;
    }

    .options_section ul {
        gap: 15px;
        margin-top: 15px;
        overflow: scroll;
    }

    .strategies_form {
        font-size: 18px;
        padding: 24px;
        width: 100%;
    }

    .placebtn button {
        padding: 12px 20px;
        font-size: 16px;
    }

    .algo_orders_outers .nav-tabs li .nav-link {
        font-size: 14px;
    }

    .portal_chat_top ul li a {
        font-size: 14px;
    }

    .section_trading .dropdown-toggle {
        padding: 7px 14px;
        font-size: 15px;
    }

    .section_trading .price {
        font-size: 18px;
    }

    .options_section ul li button {
        font-size: 14px;
    }

    .d-flex.justify_currency {
        font-size: 15px;
    }

    .request_quote_btn button {
        font-size: 15px;
        padding: 13px 0px 13px;
    }

    .refresh_cntr {
        width: 42px;
    }

    .total_balance {
        font-size: 14px;
    }

    span.green {
        font-size: 15px;
    }

    .d-flex.top_bar_hd h4 {
        font-size: 20px;
    }

    .submitbtn {
        font-size: 15px;
        padding: 8px 15px;
    }

    .trade_summary_table_lft.esay_option_table h2 {
        margin: 15px 0px;
    }

    .portal_chat_top ul {
        justify-content: start;
    }

    .portal_chat_top ul li {
        font-size: 13px;
    }

    .row.prediction_row {
        flex-direction: column;
        gap: 24px;
    }

    .prediction_detail {
        min-height: 100%;
    }

    .prediction_detail ul {
        gap: 32px;
        margin-top: 30px;
    }

    .fill_cnt {
        padding: 20px 0px 0px;
    }

    .row.prediction_row .col-sm-4 {
        width: 100%;
    }

    .prediction_top_s {
        padding: 20px 0px;
    }

    .buy_sell_option {
        padding: 30px 0px 40px;
    }

    .buy_sell_option .row {
        flex-direction: column;
        gap: 24px;
    }

    .buy_sell_option .row .col-sm-4 {
        width: 100%;
    }

    button.bn-button.button__buy {
        font-size: 14px;
        padding: 7px 10px;
        border-radius: 6px;
    }

    .search_form .modal-body {
        padding: 20px !important;
    }

    .trade_summary_table_lft .tab-content {
        min-height: 60px;
    }

    .trade_summary_table_lft .nav-tabs {
        gap: 5px;
        white-space: nowrap;
        flex-wrap: nowrap;
        overflow: auto;
    }

    .price_top_right {
        font-size: 14px;
    }

    .price_top_right span {
        font-size: 12px;
    }

    .prediction_detail ul li img {
        width: 42px;
    }


    .modal.currency_popup_s.crosstabs .modal-dialog {
        max-width: 100%;
        min-width: 100%;
        margin: 0 auto;
    }

    body {
        font-size: 14px;
    }

    .prediction_detail ul.nav-tabs {
        flex-wrap: nowrap;
        white-space: nowrap;
        overflow: scroll;
    }

    .buy_sell_option .nav-tabs li button.nav-link {
        font-size: 14px;
        padding: 5px 10px;
    }

    .buy_sell_option .nav-tabs {
        margin-top: 18px;
        white-space: nowrap;
        flex-wrap: nowrap;
        overflow: scroll;
    }

    .trade_summary_table_lft tr th {
        padding: 6px 15px;
        white-space: nowrap;
    }

    .account_hd_div {
        margin-top: 0px;
    }

    .createblock_form>.tab-content {
        margin-top: 20px;
    }

    .createblock_form .creatblock_left_inquery .nav-tabs li .nav-link {
        font-size: 15px;
        padding: 12px;
    }

    .creatblock_left_inquery .tab-content {
        padding: 24px;
    }

    .buyform form .row {
        row-gap: 20px;
    }

    .creatblock_left_inquery .form_input input {
        font-size: 14px;
        padding: 10px 15px;
    }

    .creatblock_left_inquery .form_input.fullsize select {
        padding: 10px 15px;
    }

    .submitbtn button {
        font-size: 15px;
        padding: 12px 10px;
    }

    .createblock_form .row {
        gap: 24px;
    }

    .markert_overview_right ul {
        padding-top: 15px;
        gap: 15px;
    }

    .notfound_vector {
        max-width: 120px;
        margin: 30px auto;
    }

    .table_info_data table tr th {
        font-size: 12px;
    }

    .table_info_data table tr.totaltb td.danger {
        font-size: 15px;
    }

    .trade_movers_tb button.nav-link {
        font-size: 12px;
    }

    .top_cross_dashboard ul li a {
        padding: 6px 12px 6px;
        font-size: 12px;
    }

    .top_cross_dashboard ul {
        gap: 10px;
    }

    .option_datatable_bl .buy_sell_row_price .scroll_y {
        height: 225px !important;
        overflow-x: auto;
    }

    body .top_future_left_s {
        overflow: inherit;
    }

    .future_mobile_tab_content.table_info_data .buy_sell_row {
        padding: 0px;
    }

    .market_spot_form .buysell_btn button {
        padding: 6px 14px;
        font-size: 12px;
    }


    .modal.currency_popup_s .btn-close {
        font-size: 8px;
        padding: 5px;
    }

}

@media screen and (max-width:660px) {

    .top_bar_usd_future {
        align-items: normal;
        flex-direction: column;
        gap: 15px;
    }

    body .price_top_right {
        font-size: 16px;
    }

    .hero_section_option h1 br {
        display: none;
    }

    .price_top_right {
        font-size: 12px;
    }

    .hero_section_option p {
        margin-top: 5px;
    }

    .hero_section_option ul {
        align-items: start;
    }

    .heading2 {
        font-size: 19px;
    }

    .heading2 br {
        display: none;
    }

    .trade_strengths_bl::before {
        display: none;
    }

    .top_future_left_s ul li {
        font-size: 9px;
    }

    .trade_option_bl .row {
        gap: 24px;
    }

    .createblock_form .nav-tabs li .nav-link {
        font-size: 13px;
    }

    .modal.currency_popup_s.crosstabs p {
        font-size: 12px;
        line-height: 20px;
    }

    .btnsupport button {
        font-size: 12px;
        padding: 6px 24px;
    }

    .currency_popup_s h4 {
        font-size: 18px;
    }

    .trade_option_bl .row .col-sm-6 {
        width: 100%;
    }

    .buy_sell_option h5 {
        font-size: 18px;
    }

    .hide_underlying_s {
        justify-content: start;
        padding: 10px 10px 0px;
        margin-bottom: 15px;
    }

    .top_future_left_s {
        width: 100%;
    }

    .top_future_right_s {
        width: 100%;
    }

    .trade_summary_table_lft .nav-tabs {
        gap: 5px;
    }

    .prediction_up img.prediction_vector {
        min-height: 120px;
        width: 150px;
    }

    .prediction_up {
        gap: 15px;
    }

    .buysell_btn button {
        padding: 4px 18px;
        font-size: 11px;
    }

}


@media screen and (max-width:480px) {

    .hero_section_option ul li h4 {
        font-size: 11px;
    }

    .relative_select_right {
        padding: 7px 10px !important;
    }

    .order_trade_s .price_card_head {
        justify-content: start;
        gap: 5px !important;
    }

    .product_header.ms-auto {
        gap: 5px;
    }


    .product_header button {
        font-size: 11px;
        gap: 4px;
    }

    .product_name {
        gap: 5px;
        font-size: 11px;
    }

    .product_data_info table tr td {
        font-size: 9px !important;
    }

    .product_data_info table tr td span {
        font-size: 10px;
    }

    .leverage_bl>div {
        gap: 7px;
        font-size: 12px;
        padding: 8px;
    }

    .hero_section_option p {
        font-size: 12px;
    }

    .option_datatable_bl .price_inputbl ul li button {
        font-size: 9px;
        padding: 1px 2px !important;
    }

    .option_datatable_bl .price_info .buysell_btn {
        flex-direction: row;
    }

    .costbtc_total h5 {
        font-size: 11px;
    }

    .price_inputbl ul {
        overflow: auto;
        padding-bottom: 7px;
    }

    .position_order .position_list {
        gap: 7px;
    }

    .trade_movers_tb ul.nav-tabs {
        gap: 4px;
    }

    .trade_movers_tb button.nav-link {
        font-size: 11px;
        padding: 5px 5px;
    }

    .coin_options_bl h3 {
        font-size: 18px;
    }

    .option_highlight_section p {
        font-size: 12px;
    }

    .option_highlight_section .software_trading_cnt p {
        font-size: 12px;
    }

    .hero_section_option ul {
        gap: 5px;
    }

    .why_trade_option p {
        font-size: 12px;
    }

    .futures_options_s table tbody td {
        font-size: 12px;
    }

    .why_trade_option p {
        font-size: 12px;
        margin-bottom: 10px;
    }

    .mrkt_trde_tab {
        font-size: 11px;
    }

    .price_card_head {
        overflow: auto;
        white-space: nowrap;
    }

    .price_card_head>div {
        width: auto !important;
    }

}


@media screen and (max-width:360px) {

    .trade_movers_tb button.nav-link {
        font-size: 10px;
        padding: 4px 4px;
    }

    .mrkt_trde_tab {
        font-size: 10px;
        overflow: auto;
    }

}

.data_option_calls table tr.active {
    border: 1.5px solid #fbe5ac !important;
}

.relative_select_right .nav-tabs-check .nav-link-check.active#buy-tab {
    color: #fff !important;
    background: #01BC8D !important;
}

.relative_select_right .nav-tabs-check .nav-link-check {
    /* transform: skewX(-20deg); */
    text-align: center;
    padding: 6px 0;
    border: none !important;
    background-color: #ffffff0f;
    border-radius: 2px;
    font-size: 12px;
    color: currentColor !important;
    transition: unset !important;
    width: 100%;
    display: block;
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/FuturesAndOptions/OptionHome.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;;;;IAMI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,eAAe;IACf,sCAAsC;IACtC,mCAAmC;IACnC,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,mBAAmB;IACnB,+BAA+B;IAC/B,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,cAAc;IACd,YAAY;IACZ,kCAAkC;IAClC,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kCAAkC;IAClC,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,SAAS;AACb;;;;AAIA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;;;AAIA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,kBAAkB;;AAEtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,eAAe;IACf,qBAAqB;IACrB,gCAAgC;IAChC,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;IACT;;uCAEmC;AACvC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,wCAAwC;IACxC,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,wCAAwC;IACxC,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,sCAAsC;IACtC,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;IAC7B,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;;AAGA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;;AAGA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,QAAQ;IACR,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,aAAa;AACjB;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,+BAA+B;IAC/B,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,SAAS;IACT,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,4BAA4B;IAC5B,kCAAkC;IAClC,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,eAAe;AACnB;;;;AAIA;;IAEI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kCAAkC;IAClC,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;;;AAGA;IACI,oCAAoC;AACxC;;;AAGA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,cAAc;IACd,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;;AAGA;IACI,aAAa;IACb,WAAW;IAEX,8BAA8B;IAE9B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mCAAmC;IACnC,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IAEb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mCAAmC;IACnC,uBAAuB;IACvB,sCAAsC;IACtC,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,4BAA4B;IAC5B,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,oBAAoB;IACpB,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,wCAAwC;AAC5C;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iCAAiC;IACjC,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,SAAS;IACT,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;AACf;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;;;;;AAMA;IACI,WAAW;AACf;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;;;AAIA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,OAAO;IACP,UAAU;IACV,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;IACX,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,cAAc;IACd,6BAA6B;IAC7B,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,UAAU;IACV,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;;AAGA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,yBAAyB;IACzB,yBAAyB;IACzB,QAAQ;IACR,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,6BAA6B;IAC7B,iBAAiB;IACjB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,QAAQ;IACR,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,kCAAkC;IAClC,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;;;GAGG;;AAEH;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;;;AAIA;IACI,iCAAiC;IACjC,wEAAwE;IACxE,4BAA4B;IAC5B,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0EAA0E;IAC1E,WAAW;AACf;;AAEA;IACI,sEAAsE;AAC1E;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gFAAgF;AACpF;;AAEA;IACI,gFAAgF;AACpF;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,uFAAuF;IACvF,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;IACtB,yDAA4E;IAC5E,4BAA4B;IAC5B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,WAAW;IACX,SAAS;IACT,wBAAwB;IACxB,yDAA6E;IAC7E,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,SAAS;IACT,UAAU;IACV,wBAAwB;IACxB,yDAA+E;IAC/E,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,uFAAuF;IACvF,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,kFAAkF;IAClF,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,4DAA4D;AAChE;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;IACf,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,gBAAgB;QAChB,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,gBAAgB;IACpB;;AAEJ;;AAEA;;IAEI;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,yCAAyC;QACzC,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,mBAAmB;IACvB;;IAEA;;;;;;QAMI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,sBAAsB;IAC1B;;AAEJ;;AAEA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,gBAAgB;IACpB;;;IAGA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,SAAS;QACT,cAAc;IAClB;;IAEA;QACI,UAAU;QACV,cAAc;QACd,mBAAmB;IACvB;;AAEJ;;AAEA;;IAEI;QACI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;IAClB;;;IAGA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,YAAY;QACZ,UAAU;QACV,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,QAAQ;QACR,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,gBAAgB;IACpB;;;IAGA;QACI,cAAc;QACd,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,cAAc;IAClB;;AAEJ;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;;;IAGI;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;;IAGA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,YAAY;QACZ,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;;;IAIA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,eAAe;QACf,mBAAmB;QACnB,6BAA6B;QAC7B,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,2BAA2B;IAC/B;;IAEA;QACI,sBAAsB;QACtB,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAS;QACT,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,UAAU;QACV,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,cAAc;QACd,SAAS;IACb;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;QACnB,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,WAAW;QACX,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,uBAAuB;QACvB,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;WAEO;;IAEP;QACI,oBAAoB;IACxB;;IAEA;QACI,SAAS;QACT,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,gBAAgB;QAChB,aAAa;QACb,8BAA8B;QAC9B,QAAQ;QACR,kCAAkC;IACtC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;;AAGJ;;;AAGA;;IAEI;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,iCAAiC;QACjC,wCAAwC;QACxC,qBAAqB;QACrB,wBAAwB;IAC5B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA,oDAAoD;IACpD;QACI,cAAc;IAClB;;IAEA;QACI,qBAAqB;QACrB,qDAAqD;IACzD;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,wCAAwC;QACxC,mBAAmB;IACvB;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,qBAAqB;QACrB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,aAAa;QACb,uBAAuB;IAC3B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,SAAS;QACT,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;;QAEI,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,SAAS;QACT,kBAAkB;IACtB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,cAAc;QACd,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,SAAS;QACT,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,SAAS;QACT,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;QACjB,QAAQ;QACR,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,WAAW;IACf;;IAEA;QACI,cAAc;QACd,aAAa;IACjB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,6BAA6B;IACjC;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,aAAa;QACb,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,QAAQ;QACR,mBAAmB;QACnB,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;;IAGA;QACI,eAAe;QACf,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,qBAAqB;QACrB,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,wBAAwB;QACxB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;;IAGA;QACI,cAAc;QACd,YAAY;IAChB;;AAEJ;;AAEA;;IAEI;QACI,mBAAmB;QACnB,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;AAEJ;;;AAGA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,QAAQ;IACZ;;;IAGA;QACI,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,QAAQ;QACR,eAAe;IACnB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;QACR,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,2BAA2B;IAC/B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;AAEJ;;;AAGA;;IAEI;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;AAEJ;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,4BAA4B;IAC5B,WAAW;IACX,cAAc;AAClB","sourcesContent":["img {\n    max-width: 100%;\n}\n\nul {\n    padding: 0px;\n    margin: 0px;\n    list-style: none;\n}\n\na {\n    text-decoration: none;\n}\n\n.container,\n.container-lg,\n.container-md,\n.container-sm,\n.container-xl,\n.container-xxl {\n    max-width: 1380px;\n    padding: 0px 20px;\n}\n\nbody {\n    background-color: #181A20;\n}\n\n.usd_future_dashboard {\n    width: 100%;\n    display: block;\n    background-color: #111114;\n    height: 100%;\n    color: #fff;\n}\n\n.option_datatable_bl #buy_orders .table_info_data {\n    padding: 0px 10px;\n}\n\n.option_datatable_bl #sell_orders .table_info_data {\n    padding: 0px 10px;\n}\n\n.option_datatable_bl #trades .table_info_data {\n    padding: 0px 10px;\n}\n\n.top_bar_usd_future {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    padding: 10px;\n    margin-top: 0px;\n    /* border-bottom: 4px solid #222222; */\n    /* border-top: 1px solid #222222; */\n    align-items: center;\n    background-color: #181A20;\n}\n\n.usd_left_pr {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n}\n\n.price_top_right {\n    font-size: 16px;\n    color: #01BC8D;\n    font-weight: 500;\n    line-height: 19px;\n    display: flex;\n    flex-direction: column;\n    white-space: nowrap;\n}\n\n.price_top_right span {\n    font-size: 14px;\n    font-weight: 400;\n}\n\n.space_gap_0.dashboard_mid_s .dashboard_summary_lft {\n    width: 65%;\n}\n\n.order_trade_s .trade_movers_tb .table-responsive {\n    max-height: 500px;\n}\n\n.space_gap_0.dashboard_mid_s .relative_select_right {\n    max-height: 640px;\n}\n\n.btcusd__currency span {\n    min-width: 18px;\n    height: 18px;\n    border: 1px solid #434343;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50px;\n}\n\n.btcusd__currency {\n    min-width: 130px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-weight: 500;\n}\n\n.top_future_left_s {\n    display: flex;\n    align-items: center;\n    gap: 18px;\n}\n\n.top_future_left_s ul {\n    display: flex;\n    align-items: center;\n    gap: 18px;\n    padding: 0px;\n    margin: 0px;\n    list-style: none;\n}\n\n.top_future_left_s ul li span {\n    color: #6C6C6C;\n}\n\n.top_future_left_s ul li {\n    font-size: 13px;\n}\n\n.top_future_left_s ul li span.yellow {\n    color: hsl(33, 97%, 58%);\n}\n\n.top_future_right_s {\n    text-align: right;\n}\n\n\n.market_highlight_section .table-responsive {\n    min-height: 100px;\n    max-height: 220px;\n}\n\n.top_future_right_s ul {\n    padding: 0px;\n    margin: 0px;\n    list-style: none;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.top_future_right_s ul li {\n    color: #f3f3f39c;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 12px;\n    padding-right: 12px;\n    border-right: 1px solid #222222;\n    line-height: 10px;\n    border-radius: 2px;\n    padding: 5px 8px;\n    background-color: #22242c;\n    min-width: 90px;\n    border: 1px solid #22242c;\n    font-size: 12px;\n}\n\n.top_future_right_s ul li button {\n    background: none;\n    border: none;\n    padding: 0px;\n}\n\n.top_future_right_s ul li:last-child {\n    border: none;\n}\n\n.dashboard_mid_s {\n    width: 100%;\n    display: flex;\n}\n\n.dashboard_mid_s .dashboard_summary_lft {\n    max-width: 1270px;\n}\n\n.classic_favorites_bl .col-sm-2 .order_trade_s {\n    width: 100%;\n    height: 100%;\n}\n\n.top_hd_s {\n    width: 16%;\n    padding: 0px;\n    background: #181A20;\n    border: none;\n    border-radius: 0px;\n    overflow: hidden;\n    -webkit-backdrop-filter: blur(5px);\n    backdrop-filter: blur(5px);\n    position: relative;\n    color: #fffffff2;\n}\n\n.order_book_info {\n    width: 100%;\n}\n\n.toggle_dotted {\n    width: 10px;\n    cursor: pointer;\n}\n\n.orderbook_lightbox .form-check {\n    font-size: 14px;\n}\n\n.orderbook_lightbox {\n    color: #fff;\n}\n\n.orderbook_lightbox {\n    width: 250px;\n    display: none;\n    position: absolute;\n    top: 30px;\n    right: 0px;\n    z-index: 666;\n    background-color: #3c3c3c;\n    padding: 24px;\n    border-radius: 10px;\n    border: 1px solid #494949;\n}\n\n.orderbook_lightbox.active {\n    display: block;\n}\n\n.orderbook_lightbox h6 {\n    font-size: 13px;\n    font-weight: 400;\n    padding-bottom: 10px;\n}\n\n.orderbook_lightbox .d-flex.gap-3 {\n    flex-direction: column;\n}\n\n.top_hd_s h2 {\n    font-size: 15px;\n    margin: 0px;\n    background-color: #1B1B1B;\n    padding: 6px 15px;\n    font-weight: 400;\n}\n\n.order_top_table_grid {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n    padding: 10px 10px 0px;\n}\n\n.order_top_table_grid ul.togglebtn {\n    display: flex;\n    gap: 12px;\n}\n\n.order_top_table_grid ul.togglebtn li {\n    border: 1px solid #3B3B3B;\n    border-radius: 3px;\n    display: flex;\n    padding: 1px 3px;\n    align-items: center;\n    justify-content: center;\n}\n\n.order_right_toggle ul {\n    display: flex;\n    gap: 15px;\n}\n\n.order_right_toggle ul li {\n    font-size: 12px;\n    color: #787878;\n}\n\n.table_info_data table {\n    font-size: 12px;\n    width: 100%;\n    /* height: 0% !important; */\n}\n\n.table_info_data table tr th {\n    padding: 3px 10px;\n    color: #636363;\n    font-weight: 400;\n}\n\n.table_info_data table tr td {\n    padding: 3px 10px;\n    color: #e9e9e9;\n}\n\n.table_info_data table tr td.danger {\n    color: #F65454;\n}\n\n.table_info_data table tr.totaltb td.danger {\n    font-size: 18px;\n}\n\n.table_info_data table tr .subtotal {\n    text-align: center;\n    color: #999;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.table_info_data table tr td.sucess {\n    color: #01BC8D;\n}\n\n.table_info_data table tr .subtotal span {\n    border: 2px solid #3B3B3B;\n    border-radius: 3px;\n    margin-right: 5px;\n    font-weight: 700;\n    color: #666666;\n    font-size: 10px;\n    padding: 1px 2px;\n    /* align-items: center; */\n    justify-content: center;\n}\n\n.trade_movers_tb ul.nav-tabs {\n    background-color: #181A20;\n    border-radius: 0px;\n    border-color: #ffffff12;\n    padding-top: 4px;\n}\n\n.trade_movers_tb button.nav-link.active {\n    background-color: transparent;\n    border: none;\n    border-bottom: 2px solid #fff !important;\n    color: #fff;\n}\n\n.trade_movers_tb button.nav-link {\n    font-size: 14px;\n    margin: 0px;\n    color: #949AA4;\n    border: none;\n    border-bottom: 2px solid #ffffff00;\n    padding: 6px 15px;\n    font-weight: 400;\n}\n\n.trade_movers_tb button.nav-link:hover {\n    border: none;\n    outline: none;\n}\n\n.relative_select_right {\n    background-color: #22222200;\n}\n\n.flex_right_option {\n    display: flex;\n    gap: 5px;\n    height: 85%;\n}\n\n.flex_right_option .order_trade_s {\n    width: 40%;\n}\n\n.flex_right_option .relative_select_right {\n    width: 60%;\n}\n\n.data_option_calls {\n    border: 1px solid #ffffff12;\n    border-radius: 10px;\n}\n\n.selected_product_info {\n    width: 100%;\n    display: flex;\n    border-bottom: 1px solid #ffffff12;\n    margin-bottom: 20px;\n    padding-bottom: 10px;\n    flex-direction: column;\n    gap: 15px;\n}\n\n\n\n.product_data_info table tr td {\n    font-size: 11px;\n    color: #8e9298;\n    text-align: right;\n    padding: 0px;\n}\n\n.product_data_info table tr td span {\n    display: block;\n    font-size: 12px;\n    color: #fff;\n}\n\n.product_data_info table tr {\n    display: flex;\n    justify-content: space-between;\n}\n\n.product_flex {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.product_name {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    line-height: 15px;\n    font-size: 14px;\n    color: #d5d5d5;\n}\n\n.product_name svg {\n    width: 18px;\n    height: 16px;\n}\n\n.product_name svg path {\n    fill: #f3bb2b;\n}\n\n.product_header button {\n    background-color: transparent;\n    border: none;\n    padding: 0px;\n    display: flex;\n    color: #f0f0f0;\n    font-size: 12px;\n    font-weight: 200;\n    gap: 7px;\n    align-items: center;\n}\n\n.product_header button span {\n    color: #acacac;\n}\n\n.product_header button path {\n    fill: #eeeeee;\n}\n\n.product_header.ms-auto {\n    display: flex;\n    gap: 24px;\n    align-items: center;\n}\n\n\n\n.top_cross_dashboard {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 4px 0px;\n}\n\n.top_cross_dashboard ul {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    justify-content: space-between;\n}\n\n.top_cross_dashboard ul li {\n    width: 100%;\n    display: block;\n}\n\n.top_cross_dashboard ul li a {\n    background-color: #2B313C;\n    padding: 5px 12px 6px;\n    color: #d3d3d3;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    list-style: none;\n    text-decoration: none;\n    font-size: 13px;\n    border: none;\n    border-radius: 5px;\n\n}\n\n.copy_icon {\n    max-width: 15px;\n}\n\n.spot_future_ {\n    width: 100%;\n    background-color: #121212;\n    padding: 0px 15px;\n    margin-top: 7px;\n}\n\n.spot_future_ ul {\n    display: flex;\n    gap: 10px;\n}\n\n.spot_future_ ul li a {\n    color: #999;\n    font-size: 13px;\n    text-decoration: none;\n    border-bottom: 1px solid #121212;\n    display: block;\n    padding: 10px 4px;\n    font-weight: 500;\n}\n\n.spot_future_ ul li span {\n    color: #01BC8D;\n    background-color: #102621;\n    padding: 4px;\n    border-radius: 5px;\n}\n\n.spot_future_ ul li.active a {\n    color: #fff;\n    border-bottom: 1px solid #01BC8D;\n}\n\n.leverage_bl {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    padding: 0px 0px;\n    gap: 12px;\n    /* background-color: #121212;\n    border-top: 10px solid #222222;\n    border-bottom: 5px solid #222222; */\n}\n\n.leverage_bl>div {\n    background-color: #2B313C;\n    border-radius: 4px;\n    width: 100%;\n    gap: 14px;\n    font-size: 12px;\n    font-weight: 500;\n    padding: 8px 20px;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n}\n\n.leverage_bl .rage_txt {\n    color: #5F5F5F;\n}\n\n.leverage_bl div.plustext {\n    width: auto;\n    padding: 8px 6px;\n}\n\n.market_spot_form {\n    width: 100%;\n}\n\n.market_spot_form .nav-tabs {\n    background-color: #121212;\n    border: none;\n}\n\n.market_spot_form .nav-tabs li button {\n    border: none;\n    background-color: transparent !important;\n    color: #6C6C6C !important;\n    font-size: 12px;\n    font-weight: 500;\n}\n\n.market_spot_form .nav-tabs li button.active {\n    color: #01bc8d !important;\n}\n\n.market_spot_form .nav-tabs li a {\n    border: none;\n    background-color: transparent !important;\n    color: #6C6C6C !important;\n    font-size: 13px;\n    font-weight: 500;\n}\n\n.market_spot_form .nav-tabs li a.active {\n    color: #fff !important;\n}\n\n.market_spot_form .nav-tabs li .dropdown-menu li a {\n    color: #000 !important;\n}\n\nform.price_info {\n    min-height: 100px;\n    max-height: 410px;\n    width: 100%;\n    padding: 0px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.price_inputbl {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n}\n\n.price_inputbl label {\n    font-size: 12px;\n    color: #F2F4F6;\n    font-weight: 400;\n}\n\n.relative_select_right .price_select_option {\n    background-color: #2B313C;\n    border-color: #2d303a00;\n    border-radius: 4px;\n    padding: 8px;\n    display: flex;\n    justify-content: space-between;\n}\n\n.price_inputbl .inputtype {\n    border: none;\n    background-color: transparent;\n    padding-left: 2px;\n    color: #fff;\n    font-weight: 400;\n}\n\n.price_inputbl select {\n    border: none;\n    background-color: transparent;\n    color: #999;\n    font-size: 12px;\n}\n\n.price_inputbl label span {\n    color: #ababab;\n}\n\n.price_inputbl ul {\n    display: flex;\n    gap: 4px;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.price_inputbl ul li button {\n    font-size: 12px;\n    border-radius: 0px;\n    border: 1px solid #2d303a00 !important;\n    font-weight: 200;\n    width: 100%;\n    position: relative;\n    text-align: center;\n    background-color: transparent;\n    color: #ababab;\n    padding: 0px !important;\n}\n\n.price_inputbl ul li button:before {\n    width: 7px;\n    background-color: #393F4F;\n    height: 7px;\n    position: absolute;\n    content: \"\";\n    border-radius: 50px;\n    border: 1px solid #393F4F;\n    left: 0px;\n    top: -15px;\n}\n\n.price_inputbl ul li.active button:before {\n    width: 14px;\n    background-color: #393f4f;\n    height: 14px;\n    border: 2px solid #F2F4F6;\n    top: -19px;\n}\n\n.price_inputbl ul li:last-child button:before {\n    left: inherit;\n    right: 0px;\n}\n\n.avail_total_usd {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 12px;\n}\n\n.tpsl_reduce {\n    font-size: 13px;\n    color: #6C6C6C;\n}\n\n.price_inputbl.mt-2 {\n    padding-bottom: 20px !important;\n}\n\nul.btnlimit {\n    display: flex;\n    margin: 15px 0px;\n    gap: 12px;\n}\n\nul.btnlimit li button {\n    width: 100%;\n    padding: 4px 0px;\n    border: none;\n    font-size: 13px;\n    background: none;\n    color: #fff;\n    font-weight: 200;\n}\n\nul.btnlimit li button.active {\n    color: #f3bb2b;\n}\n\n.buysell_btn button {\n    width: 100%;\n    padding: 6px 32px;\n    background-color: #5EBA89;\n    border: none;\n    font-size: 14px;\n    font-weight: 400;\n    color: #fff;\n    border-radius: 50px;\n}\n\n.buysell_btn button.sellbtn {\n    background-color: #ed5765;\n}\n\n.costbtc_total h5 {\n    font-size: 12px;\n    color: #949AA4;\n    margin: 0px;\n}\n\n.classic_grid_dashboard_bl.d-flex.option_datatable_bl .d-flex.topnav_selected {\n    padding: 16px 0px 0px;\n}\n\n.costbtc_total h5 span {\n    color: #fff;\n}\n\n.price_inputbl .inputtype:focus-visible {\n    outline: none;\n}\n\n.trade_account_summary_assets {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n}\n\n.trade_account_summary_assets {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    background-color: #121212;\n    margin-top: 4px;\n}\n\n.position_order .position_list {\n    border-bottom: 1px solid #454C59;\n    gap: 15px;\n    display: flex;\n}\n\n.position_order .position_list li button {\n    border-radius: 0px;\n    border: none;\n    background-color: transparent;\n    font-size: 13px;\n    white-space: nowrap;\n    font-weight: 400;\n    padding: 5px 10px;\n    color: #9f9f9f;\n}\n\n.trade_summary_table_lft .nav-tabs {\n    border-bottom: 1px solid #282828;\n    gap: 15px;\n}\n\n.position_order .cnt_table {\n    display: none;\n}\n\n.position_order .cnt_table.active {\n    display: flex;\n}\n\n.trade_summary_table_lft .nav-tabs li button {\n    border-radius: 0px;\n    border: none;\n    background-color: transparent;\n    font-size: 13px;\n    font-weight: 400;\n    padding: 5px 10px;\n    color: #9f9f9f;\n}\n\n\n.trade_summary_table_lft .nav-item.active button {\n    color: #fff;\n}\n\n.trade_summary_table_lft .nav-tabs li button.active {\n    color: #fff;\n}\n\n.trade_summary_table_lft .tab-content {\n    min-height: 260px;\n    display: flex;\n    align-items: start;\n    justify-content: center;\n}\n\n.trade_summary_table_lft .tab-content h4 {\n    font-size: 14px;\n    margin: 0px;\n}\n\n.notfound_vector p {\n    color: #fff !important;\n}\n\n\n.assets_right {\n    width: 23.46%;\n    background-color: #181A20;\n    /* padding: 7px; */\n}\n\n\n.assets_right h2 {\n    font-size: 14px;\n    margin-left: 0px;\n    padding: 5px 0px;\n}\n\n.no-data p {\n    font-size: 14px;\n    padding-top: 10px;\n}\n\n.trade_summary_table_lft tr th .num-div .num-select {\n    padding: 0px 10px !important;\n}\n\n.asset_total_value {\n    padding: 5px 0px;\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n}\n\n.asset_total_value h5 {\n    color: #fff;\n    font-weight: 500;\n}\n\n.asset_total_value div {\n    font-size: 12px;\n}\n\n.asset_total_value div h6 {\n    font-size: 12px;\n    margin: 0px;\n    color: #767676;\n}\n\n.danger {\n    color: #F65454 !important;\n}\n\nspan.green {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    color: #00B47D;\n}\n\n.buy_transferbtn {\n    gap: 8px;\n    margin: 10px 0px 30px;\n}\n\n.buy_transferbtn button {\n    font-size: 12px;\n    background-color: #2A2A2A;\n    color: #fff;\n    border: none;\n    padding: 7px 18px;\n    width: 100%;\n    border-radius: 50px;\n}\n\n.top_future_right_s ul li img {\n    min-width: 20px;\n}\n\n.search_form {\n    width: 100%;\n    border: 1px solid #c7c7c7;\n    padding: 5px;\n    border-radius: 5px;\n    gap: 10px;\n}\n\n.search_form input {\n    border: none;\n    width: 100%;\n}\n\n.search_form input:focus-visible {\n    outline: none;\n}\n\n.bn-tabs_favorites_bl button.nav-link {\n    border: none;\n    padding: 0px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #626262;\n    line-height: 22px;\n}\n\n.bn-tabs_favorites_bl li a {\n    border: none;\n    padding: 0px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #626262;\n    line-height: 22px;\n}\n\n.bn-tabs_favorites_bl li a:focus {\n    border: none;\n}\n\n.bn-tabs_favorites_bl li a:hover {\n    border: none;\n}\n\n.bn-tabs_favorites_bl li a.active {\n    border: none;\n}\n\n.bn-tabs_favorites_bl ul {\n    border: none;\n    margin: 10px 0px;\n}\n\n.modal.currency_popup_s .modal-dialog {\n    max-width: 620px;\n}\n\n.currency_data_list {\n    color: #181818;\n}\n\n.currency_data_list table {\n    width: 100%;\n}\n\n.currency_data_list table tr td {\n    font-size: 14px;\n    padding: 8px 0px;\n}\n\n.currency_data_list table tr th {\n    font-size: 14px;\n    padding: 5px 0px;\n    font-weight: 400;\n}\n\n.currency_data_list table h6 {\n    margin: 0px;\n    font-size: 14px;\n}\n\n.currency_data_list table p {\n    margin: 0px;\n}\n\n.cnt_first_t {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.cnt_first_t .icon_currency {\n    display: flex;\n    gap: 5px;\n    align-items: center;\n}\n\n.cnt_first_t .icon_currency img {\n    width: 22px;\n}\n\n.cnt_first_t .icon_currency svg {\n    width: 20px;\n    height: auto;\n}\n\n.no_data_found {\n    width: 100%;\n    display: block;\n    text-align: center;\n    padding: 70px 0px;\n    color: #000;\n}\n\n.no_data_found svg {\n    width: 100px;\n}\n\n.no_data_found svg path {\n    fill: #000;\n}\n\n.top_future_left_s ul li.dropdown ul.dropdown-menu {\n    display: none;\n}\n\n.top_future_left_s ul li.dropdown ul.dropdown-menu.dropdown-menu.show {\n    display: flex;\n    flex-direction: column;\n    gap: 9px;\n    align-items: normal;\n    padding: 10px;\n}\n\n\n.top_tabs_center {\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n    color: #222;\n    font-size: 13px;\n    font-weight: 500;\n    align-items: center;\n}\n\n.classic_option_top {\n    width: 100%;\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    padding: 0px;\n}\n\n.leftbar_classic {\n    width: auto;\n}\n\n.leftbar_classic ul {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n}\n\n.leftbar_classic ul li a {\n    width: 40px;\n    height: 46px;\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #121212;\n}\n\n.leftbar_classic ul li a:hover {\n    background-color: #2A2310;\n}\n\n.leftbar_classic ul li rect {\n    fill: #fff;\n}\n\n.leftbar_classic ul li.active a {\n    background-color: #2A2310;\n}\n\n.leftbar_classic ul li.active rect {\n    fill: #FEBA00;\n}\n\n.classic_usd_right {\n    width: 100%;\n}\n\n.classic_usd_right ul {\n    display: flex;\n    gap: 18px;\n}\n\n.classic_option_top .classic_usd_right ul li {\n    padding: 0px;\n}\n\n.classic_option_top .classic_usd_right ul li.active button {\n    border: 1px solid #f3bb2b;\n}\n\n.classic_usd_right ul li button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #22242c;\n    border: 1px solid #22242c;\n    font-size: 13px;\n    color: #a2a2a2;\n    min-width: 105px;\n    gap: 5px;\n    padding: 4px 10px;\n    border-radius: 2px;\n}\n\n.succes {\n    color: #01BC8D !important;\n}\n\n.classic_usd_right .cnt_top_cl {\n    text-align: left;\n}\n\n.classic_usd_right ul li:first-child {\n    background-color: #444444;\n    color: #fff;\n}\n\n.classic_usd_right ul li .cnt_top_cl h6 {\n    margin: 0px;\n    font-size: 12px;\n}\n\n.classic_usd_right ul li .cnt_top_cl p span {\n    padding-left: 20px;\n}\n\n.classic_usd_right ul li .cnt_top_cl p {\n    margin: 0px;\n}\n\n.classic_usd_right ul li img {\n    max-width: 24px;\n}\n\n.classic_grid_dashboard_left {\n    width: 100%;\n}\n\n.classic_favorites_bl {\n    width: 100%;\n    border-top: 1px solid #f3f3f329;\n    margin: 0px;\n    padding-top: 15px;\n}\n\n.classic_favorites_bl .trade_movers_tb .table_info_data {\n    height: auto;\n}\n\n.classic_favorites_bl .order_trade_s .table-trade {\n    padding: 0px 10px;\n}\n\n.classic_favorites_bl .order_trade_s .table_info_data table tr th {\n    font-size: 11px;\n}\n\n.classic_favorites_bl .table_info_data table tr.totaltb td.danger {\n    font-size: 12px;\n}\n\n\n.classic_favorites_bl .order_trade_s .table_info_data table tr td {\n    font-size: 12px;\n    padding: 3px 0px !important;\n}\n\n.topnav_selected .date_tbl {\n    border: none;\n    display: flex;\n    gap: 15px;\n    overflow: auto;\n    padding-bottom: 5px;\n}\n\n.topnav_selected .date_tbl .nav-link {\n    border: none;\n    color: #f3f3f39c;\n    border-radius: 2px;\n    padding: 5px 10px;\n    background-color: #22242c;\n    min-width: 80px;\n    border: 1px solid #22242c;\n    font-size: 12px;\n    white-space: nowrap;\n}\n\n.topnav_selected .date_tbl .nav-link:hover {\n    /* border: none; */\n    /* border: 1px solid #f3bb2b; */\n    background-color: #2d303a;\n}\n\n.topnav_selected .date_tbl .nav-link.active {\n    background-color: #22242c;\n    color: #fff;\n    border: 1px solid #f3bb2b;\n}\n\n.d-flex.topnav_selected {\n    padding: 15px 0px 0px;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.right_top_r {\n    display: flex;\n    gap: 20px;\n    padding-right: 32px;\n    position: relative;\n}\n\n.right_top_r .form-check {\n    font-size: 13px;\n    color: #f3f3f39c;\n    margin: 0px;\n}\n\n.right_top_r .orderbook_lightbox form .d-flex {\n    flex-direction: column;\n}\n\n.displayed_reset {\n    padding: 13px 0px;\n}\n\n.displayed_reset h6 {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.displayed_reset h6 span {\n    color: #f0b90b;\n}\n\n.decimal_text {\n    font-size: 12px;\n    color: #b3b3b3;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.decimal_text p {\n    margin: 0px;\n    font-size: 15px;\n}\n\n.classic_favorites_bl .col-sm-9 .tab-content {\n    border-top: 1px solid #f3f3f329;\n    padding: 0px !important;\n}\n\n.top_barcalls_put_cnt {\n    border-bottom: 1px solid #f3f3f329;\n}\n\n.top_barcalls_put_cnt ul {\n    display: flex;\n    align-items: center;\n    gap: 40px;\n    padding: 15px 0px;\n    justify-content: space-evenly;\n}\n\n.top_barcalls_put_cnt ul li {\n    font-size: 13px;\n    color: #c5c5c5;\n}\n\n.top_barcalls_put_cnt ul li strong {\n    color: #fff;\n}\n\n\n.option_datatable_bl .data_option_calls table tr th {\n    font-size: 12px;\n    font-weight: 400;\n    color: #999;\n    padding: 8px 10px !important;\n    border-bottom: 1px solid #f3f3f329;\n    background-color: #111114 !important;\n}\n\n.data_option_calls table tr {\n    background-color: #030303;\n}\n\n.data_option_calls table tr:hover {\n    background: rgb(58 62 73 / 6%);\n    cursor: pointer;\n}\n\n\n\n.data_option_calls table tr td {\n\n    font-size: 12px;\n    font-weight: 400;\n    height: 50px;\n    color: #ffffff;\n    padding: 8px 10px;\n    border-bottom: 1px solid #f3f3f329;\n}\n\n.data_option_calls table tr td.text-succes {\n    color: #01BC8D;\n}\n\n.data_option_calls table tr td.danger {\n    color: #F65454;\n}\n\n.top_table_data .mid_data tr td {\n    height: 50px;\n    color: #fff;\n    font-weight: 500;\n    background-color: #111114;\n}\n\n.classic_favorites_bl .order_trade_s .table_info_data table tr td.right_alien {\n    text-align: right;\n    padding-right: 5px !important;\n}\n\n.classic_favorites_bl .order_trade_s .table_info_data table tr th.right_alien {\n    text-align: right;\n}\n\n.data_option_calls table {\n    width: 100%;\n}\n\n.recent_tables_outer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.tables_calls {\n    width: 100%;\n}\n\n.tables_puts {\n    width: 100%;\n}\n\n.recent_trades_options table {\n    width: 100%;\n    font-size: 13px;\n}\n\n.recent_trades_options table tr th {\n    font-size: 12px;\n    font-weight: 400;\n    color: #999;\n    padding: 15px;\n    border-bottom: 1px solid #494949;\n}\n\n.recent_trades_options table tr td {\n    font-weight: 400;\n    padding: 15px;\n    border-bottom: 1px solid #494949;\n}\n\n.recent_trades_options {\n    width: 100%;\n    padding-top: 20px;\n}\n\n.recent_trades_options h6 {\n    font-size: 12px;\n    color: #999;\n    padding: 0px 15px;\n}\n\n.classic_favorites_bl .trade_summary_table_lft .nav-tabs li button {\n    padding: 10px;\n}\n\n.classic_favorites_bl .trade_summary_table_lft {\n    width: 100%;\n    overflow: hidden;\n}\n\n.hide_underlying_s {\n    display: flex;\n    justify-content: end;\n    padding-right: 30px;\n    gap: 5px;\n    align-items: center;\n    font-size: 13px;\n    color: #999;\n}\n\n.trade_summary_table_lft .row {\n    align-items: center;\n}\n\n.option_account_right {\n    width: 100%;\n    border-left: 1px solid #f3f3f32b;\n    height: 100%;\n}\n\n.trade_option_bl {\n    width: 100%;\n    margin: 0px;\n    padding: 32px;\n    background-color: #222222;\n    text-align: center;\n}\n\n.classic_favorites_bl>.col-sm-9 {\n    padding: 0px;\n}\n\n.classic_favorites_bl>.col-sm-3 {\n    padding: 0px;\n}\n\n.option_account_right h2 {\n    font-size: 15px;\n}\n\n.trade_option_bl p {\n    font-size: 12px;\n    margin: 0px;\n    max-width: 220px;\n    margin: 5px auto;\n}\n\n.data_option_calls.mobile_data_table {\n    display: none;\n}\n\n.option_block {\n    width: 100%;\n    border-radius: 4px;\n    cursor: pointer;\n    padding: 16px;\n    background-color: #454545;\n}\n\n.option_block span {\n    font-size: 12px;\n}\n\n.youtube_icon {\n    max-width: 50px;\n    margin: 0 auto;\n    margin-top: 13px;\n}\n\n.trade_option_bl .row {\n    padding-top: 20px;\n}\n\n.account_block_s {\n    width: 100%;\n    padding: 24px 32px;\n}\n\n.account_tabs_info {\n    width: 100%;\n    display: block;\n    border-bottom: 1px solid #f3f3f32b;\n    padding-bottom: 20px;\n    margin-top: 20px;\n}\n\n.account_tabs_info h5 {\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.account_tabs_info ul {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-top: 12px;\n    font-size: 12px;\n}\n\n.account_tabs_info .cnt_ac.hide {\n    display: none;\n}\n\n.account_tabs_info ul a {\n    color: #a3a3a3;\n    font-size: 13px;\n}\n\n\n.video_popup .modal-dialog {\n    max-width: 750px;\n}\n\n.video_popup .modal-content {\n    background-color: #242526;\n    border-radius: 24px;\n    padding: 5px 12px;\n}\n\n.video_popup .btn-close {\n    border-radius: 50px !important;\n    background-color: #fff;\n    opacity: 1;\n}\n\n.video_popup .modal-header {\n    border: none;\n}\n\n.easy_option_dashboard {\n    background-color: #121212;\n}\n\n.easy_mode_back {\n    width: 100%;\n    padding-top: 18px;\n}\n\n.easy_mode_back a {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: #d9d9d99c;\n}\n\n.easy_mode_back svg {\n    width: 20px;\n}\n\n.prediction_top_s {\n    width: 100%;\n    padding: 55px 0px;\n    text-align: center;\n    color: #D9D9D9;\n}\n\n.prediction_bl {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.prediction_up {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 32px;\n}\n\n.prediction_bl p a {\n    color: #FEBA00;\n}\n\n.prediction_bl p {\n    margin: 0px;\n}\n\n.bn_steps_step {\n    width: 100%;\n    position: relative;\n    margin: 20px 0px 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.bn_steps_step::before {\n    width: 100%;\n    height: 5px;\n    position: absolute;\n    content: \"\";\n    background-color: #222222;\n}\n\n.bn_steps_step .number {\n    width: 28px;\n    height: 28px;\n    background-color: #222;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50px;\n    font-size: 14px;\n    font-weight: 500;\n    position: relative;\n}\n\n.prediction_detail {\n    width: 100%;\n    padding: 24px;\n    min-height: 250px;\n    border-radius: 10px;\n    background-color: #222222;\n    color: #fff;\n}\n\n.prediction_detail ul {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 48px;\n    margin-top: 70px;\n}\n\n.prediction_detail ul.nav-tabs {\n    margin-top: 28px;\n    border: none;\n    justify-content: start;\n    gap: 20px;\n}\n\n.prediction_detail ul li {\n    cursor: pointer;\n}\n\n.prediction_detail ul.nav-tabs li button {\n    padding: 0px;\n    background-color: transparent;\n    border: none;\n    font-size: 14px;\n    color: #D9D9D9;\n    font-weight: 500;\n}\n\n.prediction_detail ul.nav-tabs li button.active {\n    background-color: transparent;\n    color: #FEBA00;\n}\n\n.prediction_detail ul.nav-tabs li button:focus-visible {\n    box-shadow: none;\n}\n\n.prediction_detail .tab-content .tab-pane {\n    margin-top: 22px;\n}\n\n.trade_summary_table_lft tr th {\n    font-size: 14px;\n    font-weight: 500;\n    color: #999;\n    border-color: #ffffff00;\n    padding: 8px 15px;\n}\n\n.trade_summary_table_lft tr td {\n    font-size: 13px;\n    font-weight: 500;\n    color: #999;\n    padding: 8px 15px;\n}\n\n.trade_summary_table_lft table {\n    width: 100%;\n}\n\n.trade_summary_table_lft .tab-content>.tab-pane {\n    width: 100%;\n}\n\n.trade-wrapper .trade_account_summary_assets .trade_summary_table_lft table tr td {\n    padding: 10px !important;\n    font-weight: 400 !important;\n}\n\n\nbody .trade_account_summary_assets .bg-dark {\n    background-color: #2b313c !important;\n}\n\n\n.fill_cnt {\n    width: 100%;\n    display: block;\n    padding: 40px 0px;\n    color: #d9d9d99c;\n    text-align: center;\n}\n\n.esay_option_table {\n    width: 100%;\n    overflow: hidden;\n    padding: 0px 20px;\n}\n\n.trade_summary_table_lft.esay_option_table h2 {\n    color: #fff;\n    margin: 32px 0px;\n}\n\n.trade_summary_table_lft.esay_option_table .nav-tabs {\n    border: none;\n    padding-bottom: 10px;\n}\n\n.top_th_easyop {\n    border-bottom: 1px solid #282828;\n}\n\n.esay_option_table thead {\n    border-bottom: 1px solid #282828;\n}\n\n.notfound_vector {\n    max-width: 190px;\n    margin: 0 auto;\n    margin: 60px auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n}\n\n.buy_sell_option {\n    width: 100%;\n    display: block;\n    padding: 40px 0px 70px;\n    color: #fff;\n}\n\n.buy_sell_option h5 {\n    font-size: 20px;\n    font-weight: 400;\n    color: #D9D9D9;\n}\n\n.buy_sell_option .nav-tabs {\n    border-bottom: none;\n    margin-top: 32px;\n}\n\n.buy_sell_option .nav-tabs li button.nav-link {\n    font-size: 16px;\n    color: #848e9c;\n    border-radius: 0px;\n    border: none;\n}\n\n.buy_sell_option .nav-tabs li button.nav-link.active {\n    background-color: #5f38074d;\n    color: #e4a456;\n}\n\n\n.probability_option .title-container {\n    display: flex;\n    width: 100%;\n    -webkit-box-pack: justify;\n    justify-content: space-between;\n    -webkit-box-align: center;\n    align-items: center;\n}\n\n.probability_option .extra-button {\n    border-radius: 16px;\n    background-color: rgb(252, 213, 53);\n    color: rgb(24, 26, 32);\n    font-size: 13px;\n    line-height: 16px;\n    padding: 4px 8px;\n    font-weight: 600;\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n}\n\n.relative_select_right .limit_tabs button {\n    padding: 6px 0;\n    /* background-color: transparent; */\n    border: none !important;\n    background-color: #ffffff00 !important;\n    border-radius: 2px;\n    font-size: 12px;\n    color: #949AA4;\n    transition: unset !important;\n    width: 100%;\n    display: block;\n}\n\n.relative_select_right .limit_tabs {\n    gap: 15px;\n    display: flex;\n    flex-wrap: nowrap;\n    border: none;\n    margin: 8px 0px 10px;\n    border-bottom: 1px solid #454C59 !important;\n}\n\n.relative_select_right .limit_tabs li.active button {\n    color: #fff;\n    border-bottom: 2px solid #fff !important;\n}\n\n.relative_select_right .nav-tabs .nav-link.active#buy-tab {\n    color: #fff !important;\n    background: #5EBA89 !important;\n}\n\n.relative_select_right .limit_tabs .selltab.active button {\n    color: #fff !important;\n    background: #ed5765 !important;\n}\n\n.buysell_heder .limit_tabs li.selltab.active button::before {\n    background: #ed5765 !important;\n}\n\n.probability_option .extra-button svg {\n    margin-left: 4px;\n    width: 15px;\n}\n\n.probability_option .title {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 22px;\n    color: rgb(234, 236, 239);\n}\n\n.probability_option {\n    margin: 0px;\n    min-width: 0px;\n    background-color: rgb(43, 49, 57);\n    padding: 16px;\n    border-radius: 8px;\n    cursor: pointer;\n    flex-basis: 100%;\n    border: 1px solid transparent;\n}\n\n.probability_option ul {\n    display: flex;\n    justify-content: space-between;\n    gap: 5px;\n    flex-direction: column;\n    margin-top: 12px;\n}\n\n.probability_option ul li {\n    display: flex;\n    justify-content: space-between;\n    font-size: 12px;\n    gap: 12px;\n    color: #969696;\n    align-items: start;\n}\n\n.probability_option ul li .value {\n    font-size: 14px;\n    width: 50%;\n    font-weight: 500;\n    color: #fff;\n    display: flex;\n    flex-direction: column;\n    align-items: end;\n}\n\n.probability_option ul li .value:first-child {\n    align-items: start;\n}\n\n.buy_sell_option .tab-content {\n    margin-top: 24px;\n}\n\n.probability_option:hover {\n    border: 1px solid #fcd535;\n}\n\n.prediction_up img.prediction_vector {\n    min-height: 170px;\n}\n\n.algo_orders_outers .nav-tabs {\n    border-bottom: none;\n}\n\n.algo_orders_outers .nav-tabs li .nav-link {\n    font-size: 16px;\n    color: #d9d9d9c9;\n    border: none;\n    border-radius: 0px;\n}\n\n.algo_orders_outers .nav-tabs li .nav-link.active {\n    background-color: transparent;\n    color: #fff;\n}\n\n.topbar_order {\n    justify-content: space-between;\n    gap: 32px;\n    align-items: center;\n    padding: 7px 20px 7px 0px;\n}\n\n.portal_chat_top {\n    width: 50%;\n}\n\n.portal_chat_top ul {\n    display: flex;\n    justify-content: end;\n    gap: 30px;\n    color: #fff;\n}\n\n.portal_chat_top ul li a {\n    display: flex;\n    gap: 10px;\n    color: #fff;\n    font-size: 16px;\n    align-items: center;\n}\n\n.algo_detail_summary {\n    width: 100%;\n    padding: 24px 15px 15px;\n    color: #fff;\n}\n\n.algo_detail_summary p {\n    color: #d9d9d9c9;\n}\n\n.orders_leftside {\n    width: 100%;\n}\n\n.orders_leftside h2 {\n    font-size: 32px;\n}\n\n.orders_leftside .nav-tabs {\n    width: 100%;\n    overflow: hidden;\n    background-color: #222222;\n    border-radius: 10px;\n    margin: 20px 0px;\n}\n\n.orders_leftside .nav-tabs li {\n    width: 50%;\n    text-align: center;\n}\n\n.algo_detail_summary .row {\n    margin-top: 24px;\n}\n\n.algo_orders_outers .orders_leftside .nav-tabs li .nav-link {\n    width: 100%;\n    padding: 22px 15px;\n    border-radius: 10px;\n    color: #fff;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n}\n\n.algo_orders_outers .orders_leftside .nav-tabs li .nav-link.active {\n    background-color: #25B070;\n}\n\n.algo_orders_outers .orders_leftside .nav-tabs li.buytab .nav-link img {\n    transform: rotate(-90deg);\n}\n\n\n.amount_info_del {\n    width: 100%;\n    background-color: #222222;\n    border-radius: 8px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 24px;\n}\n\n.algo_detail_summary_left {\n    display: flex;\n    flex-direction: column;\n    gap: 30px;\n}\n\n.algo_detail_summary_left h5 {\n    color: #C1C9D5;\n    font-weight: 400;\n    margin: 0px;\n}\n\n.pricebtn button {\n    font-size: 12px;\n    background-color: #FEBA00;\n    border: none;\n    padding: 4px 16px;\n    border-radius: 4px;\n    font-weight: 700;\n}\n\n.pricebtn button.blackbtn {\n    background-color: #000;\n    color: #fff;\n}\n\n.amount_info_del.coloum_reverse {\n    flex-direction: row-reverse;\n}\n\n.price_step {\n    width: 100%;\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n}\n\n.price_step::before {\n    width: 100%;\n    position: absolute;\n    left: 0px;\n    content: \"\";\n    background-color: #5A5B5C;\n    height: 5px;\n    top: 38%;\n}\n\n.price_step div {\n    margin-top: 40px;\n    position: relative;\n    font-size: 14px;\n    color: #C1C9D5;\n}\n\n.price_step div button:before {\n    width: 16px;\n    height: 16px;\n    background-color: #5A5B5C;\n    position: absolute;\n    right: 0px;\n    top: -22px;\n    content: \"\";\n}\n\n.placebtn button {\n    width: 100%;\n    background-color: #FEBA00;\n    border: none;\n    border-radius: 8px;\n    padding: 22px 20px;\n    font-size: 24px;\n    font-weight: 500;\n}\n\n.price_step div button {\n    padding: 0px;\n    background-color: transparent;\n    border: none;\n    color: #fff;\n}\n\n.algo_order_right {\n    width: 100%;\n}\n\n.top_right_cnt {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.left_price_summary h2 {\n    font-weight: 400;\n}\n\n.left_price_summary p {\n    color: #47A663;\n    line-height: 15px;\n    margin: 15px 0px 0px;\n    display: block;\n    font-weight: 500;\n}\n\n.left_price_summary p span {\n    margin-left: 8px;\n    background-color: #1E1E1E;\n    border: 1px solid #ffffff1f;\n    padding: 3px 8px;\n    border-radius: 5px;\n    color: #fff;\n}\n\n.morebtn_right button {\n    background-color: #1E1E1E;\n    border: 1px solid #ffffff1f;\n    padding: 9px 16px;\n    border-radius: 5px;\n    color: #fff;\n}\n\n.order_summary_graphchat {\n    width: 100%;\n    margin-top: 40px;\n}\n\n.option_symbol_s {\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    margin-top: 30px;\n}\n\n.options_section {\n    width: 100%;\n}\n\n.options_section h6 {\n    font-size: 20px;\n    color: #D9D9D9;\n    font-weight: 400;\n}\n\n.options_section ul {\n    display: flex;\n    gap: 24px;\n    margin-top: 15px;\n}\n\n.options_section ul li button {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    font-size: 20px;\n    color: #494949;\n    border: 1px solid #494949;\n    border-radius: 13px;\n    padding: 12px 16px;\n    font-weight: 600;\n    background-color: transparent;\n}\n\n.options_section ul li button.active {\n    color: #fff;\n}\n\n.strategies_cate ul {\n    justify-content: space-between;\n}\n\n.strategies_cate ul li {\n    width: 100%;\n}\n\n.strategies_cate ul li button {\n    width: 100%;\n}\n\n.spot_trading_block {\n    width: 822px;\n    margin: 0 auto;\n    max-width: 100%;\n}\n\n.d-flex.top_bar_hd {\n    justify-content: space-between;\n    align-items: center;\n}\n\n.d-flex.top_bar_hd h4 {\n    font-size: 24px;\n    font-weight: 400;\n}\n\n.setting_icon button {\n    background-color: transparent;\n    border: none;\n}\n\n\n\n\n\n.option_block a {\n    color: #fff;\n}\n\ntr.green_light {\n    background-color: #1b2a2a !important;\n}\n\ntr.danger_light {\n    background-color: #2f1e26 !important;\n}\n\n\n\n.section_trading .dropdown {\n    position: relative;\n    display: inline-block;\n    width: 200px;\n}\n\n.section_trading .dropdown-toggle {\n    background-color: #2F2F2F;\n    color: #ffffff;\n    padding: 10px 14px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n    border: 1px solid #444;\n}\n\n.section_trading .dropdown-toggle .left {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.section_trading .dropdown-toggle img.token-icon {\n    width: 24px;\n    height: 24px;\n}\n\n.section_trading .dropdown-menu {\n    display: none;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    background-color: #1c1c1c;\n    border-radius: 10px;\n    margin-top: 8px;\n    width: 100%;\n    border: 1px solid #444;\n    z-index: 999;\n}\n\n.section_trading .dropdown-menu .item {\n    padding: 10px 14px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: #fff;\n    cursor: pointer;\n}\n\n.section_trading .dropdown-menu .item:hover {\n    background-color: #333;\n}\n\n.section_trading .dropdown-menu img {\n    width: 22px;\n    height: 22px;\n}\n\n.section_trading .dropdown-menu.show {\n    display: block;\n}\n\n.d-flex.justify_currency {\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    font-size: 18px;\n}\n\n.d-flex.justify_currency p {\n    color: #717A8C;\n    margin: 0px;\n}\n\n.section_trading {\n    background-color: #222222;\n    padding: 26px;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.section_trading .price {\n    font-size: 26px;\n    color: #717A8C;\n}\n\n.trading_info_bl {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    gap: 12px;\n    margin-top: 20px;\n}\n\n.refresh_cntr {\n    width: 98px;\n    position: absolute;\n    margin: 0 auto;\n    left: 0;\n    right: 0px;\n    top: 33%;\n    transform: translateY(-40%);\n}\n\n.total_balance {\n    font-size: 18px;\n    color: #717A8C;\n    text-align: right;\n}\n\n.request_quote_btn button {\n    font-size: 22px;\n    background-color: #feba008f;\n    width: 100%;\n    border: none;\n    border-radius: 12px;\n    padding: 18px 0px 20px;\n}\n\n.request_quote_btn {\n    margin-top: 10px;\n}\n\n.option_block_outer {\n    width: 100%;\n    color: #fff;\n    padding: 20px 40px;\n}\n\n.option_block_outer h1 {\n    font-size: 32px;\n}\n\n.option_block_process {\n    width: 100%;\n    display: block;\n    padding: 20px 0px;\n    border: 1px solid #575757;\n    border-radius: 35px;\n    padding: 40px;\n    margin-top: 40px;\n}\n\n.option_block_process ul {\n    display: flex;\n    gap: 50px;\n    justify-content: space-between;\n}\n\n.option_block_process ul li span {\n    font-size: 20px;\n    margin-bottom: 10px;\n    display: block;\n}\n\n.option_block_process ul li h2 {\n    font-size: 22px;\n    font-weight: 400;\n}\n\n.option_block_process ul li p {\n    color: #999999;\n    margin: 0px;\n}\n\n.createblock_form {\n    width: 100%;\n    display: block;\n    padding: 115px 0px 40px;\n}\n\n.createblock_form .nav-tabs {\n    border: none;\n}\n\n.createblock_form .nav-tabs li .nav-link {\n    font-size: 18px;\n    color: #C1C9D5;\n    font-weight: 600;\n    border: none;\n    border-radius: 12px;\n}\n\n.createblock_form .nav-tabs li .nav-link.active {\n    background-color: #222222;\n    color: #fff;\n}\n\n.createblock_form>.tab-content {\n    margin-top: 50px;\n}\n\n.creatblock_left_inquery {\n    width: 100%;\n    overflow: hidden;\n    border-radius: 32px;\n    background-color: #474747;\n}\n\nh5.mobile {\n    padding: 10px 15px 0px;\n    font-size: 18px;\n    display: none;\n}\n\n.createblock_form .creatblock_left_inquery .nav-tabs {\n    border: none;\n    justify-content: space-between;\n    flex-direction: row;\n    display: flex;\n    flex-wrap: nowrap;\n}\n\n.createblock_form .creatblock_left_inquery .nav-tabs li {\n    width: 100%;\n}\n\n.createblock_form .creatblock_left_inquery .nav-tabs li .nav-link {\n    width: 100%;\n    font-size: 22px;\n    border-radius: 0px;\n    padding: 20px 15px;\n}\n\n.creatblock_left_inquery .tab-content {\n    padding: 40px;\n}\n\n.creatblock_left_inquery .form_input {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    gap: 15px;\n    padding-right: 15px;\n    align-items: center;\n    border: 1px solid #5E5E5E;\n    border-radius: 15px;\n}\n\n.creatblock_left_inquery .form_input input {\n    font-size: 20px;\n    width: 100%;\n    color: #C1C9D5;\n    background-color: transparent;\n    border: none;\n    padding: 15px;\n}\n\n.creatblock_left_inquery .form_input input:focus-visible {\n    outline: none;\n    border: none;\n}\n\n.creatblock_left_inquery .form_input select {\n    background-color: transparent;\n    border: none;\n    font-size: 18px;\n    color: #fff;\n}\n\n.creatblock_left_inquery .form_input select option {\n    color: #000;\n}\n\n.creatblock_left_inquery .form_input select:focus-visible {\n    outline: none;\n    border: none;\n}\n\n.creatblock_left_inquery .form_input.fullsize select {\n    padding: 15px;\n    width: 100%;\n    color: #7b7b7b;\n}\n\n.buyform form .row {\n    row-gap: 32px;\n}\n\n.submitbtn button {\n    font-size: 22px;\n    background-color: #caab2e;\n    border-radius: 15px;\n    color: #000;\n    padding: 18px 10px;\n    border: none;\n    width: 100%;\n    font-weight: 600;\n}\n\n.createblock_form .submitbtn {\n    background-color: transparent;\n    padding: 0px;\n    border-radius: 0px;\n}\n\n.markert_overview_right {\n    width: 100%;\n    border: 1px solid #575757;\n    padding: 32px;\n    border-radius: 32px;\n    height: 100%;\n}\n\n.markert_overview_right ul {\n    padding-top: 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px\n}\n\n.markert_overview_right ul li {\n    color: #C1C9D5;\n    font-size: 18px;\n    display: flex;\n    justify-content: space-between;\n}\n\n.markert_overview_right ul li:last-child {\n    padding-top: 36px;\n}\n\n.strategies_form {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 10px;\n    font-size: 20px;\n    color: #494949;\n    border: 1px solid #494949;\n    border-radius: 13px;\n    padding: 36px;\n    font-weight: 600;\n    background-color: transparent;\n    width: 600px;\n    margin: 0 auto;\n}\n\n.strategies_form form {\n    width: 100%;\n    margin-top: 12px;\n}\n\n.strategies_form h4 {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    font-size: 18px;\n}\n\n.strategies_form form .op_traders_step {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n}\n\n.search_currency .modal-content {\n    background-color: #222222;\n}\n\n.search_currency .modal-header {\n    border-bottom: none;\n}\n\n.search_currency .search_form {\n    border: 1px solid #474747;\n}\n\n.search_currency .search_form input {\n    background-color: transparent;\n    border: none;\n}\n\n.rightdata_s.mobileview {\n    display: none;\n}\n\n.Currency_list_select {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    margin-top: 24px;\n    max-height: 260px;\n    overflow: auto;\n}\n\n.currency_item {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    gap: 15px;\n}\n\n.text-succes {\n    color: #01BC8D;\n}\n\n.currency_item h5 {\n    font-size: 15px;\n    font-weight: 400;\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n    margin: 0px;\n}\n\n.search_currency button.btn-close {\n    background-color: #fff;\n    opacity: 1;\n    border-radius: 50px;\n    font-size: 12px;\n    top: -13px;\n    position: relative;\n    right: -4px;\n}\n\n.currency_item h5 span {\n    font-size: 13px;\n}\n\n.currency_item img.token-icon {\n    width: 30px;\n    border-radius: 50px;\n}\n\n.op_traders_step .input_block {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n}\n\n.op_traders_step .input_block label {\n    font-size: 14px;\n    color: #fff;\n    min-width: 100px;\n    color: #c4c4c4;\n}\n\n.op_traders_step .input_block .select_option {\n    width: 100%;\n    background-color: transparent;\n    border: 1px solid #494949;\n    border-radius: 6px;\n    padding: 8px;\n    font-size: 14px;\n}\n\n.mobile_view {\n    display: none;\n}\n\n.input_inserst {\n    width: 100%;\n    background-color: transparent;\n    border: 1px solid #494949;\n    border-radius: 6px;\n    padding: 8px;\n    font-size: 14px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.input_inserst input {\n    background-color: transparent;\n    border: none;\n    width: 80%;\n    color: #999;\n}\n\ninput:focus-visible {\n    outline: none;\n}\n\n.submitbtn {\n    background-color: #fcd535;\n    border: none;\n    font-weight: 600;\n    font-size: 18px;\n    padding: 10px 15px;\n    border-radius: 8px;\n}\n\n\n.toggle_righsidebar {\n    width: 300px;\n    color: #c9c9c9;\n    position: absolute;\n    right: 0px;\n    background-color: #1e2329;\n    border: 1px solid #2b3139;\n    top: 0px;\n    padding: 16px;\n    display: none;\n}\n\n.toggle_righsidebar::before {\n    width: 299px;\n    background-color: #1e2329;\n    position: fixed;\n    content: \"\";\n    height: 100%;\n    bottom: 0px;\n    right: 0;\n}\n\n.toggle_righsidebar.active {\n    display: block;\n}\n\n.top_hd svg {\n    width: 18px;\n}\n\n.closebtn {\n    cursor: pointer;\n}\n\n.top_sidebar_main {\n    position: relative;\n}\n\n.top_hd {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    position: relative;\n    justify-content: space-between;\n}\n\n.top_hd .leftcnt {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.top_hd h4 {\n    font-size: 16px;\n    margin: 0px;\n    display: flex;\n    gap: 5px;\n}\n\n.sidebartabs .nav-tabs {\n    flex-wrap: nowrap;\n    border: none;\n}\n\n.sidebartabs .nav-tabs li {\n    width: 100%;\n}\n\n.sidebartabs .nav-tabs .nav-link {\n    color: #848e9c;\n    border: none;\n    font-size: 15px;\n    width: 100%;\n    border-radius: 50px;\n    padding: 4px 15px;\n}\n\n.sidebartabs .nav-tabs .nav-link.active {\n    background-color: #feba00;\n    color: #000;\n    font-weight: 500;\n}\n\n.bn_bubble_content {\n    font-size: 13px;\n    background-color: #feba001a;\n    display: inline-block;\n    padding: 2px 5px;\n    border-radius: 4px;\n    color: #feba00;\n    margin: 5px 0px;\n}\n\n.sidebartabs {\n    margin-top: 12px;\n    font-size: 14px;\n}\n\n.avbl_usdt .d-flex {\n    gap: 5px;\n}\n\n.evenodd_icon svg {\n    width: 20px;\n}\n\n.evenodd_icon svg path {\n    color: #feba00;\n}\n\n.price_stbs .price {\n    display: flex;\n    gap: 5px;\n}\n\n.price_stbs .price svg {\n    width: 18px;\n}\n\n.bn_textField_inp {\n    display: flex;\n    justify-content: space-between;\n    gap: 15px;\n    background-color: #2b3139;\n    border-radius: 7px;\n    margin-top: 10px;\n}\n\n.bn_textField_inp input {\n    width: 90%;\n    background-color: transparent;\n    border: none;\n    padding: 10px;\n    color: #999;\n}\n\n.bn_textField_inp .text_primarytext {\n    padding: 10px;\n}\n\n.tif_ios_cnt {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    border-top: 1px solid #2b3139;\n    padding: 20px 0px;\n    border-bottom: 1px solid #2b3139;\n    margin-top: 20px;\n}\n\n.tif_ios_cnt ul {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n}\n\n.tif_ios_cnt ul li a {\n    gap: 0px;\n    display: flex;\n    color: #c9c9c9;\n}\n\n.tif_ios_cnt ul li select {\n    background-color: transparent;\n    border: none;\n    color: #fff;\n}\n\n.tif_ios_cnt ul li select option {\n    color: #000;\n}\n\nbutton.bn-button.button__buy {\n    background-color: #feba00;\n    border: none;\n    font-size: 16px;\n    font-weight: 500;\n    padding: 10px;\n    border-radius: 10px;\n}\n\n.toggle_righsidebar .account_block_s {\n    padding: 0px;\n}\n\n.toggle_righsidebar .account_tabs_info h5 {\n    font-size: 16px;\n}\n\n.toggle_righsidebar .account_tabs_info ul {\n    font-size: 13px;\n}\n\n.account_tabs_info ul li {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 15px;\n    color: #c9c9c9;\n}\n\n.account_hd_div {\n    margin-top: 20px;\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    justify-content: space-between;\n}\n\n.account_currency_cate {\n    margin: 10px 0px;\n    overflow: auto;\n}\n\n.account_currency_cate ul {\n    display: flex;\n    gap: 15px;\n    flex-direction: row;\n    flex-wrap: nowrap;\n}\n\n.account_currency_cate ul li a {\n    font-size: 14px;\n    font-weight: 400;\n}\n\n.account_hd_div svg {\n    width: 20px;\n}\n\n.account_hd_div svg path {\n    fill: #feba00;\n}\n\n.account_hd_div h2 {\n    font-size: 18px;\n}\n\n.dotted_toggle {\n    width: 18px;\n    cursor: pointer;\n}\n\n.togglehide_cnt {\n    position: absolute;\n    width: 200px;\n    padding: 15px;\n    background-color: #1e2329;\n    right: 0px;\n    top: 24px;\n    border: 1px solid #9999993d;\n    border-radius: 10px;\n    display: none;\n}\n\n.togglehide_cnt.active {\n    display: flex;\n}\n\n.togglehide_cnt ul {\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n}\n\n.togglehide_cnt ul li {\n    align-items: center;\n    gap: 7px;\n    display: flex;\n    font-size: 14px;\n}\n\n.modal.currency_popup_s.crosstabs .modal-dialog {\n    max-width: 410px;\n    min-width: 410px;\n    width: 100%;\n}\n\n.modal.currency_popup_s.crosstabs .modal-content {\n    background: #373E4B;\n    border-radius: 15px;\n}\n\n.modal.currency_popup_s.crosstabs .modal-header {\n    border: none;\n    padding-bottom: 0px;\n}\n\n.modal.currency_popup_s .btn-close {\n    background-color: #f3bb2b00;\n    font-size: 11px;\n    opacity: 1;\n    border-radius: 50px;\n}\n\n.modal.currency_popup_s.crosstabs .modal-body {\n    display: flex;\n    justify-content: center;\n    gap: 5px;\n    color: #fff;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    padding: 10px 24px 20px;\n}\n\n.user_identyid {\n    max-width: 120px;\n    margin: 0;\n    margin-bottom: 20px;\n    opacity: 0.7;\n}\n\n.modal.currency_popup_s.crosstabs p {\n    font-size: 12px;\n    line-height: 22px;\n    margin-bottom: 5px;\n    color: #ffffffbf;\n}\n\n.modal.currency_popup_s h3 {\n    font-size: 22px;\n}\n\n.btnsupport {\n    flex-direction: column;\n    width: 100%;\n    gap: 5px;\n}\n\n.btnsupport button {\n    font-size: 16px;\n    padding: 10px 24px;\n    border-radius: 50px;\n    border: none;\n    font-weight: 500;\n    background-color: #f3bb2b;\n}\n\n.btnsupport button.customerbtn {\n    background-color: transparent;\n    border-radius: 0px;\n    color: #f3bb2b;\n}\n\n.modal.currency_popup_s.crosstabs .modal-body.free_rate {\n    align-items: start;\n    text-align: left;\n    padding: 15px 32px 32px;\n}\n\n.modal.currency_popup_s.crosstabs .modal-body.free_rate ul {\n    align-items: start;\n    width: 100%;\n    margin: 10px 0px 24px;\n    flex-direction: column;\n}\n\n.modal.currency_popup_s.crosstabs .modal-body.free_rate ul li {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 16px;\n    width: 100%;\n}\n\n.price_stbs .price a {\n    color: #fff;\n}\n\nbutton.bn-button.button__buy.sellbtn {\n    background-color: #f65454;\n    color: #fff;\n}\n\n.top_table_data {\n    display: flex;\n    justify-content: space-between;\n    align-items: start;\n    border-bottom: 1px solid #f3f3f329;\n    min-height: 500px;\n    max-height: 500px;\n    overflow: auto;\n}\n\n.recent_tables_outer .tables_calls .table-responsive,\n.recent_tables_outer .tables_puts .table-responsive {\n    min-height: 150px;\n    max-height: 150px;\n    overflow: auto;\n}\n\n::-webkit-scrollbar {\n    width: 6px;\n}\n\n::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n    background-color: rgba(255, 255, 255, 0.15);\n    border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(255, 255, 255, 0.25);\n}\n\n/* * {\n    scrollbar-width: thin;\n    scrollbar-color: rgba(255, 255, 255, 0.25) transparent;\n} */\n\n.top_table_data .lefside_data {\n    width: 100%;\n}\n\n.top_table_data .table-responsive {\n    min-height: 100%;\n    max-height: 100%;\n}\n\n.top_table_data .right_data {\n    width: 100%;\n}\n\n.top_table_data .mid_data {\n    min-width: 100px;\n    text-align: center;\n    box-shadow: 0 10px 8px #000000de;\n    position: relative;\n}\n\n.topnav_selected .form-check-label:before {\n    display: none;\n}\n\n.classic_favorites_bl .col-sm-2 .relative_select_right {\n    width: 100%;\n}\n\n.usd_future_dashboard {\n    position: relative;\n    /* z-index: 999; */\n}\n\n.data_option_calls table tr td span {\n    display: block;\n    color: #999;\n    font-size: 10px;\n}\n\n.option_block_outer .esay_option_table {\n    padding: 0px;\n}\n\n\n\n.hero_section_option {\n    background-position: right center;\n    /* background-image: url(/public/images/option_home_img/hero_img.svg); */\n    background-repeat: no-repeat;\n    background-size: 1075px;\n    min-height: 840px;\n    display: flex;\n    align-items: center;\n    color: #fff;\n    background-color: #000000;\n}\n\n.hero_section_option h1 {\n    font-size: 90px;\n    font-weight: 700;\n}\n\n.hero_section_option p {\n    font-size: 22px;\n    margin: 24px 0px 15px;\n    max-width: 85%;\n}\n\n.options_btn {\n    display: flex;\n    gap: 48px;\n    align-items: center;\n}\n\n.options_btn button {\n    background-color: #b1adad20;\n    padding: 19px 48px;\n    border-radius: 50px;\n    font-size: 24px;\n    color: #fff;\n    border: none;\n}\n\n.options_btn button span {\n    color: #FEBA00;\n}\n\n.options_btn button.optionsbg {\n    background: linear-gradient(90deg, rgba(243, 187, 43, 1) 0%, #ff9400 100%);\n    color: #000;\n}\n\n.options_btn button.optionsbg:hover {\n    background: linear-gradient(90deg, rgb(185, 139, 22) 0%, #f0900b 100%);\n}\n\n.hero_section_option ul {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 20px;\n    margin-top: 30px;\n}\n\n.tradenow_btn button:hover {\n    background: linear-gradient(90deg, rgb(201, 150, 22) 0%, rgb(241, 148, 17) 100%);\n}\n\n.learn_btn button:hover {\n    background: linear-gradient(90deg, rgb(201, 150, 22) 0%, rgb(241, 148, 17) 100%);\n}\n\n.hero_section_option ul li h4 {\n    font-size: 22px;\n    color: #ffffff6e;\n    font-weight: 400;\n    margin: 0px;\n    line-height: 180%;\n}\n\n.hero_section_option ul li h4 span {\n    display: block;\n    color: #fff;\n    font-weight: 500;\n}\n\n.market_highlight_section {\n    width: 100%;\n    background-color: #000;\n    padding: 0px 0px 80px;\n    color: #fff;\n}\n\n.heading2 {\n    font-size: 46px;\n    line-height: 130%;\n}\n\n.market_highlight_section .nav li button.nav-link {\n    font-size: 13px;\n    color: #fff;\n    display: flex;\n    border-radius: 50px;\n    padding: 10px 18px;\n    align-items: center;\n    justify-content: center;\n}\n\n.market_highlight_section .nav li button.nav-link.active {\n    background-color: #d9d9d921;\n    box-shadow: 0px 1px 0px #A77B01;\n}\n\n.tradenow_btn button {\n    padding: 13px 20px;\n    border: none;\n    border-radius: 50px;\n    font-size: 20px;\n    font-weight: 400;\n    background: linear-gradient(90deg, rgba(243, 187, 43, 1) 0%, rgba(255, 148, 0, 1) 100%);\n    color: #000;\n}\n\n.market_summary {\n    width: 100% !important;\n    text-align: left;\n    background-size: cover;\n    background-image: url(/public//images/option_home_img/markert_summarybg.svg);\n    background-repeat: no-repeat;\n    border-radius: 10px;\n    padding: 24px 20px;\n}\n\n.slick-track {\n    display: flex !important;\n    gap: 10px;\n}\n\n.market_summary table {\n    width: 100%;\n    margin-top: 20px;\n}\n\n.market_summary table tr th {\n    font-size: 14px;\n    color: #ffffff9f;\n    font-weight: 300;\n    padding: 6px 10px !important;\n}\n\n.market_summary table tr td {\n    font-size: 14px;\n    color: #fff;\n    font-weight: 300;\n    padding: 6px 10px;\n}\n\n.market_summary table tr td.green {\n    color: #01BC8D;\n}\n\n.market_summary h4 {\n    font-weight: 400;\n    font-size: 20px;\n}\n\n.market_highlight_section .tab-content {\n    margin-top: 15px;\n}\n\n.option_highlight_section {\n    padding: 30px 0px 120px;\n    position: relative;\n    background-color: #000;\n    color: #fff;\n}\n\n.option_highlight_section::before {\n    position: absolute;\n    content: \"\";\n    width: 221px;\n    height: 1180px;\n    top: -310px;\n    left: 0px;\n    background-size: contain;\n    background-image: url(/public//images/option_home_img/option_highlightbg.svg);\n    background-repeat: no-repeat;\n}\n\n.trade_strengths_bl::before {\n    position: absolute;\n    content: \"\";\n    width: 220px;\n    height: 1500px;\n    top: -80%;\n    right: 0px;\n    background-size: contain;\n    background-image: url(/public//images//option_home_img//option_highlightbg.svg);\n    background-repeat: no-repeat;\n    transform: rotate(180deg);\n}\n\n.option_highlight_section p {\n    font-size: 22px;\n    font-weight: 300;\n    margin: 20px 0px;\n    color: #ffffffec;\n}\n\n.option_highlight_section .software_trading_cnt p {\n    font-size: 14px;\n    font-weight: 400;\n    margin: 10px 0px 0px;\n    color: #6D7792;\n    line-height: 120%;\n}\n\n.option_highlight_section .row {\n    padding-top: 20px;\n}\n\n.option_highlight_section .container {\n    position: relative;\n    z-index: 999;\n}\n\n.why_trade_option {\n    width: 100%;\n    display: block;\n    position: relative;\n    background-color: #010101;\n    color: #fff;\n    padding: 0px 0px 70px;\n}\n\n.why_trade_option .row {\n    align-items: center;\n    justify-content: center;\n}\n\n.why_trade_option p {\n    font-size: 20px;\n    padding: 15px 0px 5px;\n    font-weight: 300;\n    color: #e9e9e9;\n}\n\n.learn_btn button {\n    padding: 20px 70px;\n    border: none;\n    border-radius: 50px;\n    font-size: 20px;\n    font-weight: 500;\n    background: linear-gradient(90deg, rgba(243, 187, 43, 1) 0%, rgba(255, 148, 0, 1) 100%);\n    color: #000;\n}\n\n.why_trade_options {\n    max-width: 680px;\n    float: right;\n}\n\n.trade_strengths_bl .nav {\n    margin: 30px 0px;\n    gap: 30px;\n}\n\n.trade_strengths_bl .nav li button.nav-link {\n    font-size: 22px;\n    background-color: #b1adad21;\n    padding: 18px 32px;\n    color: #fff;\n    border-radius: 50px;\n}\n\n.tradenow_btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.trade_strengths_bl .nav li button.nav-link.active {\n    background-color: #FBA00D;\n    color: #000;\n}\n\n.coin_options_bl {\n    background: linear-gradient(180deg, rgba(31, 31, 31, 1) 0%, rgba(6, 6, 6, 1) 100%);\n    text-align: center;\n    position: relative;\n    padding: 50px;\n    border-width: 1px;\n    border-style: solid;\n    border-image: linear-gradient(to bottom, #3e3e3e, #000000) 1;\n}\n\n.coin_options_bl::before {\n    width: 160px;\n    height: 160px;\n    background-color: #FEBA00;\n    border-radius: 100%;\n    position: absolute;\n    content: \"\";\n    top: 0px;\n}\n\n.coin_icon {\n    width: 106px;\n    height: 106px;\n    background-color: #FED300;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 100px;\n    border: 4px solid #FBB226;\n    margin: 0 auto;\n    position: relative;\n    top: -40px;\n    margin-top: -60px;\n}\n\n.coin_options_bl h3 {\n    font-size: 30px;\n    font-weight: 700;\n}\n\n.coin_options_bl p {\n    color: #898CA9;\n    font-size: 18px;\n    margin: 0px;\n}\n\n.trade_strengths_bl .tab-content {\n    margin-top: 50px;\n}\n\n.why_trade_option .tab-content .row {\n    padding-top: 50px;\n}\n\n.coin_options_bl::before {\n    width: 160px;\n    height: 160px;\n    background-color: #FEBA00;\n    border-radius: 100%;\n    position: absolute;\n    content: \"\";\n    top: -50px;\n    right: 0px;\n    filter: blur(60px);\n    left: 0px;\n    margin: 0 auto;\n    opacity: 0.6;\n}\n\n.social_button {\n    width: 100%;\n    display: flex;\n    gap: 24px;\n    flex-wrap: wrap;\n    margin-top: 30px;\n}\n\n.qr_code {\n    padding-left: 15px;\n}\n\n.social_btn a {\n    background-color: #24272C;\n    border-radius: 8px;\n    padding: 10px 12px;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    gap: 18px;\n}\n\n.social_btn a .btn_cnt {\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 28px;\n}\n\n.social_btn a .btn_cnt span {\n    font-size: 12px;\n    display: block;\n    font-weight: 400;\n}\n\n.why_trade_option.trade_anywhere_s {\n    padding: 70px 0px;\n}\n\n.start_trading_options {\n    margin: 120px 0px;\n    text-align: center;\n}\n\n.start_trading_options .tradenow_btn button {\n    padding: 18px 36px;\n    font-size: 20px;\n    font-weight: 500;\n    margin-top: 18px;\n}\n\n.futures_options_s table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 20px;\n}\n\n.futures_options_s table thead th {\n    background-color: #161616;\n    color: #fff;\n    font-size: 16px;\n    text-transform: uppercase;\n    padding: 12px;\n    letter-spacing: 1px;\n    text-align: left;\n    border: 1px solid #222222;\n}\n\n.futures_options_s table thead th h4 {\n    font-size: 28px;\n    font-weight: 500;\n    color: #f8f8f8;\n}\n\n.futures_options_s table tbody td {\n    padding: 12px;\n    border: 1px solid #222222;\n    color: #ddd;\n    vertical-align: top;\n}\n\n.futures_options_s table tbody td.first_tbl {\n    white-space: nowrap;\n}\n\n.futures_options_s table tbody tr:nth-child(even) {\n    background-color: #161616;\n}\n\n.market_highlight_section .nav li button.nav-link img {\n    width: 24px;\n    height: 24px;\n    border-radius: 100px;\n    margin-right: 5px;\n}\n\n.hero_img_mobile {\n    display: none;\n}\n\nbutton.mobilebtn {\n    display: none;\n}\n\n.market_spot_form .tab-content>.tab-pane.show {\n    padding-right: 0px;\n}\n\n.market_spot_form .buysell_btn button {\n    padding: 6px 24px;\n    font-size: 14px;\n}\n\n.market_spot_form .price_inputbl.mt-2 {\n    padding-bottom: 20px;\n}\n\n.order_trade_s .price_card_head {\n    opacity: 0.6;\n}\n\n.top_barcalls_put_cnt ul li.nthchild2 {\n    padding-left: 94px;\n}\n\nul.future_mobileview_tabs {\n    display: none;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 10px;\n}\n\n.future_mobile_tab_content.table_info_data .buy_sell_row {\n    padding-top: 0px;\n}\n\nul.future_mobileview_tabs li {\n    font-size: 12px;\n    color: #999;\n    cursor: pointer;\n    border-bottom: 1px solid transparent;\n    padding-bottom: 3px;\n}\n\nul.future_mobileview_tabs li.active {\n    color: #fff;\n    border-bottom: 1px solid #fff;\n}\n\n.future_mobile_tab_content {\n    overflow-y: auto;\n    max-height: 100%;\n}\n\n@media screen and (max-width:1550px) {\n\n    .hero_section_option h1 {\n        font-size: 60px;\n    }\n\n    .hero_section_option p {\n        font-size: 18px;\n        max-width: 70%;\n    }\n\n    .options_btn button {\n        padding: 11px 32px;\n        font-size: 18px;\n    }\n\n    .options_btn {\n        gap: 20px;\n    }\n\n    .hero_section_option ul li h4 {\n        font-size: 18px;\n    }\n\n    .hero_section_option ul {\n        gap: 20px;\n        margin-top: 20px;\n        width: 70%;\n        flex-wrap: wrap;\n    }\n\n    .heading2 {\n        font-size: 38px;\n    }\n\n    .option_highlight_section p {\n        font-size: 18px;\n    }\n\n    .why_trade_option p {\n        font-size: 18px;\n    }\n\n    .learn_btn button {\n        padding: 11px 50px;\n        font-size: 16px;\n    }\n\n    .trade_strengths_bl .nav li button.nav-link {\n        font-size: 18px;\n        padding: 10px 32px;\n    }\n\n    .start_trading_options .tradenow_btn button {\n        padding: 10px 20px;\n        font-size: 16px;\n    }\n\n    .tradenow_btn button {\n        font-size: 18px;\n    }\n\n    .trade_movers_tb button.nav-link {\n        font-size: 12px;\n        padding: 4px 12px;\n    }\n\n    .trade_movers_tb ul.nav-tabs {\n        gap: 8px;\n    }\n\n    .top_future_right_s ul li {\n        min-width: 140px;\n    }\n\n}\n\n@media screen and (max-width:1440px) {\n\n    .market_spot_form .buysell_btn button {\n        padding: 4px 14px;\n        font-size: 13px;\n    }\n\n    .price_inputbl ul {\n        overflow: auto;\n        padding-bottom: 7px;\n    }\n\n    .top_barcalls_put_cnt ul li.nthchild2 {\n        padding-left: 0px;\n    }\n\n    .mrkt_trde_tab {\n        justify-content: space-between !important;\n        font-size: 12px;\n    }\n\n    .classic_favorites_bl .col-sm-2 .relative_select_right {\n        padding: 10px 15px;\n    }\n\n    .data_option_calls table tr th {\n        white-space: nowrap;\n    }\n\n    .coin_options_bl h3 {\n        font-size: 24px;\n    }\n\n\n    .recent_trades_options table tr th {\n        white-space: nowrap;\n    }\n\n    .container,\n    .container-lg,\n    .container-md,\n    .container-sm,\n    .container-xl,\n    .container-xxl {\n        max-width: 95%;\n    }\n\n    .algo_orders_outers .nav-tabs {\n        white-space: nowrap;\n        flex-wrap: nowrap;\n        overflow: auto;\n    }\n\n    .placebtn button {\n        padding: 16px 20px;\n        font-size: 20px;\n    }\n\n    .algo_orders_outers .orders_leftside .nav-tabs li .nav-link {\n        padding: 18px 15px;\n    }\n\n    .request_quote_btn button {\n        font-size: 18px;\n        padding: 16px 0px 20px;\n    }\n\n}\n\n@media screen and (max-width:1366px) {\n\n    .hero_section_option h1 {\n        font-size: 40px;\n    }\n\n    .trade_movers_tb ul.nav-tabs {\n        gap: 5px;\n    }\n\n    .space_gap_0 form.price_info {\n        padding: 0px 0px;\n    }\n\n\n    .assets_right h2 {\n        margin-left: 0px;\n    }\n\n    .asset_total_value {\n        padding: 5px 0px;\n    }\n\n    .hero_section_option p {\n        font-size: 15px;\n    }\n\n    .options_btn button {\n        padding: 9px 24px;\n        font-size: 15px;\n    }\n\n    .hero_section_option ul li h4 {\n        font-size: 15px;\n    }\n\n    .hero_section_option {\n        background-size: 750px;\n        min-height: 560px;\n    }\n\n    .trade_movers_tb button.nav-link {\n        font-size: 12px;\n        padding: 6px 10px;\n    }\n\n    .order_trade_s .price_card_head {\n        gap: 12px;\n        overflow: auto;\n    }\n\n    .top_future_left_s {\n        width: 70%;\n        overflow: auto;\n        white-space: nowrap;\n    }\n\n}\n\n@media screen and (max-width:1200px) {\n\n    .order_trade_s .price_card_head div {\n        width: auto !important;\n    }\n\n    .mrkt_trde_tab {\n        overflow: auto;\n    }\n\n\n    .top_table_data {\n        min-height: 520px;\n    }\n\n    .buysell_btn button {\n        padding: 5px 24px;\n        font-size: 13px;\n    }\n\n    .market_summary table tr th {\n        white-space: nowrap;\n    }\n\n    .option_highlight_section p {\n        font-size: 15px;\n    }\n\n    .dashboard_mid_s.space_gap_0.pa_2 .price_info .price_inputbl {\n        padding-bottom: 0px;\n    }\n\n    .why_trade_option p {\n        font-size: 15px;\n    }\n\n    .learn_btn button {\n        padding: 9px 36px;\n        font-size: 15px;\n    }\n\n    .trade_strengths_bl .nav li button.nav-link {\n        font-size: 15px;\n        padding: 8px 32px;\n    }\n\n    .coin_options_bl {\n        padding: 0px 20px 30px;\n    }\n\n    .coin_options_bl h3 {\n        font-size: 20px;\n    }\n\n    .coin_icon {\n        width: 80px;\n        padding: 10px;\n        height: 80px;\n        top: -20px;\n        margin-top: -20px;\n    }\n\n    .social_btn img {\n        width: 30px;\n    }\n\n    .option_highlight_section {\n        padding: 30px 0px 70px;\n    }\n\n    .social_btn img {\n        width: 20px;\n    }\n\n    .social_btn a {\n        padding: 7px 12px;\n        gap: 10px;\n    }\n\n    .social_btn a .btn_cnt {\n        font-size: 15px;\n        line-height: 20px;\n    }\n\n    .social_btn a .btn_cnt span {\n        font-size: 10px;\n    }\n\n    .why_trade_option.trade_anywhere_s {\n        padding: 40px 0px;\n    }\n\n    .market_highlight_section .nav li button.nav-link {\n        font-size: 12px;\n        padding: 6px 15px;\n    }\n\n    .tradenow_btn button {\n        font-size: 15px;\n    }\n\n    .market_summary table tr td {\n        font-size: 12px;\n    }\n\n    .submitbtn button {\n        font-size: 18px;\n        padding: 15px 10px;\n    }\n\n    .createblock_form .creatblock_left_inquery .nav-tabs li .nav-link {\n        font-size: 18px;\n        padding: 15px 15px;\n    }\n\n    .markert_overview_right h3 {\n        font-size: 20px;\n    }\n\n    .markert_overview_right {\n        padding: 24px;\n    }\n\n    .creatblock_left_inquery .form_input select {\n        font-size: 15px;\n    }\n\n    .creatblock_left_inquery .form_input input {\n        font-size: 15px;\n    }\n\n    .createblock_form {\n        padding: 70px 0px 40px;\n    }\n\n    .trade_summary_table_lft .nav-tabs {\n        gap: 5px;\n        overflow: scroll;\n        white-space: nowrap;\n        flex-wrap: nowrap;\n    }\n\n    .algo_orders_outers .orders_leftside .nav-tabs li .nav-link {\n        padding: 16px 15px;\n    }\n\n    .trade_summary_table_lft {\n        width: 100%;\n    }\n\n    .price_info {\n        padding-bottom: 20px;\n    }\n\n    .assets_right {\n        width: 100%;\n    }\n\n    footer .menu li a {\n        font-size: 14px;\n    }\n\n    .h1,\n    h1 {\n        font-size: 30px;\n    }\n\n    .orders_leftside h2 {\n        font-size: 24px;\n    }\n\n    .options_section ul li button {\n        font-size: 15px;\n        border-radius: 10px;\n    }\n\n    .strategies_cate ul {\n        white-space: nowrap;\n        overflow: auto;\n    }\n\n    .request_quote_btn button {\n        font-size: 18px;\n        padding: 15px 0px 20px;\n    }\n\n    .placebtn button {\n        padding: 18px 20px;\n        font-size: 18px;\n    }\n\n    .algo_detail_summary_left h5 {\n        font-size: 16px;\n    }\n\n    .portal_chat_top ul {\n        white-space: nowrap;\n        flex-wrap: nowrap;\n        overflow: scroll;\n    }\n\n\n    .top_future_right_s {\n        overflow: auto;\n        width: 35%;\n        white-space: nowrap;\n    }\n\n    .top_bar_usd_future {\n        align-items: end;\n    }\n\n    .trade_summary_table_lft.esay_option_table .nav-tabs {\n        flex-wrap: nowrap;\n        overflow: auto;\n        white-space: nowrap;\n    }\n\n    .classic_usd_right ul {\n        overflow: scroll;\n        gap: 20px;\n    }\n\n    .classic_option_top {\n        overflow: hidden;\n    }\n\n    .hero_section_option {\n        background-size: 600px;\n        min-height: 480px;\n    }\n\n    .heading2 {\n        font-size: 30px;\n    }\n\n    .price_info .price_inputbl {\n        padding-bottom: 15px;\n    }\n\n    .trade_movers_tb ul.nav-tabs {\n        white-space: nowrap;\n        flex-wrap: nowrap;\n        overflow: auto;\n    }\n\n}\n\n\n.mobile_data_table .desktop_view {\n    display: none;\n}\n\nspan.arrowmobile {\n    display: none;\n}\n\n.mobileview .rightdata_s {\n    display: none;\n}\n\n@media screen and (max-width:991px) {\n\n\n    .rightdata_s.mobileview.active {\n        display: block;\n        margin-bottom: 20px;\n    }\n\n    .rightdata_s {\n        display: none;\n    }\n\n    .desktop_view {\n        padding-top: 10px;\n    }\n\n    .selected_product_info {\n        padding: 10px 0px;\n    }\n\n    span.arrowmobile {\n        display: block;\n    }\n\n    .flex_right_option .order_trade_s {\n        width: 40%;\n    }\n\n    .classic_usd_right ul {\n        gap: 10px;\n    }\n\n    .product_name span.arrowmobile svg {\n        width: 12px;\n        height: 13px;\n    }\n\n\n    .mobile_data_table .desktop_view {\n        display: block;\n    }\n\n    button.mobilebtn {\n        display: block;\n        border: none;\n        border-radius: 50px;\n        padding: 5px 12px;\n    }\n\n    .dashboard_mid_s.space_gap_0 .order_trade_s {\n        padding-top: 0px;\n    }\n\n    .market_spot_form .price_inputbl.mt-2 {\n        padding-bottom: 20px !important;\n    }\n\n    .data_option_calls.mobile_data_table.active {\n        display: block;\n    }\n\n    .data_option_calls.mobile_data_table {\n        display: block;\n    }\n\n    .data_option_calls {\n        display: none;\n    }\n\n\n\n    .option_datatable_bl .row .col-sm-5 {\n        width: 100%;\n        padding: 0px 5px;\n    }\n\n    .option_datatable_bl .row.classic_favorites_bl {\n        flex-direction: row;\n        padding-top: 0px;\n    }\n\n    .option_datatable_bl .order_trade_s {\n        padding-top: 0px;\n    }\n\n    .option_datatable_bl .price_info .price_inputbl {\n        padding-bottom: 0px;\n    }\n\n    .option_datatable_bl .row .col-sm-7 {\n        margin-bottom: 10px;\n        width: 100%;\n    }\n\n    .datatable {\n        display: flex;\n        flex-direction: column;\n        /* gap: 40px; */\n        align-items: center;\n        justify-content: space-around;\n        min-height: 120px;\n    }\n\n    .datatable div {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .data_put {\n        display: flex;\n        flex-direction: column;\n        gap: 40px;\n    }\n\n    .mobile_data_table .top_table_data {\n        display: flex;\n        flex-direction: row-reverse;\n    }\n\n    .hero_section_option {\n        background-size: 480px;\n        min-height: 400px;\n    }\n\n    .space_gap_0.dashboard_mid_s .dashboard_summary_lft {\n        width: 100%;\n    }\n\n    .market_highlight_section .nav li button.nav-link {\n        padding: 6px 25px;\n    }\n\n    .market_highlight_section .mt-5 {\n        margin-top: 24px !important;\n    }\n\n    .hero_section_option h1 {\n        font-size: 30px;\n    }\n\n    .hero_section_option p {\n        font-size: 14px;\n    }\n\n    .market_highlight_section {\n        padding: 0px 0px 40px;\n    }\n\n    .options_btn button {\n        padding: 8px 20px;\n        font-size: 13px;\n    }\n\n    .options_btn {\n        gap: 10px;\n    }\n\n    .hero_section_option ul {\n        gap: 10px;\n        margin-top: 10px;\n        width: 80%;\n    }\n\n    .heading2 {\n        font-size: 24px;\n    }\n\n    .trade_strengths_bl .nav {\n        gap: 15px;\n    }\n\n    .coin_options_bl::before {\n        width: 100px;\n        height: 100px;\n        top: -20px;\n    }\n\n    .coin_options_bl h3 {\n        font-size: 20px;\n    }\n\n    .coin_icon {\n        width: 70px;\n        height: 70px;\n        padding: 10px;\n        top: -20px;\n        margin-top: -10px;\n    }\n\n    .option_highlight_section .row {\n        row-gap: 24px;\n    }\n\n    .option_highlight_section .row .col-sm-3 {\n        width: 50%;\n    }\n\n    .hero_section_option ul li {\n        width: 48%;\n    }\n\n    .futures_options_s table thead th h4 {\n        font-size: 18px;\n    }\n\n    .futures_options_s table thead th {\n        font-size: 13px;\n    }\n\n    .futures_options_s table tbody td {\n        font-size: 13px;\n    }\n\n    .trade_strengths_bl::before {\n        width: 130px;\n        height: 1000px;\n        top: -60%;\n    }\n\n    .why_trade_option {\n        padding: 0px 0px 30px;\n    }\n\n    .why_trade_option .tab-content .row {\n        padding-top: 20px;\n    }\n\n    .option_block_process {\n        border-radius: 24px;\n        padding: 24px;\n        margin-top: 24px;\n    }\n\n    .markert_overview_right ul li {\n        font-size: 15px;\n    }\n\n    .row.classic_favorites_bl {\n        flex-direction: column;\n    }\n\n    .row.classic_favorites_bl .col-sm-9 {\n        width: 100%;\n    }\n\n    .row.classic_favorites_bl .col-sm-3 {\n        width: 100%;\n    }\n\n    .recent_tables_outer {\n        flex-direction: column;\n    }\n\n    .dashboard_mid_s {\n        flex-direction: column;\n    }\n\n    .algo_detail_summary .row {\n        flex-direction: column;\n    }\n\n    .algo_detail_summary .row .col-sm-4 {\n        width: 100%;\n    }\n\n    .algo_detail_summary .row .col-sm-8 {\n        width: 100%;\n    }\n\n    .topbar_order {\n        align-items: start;\n        flex-direction: column;\n        gap: 15px;\n    }\n\n    .portal_chat_top ul {\n        justify-content: center;\n    }\n\n    .algo_order_right {\n        margin-top: 30px;\n    }\n\n    .algo_orders_outers .nav-tabs {\n        width: 100%;\n    }\n\n    .portal_chat_top {\n        width: 100%;\n    }\n\n    .order_trade_s {\n        width: 100%;\n        padding-top: 20px;\n    }\n\n    .relative_select_right {\n        width: 100%;\n        padding-top: 15px;\n    }\n\n    .table_info_data table tr .subtotal {\n        text-align: left;\n    }\n\n    .trade_account_summary_assets {\n        flex-direction: column;\n        margin-top: 0px;\n    }\n\n    .trade_summary_table_lft {\n        width: 100%;\n    }\n\n    .assets_right {\n        width: 100%;\n    }\n\n    .market_spot_form {\n        padding-bottom: 24px;\n    }\n\n    .bs_dropbox small {\n        margin-bottom: 8px;\n        display: block;\n    }\n\n    .dashboard_mid_s.space_gap_0.pa_2 .market_spot_form {\n        padding-bottom: 0px;\n    }\n\n    .trade_summary_table_lft .tab-content {\n        min-height: 100px;\n    }\n\n    .prediction_detail ul.nav-tabs {\n        margin-top: 18px;\n        gap: 12px;\n    }\n\n    .no_wrap_s {\n        width: 100%;\n        overflow: auto;\n    }\n\n    .no_wrap_s ul {\n        white-space: nowrap;\n        flex-wrap: nowrap;\n        width: 100%;\n        margin: 0px !important;\n    }\n\n    .tradenow_btn button {\n        font-size: 14px;\n        white-space: nowrap;\n    }\n\n    .top_table_data .mid_data {\n        display: none;\n    }\n\n    .mobile_data_table .scroll_y {\n        overflow-x: auto;\n        height: 100% !important;\n        width: 100%;\n    }\n\n    .top_table_data .mid_data.mobile_view {\n        display: flex;\n    }\n\n    .top_table_data .lefside_data {\n        display: flex;\n        flex-direction: row;\n        flex-wrap: nowrap;\n    }\n\n    .mobile_data_table .top_table_data .table-responsive {\n        min-height: 100%;\n        max-height: 580px;\n    }\n\n    .datatable div span {\n        font-size: 10px;\n    }\n\n    .data_option_calls table tr td {\n        font-size: 12px;\n        color: #d3d3d3;\n    }\n\n    .data_option_calls table tr td div span {\n        color: #aaaaaa;\n    }\n\n    .flex_right_option {\n        gap: 5px;\n    }\n\n    .market_spot_form .buysell_btn button {\n        padding: 7px 14px;\n    }\n\n    /* button.btn.btn-danger.btn-block.w-100 {\n            font-size: 12px;\n        } */\n\n    .order_datalist .listdata {\n        padding-bottom: 18px;\n    }\n\n    .usd_left_pr {\n        gap: 15px;\n        flex-direction: column;\n    }\n\n    body .top_future_right_s {\n        display: none;\n    }\n\n    body .top_future_left_s {\n        width: 100%;\n    }\n\n    body .price_top_right {\n        width: 100%;\n        font-size: 20px;\n    }\n\n    .top_future_left_s ul {\n        padding: 0px;\n        margin: 0px;\n        list-style: none;\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        gap: 5px;\n        align-items: flex-start !important;\n    }\n\n    body .top_future_left_s ul li:nth-child(3) {\n        min-width: auto;\n    }\n\n    body .top_future_left_s ul li:nth-child(4) {\n        min-width: auto;\n    }\n\n    body .top_future_left_s ul li:nth-child(5) {\n        min-width: auto;\n    }\n\n\n}\n\n\n@media screen and (max-width:767px) {\n\n    .modal.currency_popup_s.crosstabs .modal-content {\n        border-radius: 0px;\n    }\n\n    ul.future_mobileview_tabs {\n        display: flex;\n        border-bottom: 1px solid #585858;\n    }\n\n    .position_order .position_list {\n        overflow: auto;\n        -webkit-overflow-scrolling: touch;\n        /* Hide scrollbar by default on mobile */\n        scrollbar-width: none;\n        -ms-overflow-style: none;\n    }\n\n    .position_order .position_list li button {\n        font-size: 14px;\n    }\n\n    .trade_account_summary_assets {\n        margin-top: 0px;\n    }\n\n    .position_order .position_list::-webkit-scrollbar {\n        height: 6px;\n        display: none;\n    }\n\n    /* Show scrollbar only when user scrolls or hovers */\n    .position_order .position_list.show-scrollbar::-webkit-scrollbar {\n        display: block;\n    }\n\n    .position_order .position_list.show-scrollbar {\n        scrollbar-width: thin;\n        scrollbar-color: rgba(255, 255, 255, 0.4) transparent;\n    }\n\n    .position_order .position_list.show-scrollbar::-webkit-scrollbar-track {\n        background: transparent;\n        border-radius: 10px;\n    }\n\n    .position_order .position_list.show-scrollbar::-webkit-scrollbar-thumb {\n        background-color: rgb(255 255 255 / 20%);\n        border-radius: 10px;\n    }\n\n    .position_order .position_list.show-scrollbar::-webkit-scrollbar-thumb:hover {\n        background-color: rgb(255 255 255 / 20%);\n    }\n\n    body .top_future_left_s ul li span {\n        font-size: 9px;\n    }\n\n    .hero_img_mobile {\n        display: block;\n        max-width: 300px;\n        margin: 0 auto;\n    }\n\n    .classic_grid_dashboard_bl.d-flex.option_datatable_bl .d-flex.topnav_selected {\n        padding: 10px 0px 2px;\n        margin-bottom: 12px;\n    }\n\n    .rightdata_s.mobileview.active {\n        margin-bottom: 5px;\n        padding: 0px;\n    }\n\n    .classic_usd_right ul {\n        padding-bottom: 6px;\n    }\n\n    .modal.currency_popup_s.crosstabs .modal-body {\n        padding: 0px 18px 18px;\n    }\n\n    button.mobilebtn {\n        margin: 8px 0px 10px;\n    }\n\n    .datatable {\n        min-height: 100px;\n    }\n\n    .top_table_data .mid_data tr td {\n        height: 117px;\n        display: flex;\n        align-items: center;\n    }\n\n    .top_table_data .mid_data tr {\n        display: block;\n    }\n\n    .option_datatable_bl .top_table_data .mid_data.mobile_view {\n        padding: 0px;\n    }\n\n    .option_datatable_bl .classic_favorites_bl .col-sm-2 .relative_select_right {\n        padding: 10px;\n    }\n\n    .option_datatable_bl .classic_favorites_bl .tab-content>.tab-pane {\n        padding-right: 0px;\n    }\n\n    .d-flex.topnav_selected {\n        overflow: auto;\n        padding: 0px;\n        align-items: start;\n    }\n\n    .d-flex.align-items-center.justify-content-between.buy_transferbtn {\n        margin-bottom: 10px;\n    }\n\n    .tradenow_btn button {\n        padding: 7px 20px;\n    }\n\n    .options_btn {\n        justify-content: center;\n    }\n\n    .learn_btn {\n        display: flex;\n        justify-content: center;\n    }\n\n    .hero_section_option h1 br {\n        display: none;\n    }\n\n    .option_highlight_section::before {\n        display: none;\n    }\n\n    .buysell_btn button {\n        padding: 7px 24px;\n        font-size: 13px;\n    }\n\n    .why_trade_option .row {\n        gap: 30px;\n        flex-direction: column;\n    }\n\n    .why_trade_option .row .col-sm-6 {\n        width: 100%;\n    }\n\n    .why_trade_option .row .col-sm-4 {\n        width: 100%;\n    }\n\n    .hero_section_option .col-sm-8 {\n        width: 100%;\n    }\n\n    .hero_section_option ul {\n        width: 100%;\n    }\n\n    .hero_section_option {\n        background-image: none;\n    }\n\n    .option_block_process ul {\n        gap: 24px;\n        flex-direction: column;\n    }\n\n    .createblock_form {\n        padding: 40px 0px 20px;\n    }\n\n    .createblock_form .nav-tabs li .nav-link {\n        font-size: 14px;\n    }\n\n    .option_block_process ul li h2 {\n        font-size: 18px;\n    }\n\n    .algo_detail_summary p {\n        margin-bottom: 0px;\n    }\n\n    .option_block_outer h1 {\n        font-size: 24px;\n    }\n\n    .top_table_data .right_data {\n        display: flex;\n    }\n\n    h5.mobile {\n        display: block;\n    }\n\n    .top_table_data {\n        max-height: 100%;\n    }\n\n    .top_table_data .mid_data {\n        min-width: 60px;\n        padding: 15px 0px;\n    }\n\n    .recent_tables_outer {\n        flex-direction: column;\n        gap: 24px;\n    }\n\n    .recent_tables_outer .tables_calls .table-responsive,\n    .recent_tables_outer .tables_puts .table-responsive {\n        min-height: 250px;\n        max-height: 250px;\n    }\n\n    .recent_trades_options table tr th {\n        white-space: nowrap;\n    }\n\n    .top_table_data {\n        flex-direction: column;\n    }\n\n    .top_barcalls_put_cnt ul {\n        gap: 20px;\n        padding: 10px 20px;\n    }\n\n    .container,\n    .container-sm {\n        max-width: 100%;\n    }\n\n    .hero_section_option {\n        background-image: none;\n        padding: 30px 0px;\n        text-align: center;\n    }\n\n    .hero_section_option ul li h4 {\n        font-size: 13px;\n    }\n\n    .options_btn button {\n        padding: 6px 20px;\n        font-size: 12px;\n        line-height: 110%;\n    }\n\n    .hero_section_option h1 {\n        font-size: 24px;\n    }\n\n    .heading2 {\n        font-size: 22px;\n    }\n\n    .market_highlight_section .mt-5 {\n        margin-top: 20px !important;\n    }\n\n    .market_highlight_section .d-flex.justify-content-between.align-items-center.mt-5 {\n        flex-direction: column;\n        gap: 20px;\n    }\n\n    .option_highlight_section p {\n        margin: 10px 0px 0px;\n    }\n\n    .market_highlight_section .table-responsive {\n        max-height: 290px;\n    }\n\n    .market_highlight_section {\n        padding-bottom: 0px;\n    }\n\n    .market_summary table {\n        margin-top: 0px;\n    }\n\n    .market_highlight_section .nav {\n        gap: 12px;\n    }\n\n    .market_summary h4 {\n        font-size: 16px;\n    }\n\n    .market_summary {\n        padding: 20px 15px;\n    }\n\n    .slick-track {\n        gap: 0px;\n    }\n\n    .market_summary table tr th {\n        white-space: nowrap;\n        font-size: 12px;\n    }\n\n    .hero_section_option p {\n        font-size: 13px;\n        max-width: 100%;\n    }\n\n    .option_highlight_section p {\n        font-size: 13px;\n    }\n\n    .why_trade_option p {\n        font-size: 13px;\n        padding-top: 4px;\n    }\n\n    .trade_strengths_bl::before {\n        display: none;\n    }\n\n    .why_trade_option {\n        text-align: center;\n    }\n\n    .learn_btn button {\n        padding: 6px 28px;\n        font-size: 13px;\n    }\n\n    .learn_btn button img {\n        width: 11px;\n    }\n\n    .futures_options_s {\n        overflow: scroll;\n    }\n\n    .futures_options_s table {\n        margin-top: 0px;\n    }\n\n    .why_trade_options {\n        max-width: 280px;\n        float: none;\n        margin: 0 auto;\n        padding: 5px 0px 20px;\n    }\n\n    .trade_strengths_bl .nav li button.nav-link {\n        font-size: 13px;\n        padding: 6px 24px;\n    }\n\n    .trade_strengths_bl .nav {\n        gap: 10px;\n        justify-content: center;\n        margin: 15px 0px;\n    }\n\n    .trade_strengths_bl .tab-content {\n        margin-top: 35px;\n    }\n\n    .coin_options_bl {\n        padding: 0px 20px 10px;\n        margin-bottom: 24px;\n    }\n\n    .why_trade_option.trade_anywhere_s {\n        padding: 0px 0px 20px;\n    }\n\n    .social_button {\n        gap: 10px;\n        margin-top: 10px;\n        justify-content: center;\n    }\n\n    .social_btn a {\n        padding: 4px 12px;\n        gap: 7px;\n        text-align: left;\n    }\n\n    .social_btn a .btn_cnt {\n        font-size: 13px;\n        line-height: 16px;\n    }\n\n    .social_btn a .btn_cnt span {\n        font-size: 9px;\n    }\n\n    .social_btn img {\n        width: 16px;\n    }\n\n    .start_trading_options {\n        margin: 10px 0px;\n    }\n\n    .start_trading_options .tradenow_btn button {\n        padding: 7px 20px;\n        font-size: 13px;\n    }\n\n    .option_highlight_section .row {\n        flex-direction: column;\n    }\n\n    .option_highlight_section {\n        padding: 30px 0px 30px;\n        text-align: center;\n    }\n\n    .option_highlight_section .row .col-sm-3 {\n        width: 100%;\n    }\n\n    .d-flex.topnav_selected {\n        flex-direction: column;\n    }\n\n    .topnav_selected .nav-tabs {\n        width: 100%;\n    }\n\n    .right_top_r {\n        padding: 0px 13px;\n        width: 100%;\n    }\n\n    .orderbook_lightbox {\n        right: inherit;\n        padding: 18px;\n    }\n\n    .data_option_calls table tr th {\n        white-space: nowrap;\n        padding: 10px 15px;\n    }\n\n    .recent_trades_options table tr td {\n        padding: 10px 15px;\n        font-size: 12px;\n    }\n\n    .portal_chat_top {\n        padding: 0px 20px;\n    }\n\n    .top_barcalls_put_cnt ul {\n        white-space: nowrap;\n        overflow: scroll;\n        justify-content: space-around;\n    }\n\n    .h1,\n    h1 {\n        font-size: 24px;\n    }\n\n    h2 {\n        font-size: 20px;\n    }\n\n    .orders_leftside h2 {\n        font-size: 20px;\n    }\n\n    .algo_orders_outers .orders_leftside .nav-tabs li .nav-link {\n        padding: 11px 12px;\n        font-size: 14px;\n    }\n\n    .morebtn_right button {\n        padding: 6px 16px;\n    }\n\n    .algo_detail_summary_left h5 {\n        font-size: 14px;\n    }\n\n    .options_section ul {\n        gap: 15px;\n        margin-top: 15px;\n        overflow: scroll;\n    }\n\n    .strategies_form {\n        font-size: 18px;\n        padding: 24px;\n        width: 100%;\n    }\n\n    .placebtn button {\n        padding: 12px 20px;\n        font-size: 16px;\n    }\n\n    .algo_orders_outers .nav-tabs li .nav-link {\n        font-size: 14px;\n    }\n\n    .portal_chat_top ul li a {\n        font-size: 14px;\n    }\n\n    .section_trading .dropdown-toggle {\n        padding: 7px 14px;\n        font-size: 15px;\n    }\n\n    .section_trading .price {\n        font-size: 18px;\n    }\n\n    .options_section ul li button {\n        font-size: 14px;\n    }\n\n    .d-flex.justify_currency {\n        font-size: 15px;\n    }\n\n    .request_quote_btn button {\n        font-size: 15px;\n        padding: 13px 0px 13px;\n    }\n\n    .refresh_cntr {\n        width: 42px;\n    }\n\n    .total_balance {\n        font-size: 14px;\n    }\n\n    span.green {\n        font-size: 15px;\n    }\n\n    .d-flex.top_bar_hd h4 {\n        font-size: 20px;\n    }\n\n    .submitbtn {\n        font-size: 15px;\n        padding: 8px 15px;\n    }\n\n    .trade_summary_table_lft.esay_option_table h2 {\n        margin: 15px 0px;\n    }\n\n    .portal_chat_top ul {\n        justify-content: start;\n    }\n\n    .portal_chat_top ul li {\n        font-size: 13px;\n    }\n\n    .row.prediction_row {\n        flex-direction: column;\n        gap: 24px;\n    }\n\n    .prediction_detail {\n        min-height: 100%;\n    }\n\n    .prediction_detail ul {\n        gap: 32px;\n        margin-top: 30px;\n    }\n\n    .fill_cnt {\n        padding: 20px 0px 0px;\n    }\n\n    .row.prediction_row .col-sm-4 {\n        width: 100%;\n    }\n\n    .prediction_top_s {\n        padding: 20px 0px;\n    }\n\n    .buy_sell_option {\n        padding: 30px 0px 40px;\n    }\n\n    .buy_sell_option .row {\n        flex-direction: column;\n        gap: 24px;\n    }\n\n    .buy_sell_option .row .col-sm-4 {\n        width: 100%;\n    }\n\n    button.bn-button.button__buy {\n        font-size: 14px;\n        padding: 7px 10px;\n        border-radius: 6px;\n    }\n\n    .search_form .modal-body {\n        padding: 20px !important;\n    }\n\n    .trade_summary_table_lft .tab-content {\n        min-height: 60px;\n    }\n\n    .trade_summary_table_lft .nav-tabs {\n        gap: 5px;\n        white-space: nowrap;\n        flex-wrap: nowrap;\n        overflow: auto;\n    }\n\n    .price_top_right {\n        font-size: 14px;\n    }\n\n    .price_top_right span {\n        font-size: 12px;\n    }\n\n    .prediction_detail ul li img {\n        width: 42px;\n    }\n\n\n    .modal.currency_popup_s.crosstabs .modal-dialog {\n        max-width: 100%;\n        min-width: 100%;\n        margin: 0 auto;\n    }\n\n    body {\n        font-size: 14px;\n    }\n\n    .prediction_detail ul.nav-tabs {\n        flex-wrap: nowrap;\n        white-space: nowrap;\n        overflow: scroll;\n    }\n\n    .buy_sell_option .nav-tabs li button.nav-link {\n        font-size: 14px;\n        padding: 5px 10px;\n    }\n\n    .buy_sell_option .nav-tabs {\n        margin-top: 18px;\n        white-space: nowrap;\n        flex-wrap: nowrap;\n        overflow: scroll;\n    }\n\n    .trade_summary_table_lft tr th {\n        padding: 6px 15px;\n        white-space: nowrap;\n    }\n\n    .account_hd_div {\n        margin-top: 0px;\n    }\n\n    .createblock_form>.tab-content {\n        margin-top: 20px;\n    }\n\n    .createblock_form .creatblock_left_inquery .nav-tabs li .nav-link {\n        font-size: 15px;\n        padding: 12px;\n    }\n\n    .creatblock_left_inquery .tab-content {\n        padding: 24px;\n    }\n\n    .buyform form .row {\n        row-gap: 20px;\n    }\n\n    .creatblock_left_inquery .form_input input {\n        font-size: 14px;\n        padding: 10px 15px;\n    }\n\n    .creatblock_left_inquery .form_input.fullsize select {\n        padding: 10px 15px;\n    }\n\n    .submitbtn button {\n        font-size: 15px;\n        padding: 12px 10px;\n    }\n\n    .createblock_form .row {\n        gap: 24px;\n    }\n\n    .markert_overview_right ul {\n        padding-top: 15px;\n        gap: 15px;\n    }\n\n    .notfound_vector {\n        max-width: 120px;\n        margin: 30px auto;\n    }\n\n    .table_info_data table tr th {\n        font-size: 12px;\n    }\n\n    .table_info_data table tr.totaltb td.danger {\n        font-size: 15px;\n    }\n\n    .trade_movers_tb button.nav-link {\n        font-size: 12px;\n    }\n\n    .top_cross_dashboard ul li a {\n        padding: 6px 12px 6px;\n        font-size: 12px;\n    }\n\n    .top_cross_dashboard ul {\n        gap: 10px;\n    }\n\n    .option_datatable_bl .buy_sell_row_price .scroll_y {\n        height: 225px !important;\n        overflow-x: auto;\n    }\n\n    body .top_future_left_s {\n        overflow: inherit;\n    }\n\n    .future_mobile_tab_content.table_info_data .buy_sell_row {\n        padding: 0px;\n    }\n\n    .market_spot_form .buysell_btn button {\n        padding: 6px 14px;\n        font-size: 12px;\n    }\n\n\n    .modal.currency_popup_s .btn-close {\n        font-size: 8px;\n        padding: 5px;\n    }\n\n}\n\n@media screen and (max-width:660px) {\n\n    .top_bar_usd_future {\n        align-items: normal;\n        flex-direction: column;\n        gap: 15px;\n    }\n\n    body .price_top_right {\n        font-size: 16px;\n    }\n\n    .hero_section_option h1 br {\n        display: none;\n    }\n\n    .price_top_right {\n        font-size: 12px;\n    }\n\n    .hero_section_option p {\n        margin-top: 5px;\n    }\n\n    .hero_section_option ul {\n        align-items: start;\n    }\n\n    .heading2 {\n        font-size: 19px;\n    }\n\n    .heading2 br {\n        display: none;\n    }\n\n    .trade_strengths_bl::before {\n        display: none;\n    }\n\n    .top_future_left_s ul li {\n        font-size: 9px;\n    }\n\n    .trade_option_bl .row {\n        gap: 24px;\n    }\n\n    .createblock_form .nav-tabs li .nav-link {\n        font-size: 13px;\n    }\n\n    .modal.currency_popup_s.crosstabs p {\n        font-size: 12px;\n        line-height: 20px;\n    }\n\n    .btnsupport button {\n        font-size: 12px;\n        padding: 6px 24px;\n    }\n\n    .currency_popup_s h4 {\n        font-size: 18px;\n    }\n\n    .trade_option_bl .row .col-sm-6 {\n        width: 100%;\n    }\n\n    .buy_sell_option h5 {\n        font-size: 18px;\n    }\n\n    .hide_underlying_s {\n        justify-content: start;\n        padding: 10px 10px 0px;\n        margin-bottom: 15px;\n    }\n\n    .top_future_left_s {\n        width: 100%;\n    }\n\n    .top_future_right_s {\n        width: 100%;\n    }\n\n    .trade_summary_table_lft .nav-tabs {\n        gap: 5px;\n    }\n\n    .prediction_up img.prediction_vector {\n        min-height: 120px;\n        width: 150px;\n    }\n\n    .prediction_up {\n        gap: 15px;\n    }\n\n    .buysell_btn button {\n        padding: 4px 18px;\n        font-size: 11px;\n    }\n\n}\n\n\n@media screen and (max-width:480px) {\n\n    .hero_section_option ul li h4 {\n        font-size: 11px;\n    }\n\n    .relative_select_right {\n        padding: 7px 10px !important;\n    }\n\n    .order_trade_s .price_card_head {\n        justify-content: start;\n        gap: 5px !important;\n    }\n\n    .product_header.ms-auto {\n        gap: 5px;\n    }\n\n\n    .product_header button {\n        font-size: 11px;\n        gap: 4px;\n    }\n\n    .product_name {\n        gap: 5px;\n        font-size: 11px;\n    }\n\n    .product_data_info table tr td {\n        font-size: 9px !important;\n    }\n\n    .product_data_info table tr td span {\n        font-size: 10px;\n    }\n\n    .leverage_bl>div {\n        gap: 7px;\n        font-size: 12px;\n        padding: 8px;\n    }\n\n    .hero_section_option p {\n        font-size: 12px;\n    }\n\n    .option_datatable_bl .price_inputbl ul li button {\n        font-size: 9px;\n        padding: 1px 2px !important;\n    }\n\n    .option_datatable_bl .price_info .buysell_btn {\n        flex-direction: row;\n    }\n\n    .costbtc_total h5 {\n        font-size: 11px;\n    }\n\n    .price_inputbl ul {\n        overflow: auto;\n        padding-bottom: 7px;\n    }\n\n    .position_order .position_list {\n        gap: 7px;\n    }\n\n    .trade_movers_tb ul.nav-tabs {\n        gap: 4px;\n    }\n\n    .trade_movers_tb button.nav-link {\n        font-size: 11px;\n        padding: 5px 5px;\n    }\n\n    .coin_options_bl h3 {\n        font-size: 18px;\n    }\n\n    .option_highlight_section p {\n        font-size: 12px;\n    }\n\n    .option_highlight_section .software_trading_cnt p {\n        font-size: 12px;\n    }\n\n    .hero_section_option ul {\n        gap: 5px;\n    }\n\n    .why_trade_option p {\n        font-size: 12px;\n    }\n\n    .futures_options_s table tbody td {\n        font-size: 12px;\n    }\n\n    .why_trade_option p {\n        font-size: 12px;\n        margin-bottom: 10px;\n    }\n\n    .mrkt_trde_tab {\n        font-size: 11px;\n    }\n\n    .price_card_head {\n        overflow: auto;\n        white-space: nowrap;\n    }\n\n    .price_card_head>div {\n        width: auto !important;\n    }\n\n}\n\n\n@media screen and (max-width:360px) {\n\n    .trade_movers_tb button.nav-link {\n        font-size: 10px;\n        padding: 4px 4px;\n    }\n\n    .mrkt_trde_tab {\n        font-size: 10px;\n        overflow: auto;\n    }\n\n}\n\n.data_option_calls table tr.active {\n    border: 1.5px solid #fbe5ac !important;\n}\n\n.relative_select_right .nav-tabs-check .nav-link-check.active#buy-tab {\n    color: #fff !important;\n    background: #01BC8D !important;\n}\n\n.relative_select_right .nav-tabs-check .nav-link-check {\n    /* transform: skewX(-20deg); */\n    text-align: center;\n    padding: 6px 0;\n    border: none !important;\n    background-color: #ffffff0f;\n    border-radius: 2px;\n    font-size: 12px;\n    color: currentColor !important;\n    transition: unset !important;\n    width: 100%;\n    display: block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
